/*!
 * @license
 * TradingView Lightweight Charts v2.0.0
 * Copyright (c) 2019 TradingView, Inc.
 * Licensed under Apache License 2.0 https://www.apache.org/licenses/LICENSE-2.0
 */
import { bindToDevicePixelRatio as t } from "fancy-canvas/coordinate-space";
var i, n;
function s(t, i) {
  var n,
    s = ((n = {})[0] = [], n[1] = [t.lineWidth, t.lineWidth], n[2] = [2 * t.lineWidth, 2 * t.lineWidth], n[3] = [6 * t.lineWidth, 6 * t.lineWidth], n[4] = [t.lineWidth, 4 * t.lineWidth], n)[i];
  t.setLineDash(s);
}
function h(t, i, n, s) {
  t.beginPath();
  var h = t.lineWidth % 2 ? .5 : 0;
  t.moveTo(n, i + h), t.lineTo(s, i + h), t.stroke();
}
!function (t) {
  t[t.Simple = 0] = "Simple", t[t.WithSteps = 1] = "WithSteps";
}(i || (i = {})), function (t) {
  t[t.Solid = 0] = "Solid", t[t.Dotted = 1] = "Dotted", t[t.Dashed = 2] = "Dashed", t[t.LargeDashed = 3] = "LargeDashed", t[t.SparseDotted = 4] = "SparseDotted";
}(n || (n = {}));
var _r = function r(t, i) {
  return (_r = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (t, i) {
    t.__proto__ = i;
  } || function (t, i) {
    for (var n in i) i.hasOwnProperty(n) && (t[n] = i[n]);
  })(t, i);
};
function u(t, i) {
  function n() {
    this.constructor = t;
  }
  _r(t, i), t.prototype = null === i ? Object.create(i) : (n.prototype = i.prototype, new n());
}
var _e = function e() {
  return (_e = Object.assign || function (t) {
    for (var i, n = 1, s = arguments.length; n < s; n++) for (var h in i = arguments[n]) Object.prototype.hasOwnProperty.call(i, h) && (t[h] = i[h]);
    return t;
  }).apply(this, arguments);
};
function o() {
  for (var t = 0, i = 0, n = arguments.length; i < n; i++) t += arguments[i].length;
  var s = Array(t),
    h = 0;
  for (i = 0; i < n; i++) for (var r = arguments[i], u = 0, e = r.length; u < e; u++, h++) s[h] = r[u];
  return s;
}
function f(t, i) {
  if (!t) throw new Error("Assertion failed" + (i ? ": " + i : ""));
}
function a(t) {
  if (void 0 === t) throw new Error("Value is undefined");
  return t;
}
function c(t) {
  if (null === t) throw new Error("Value is null");
  return t;
}
function l(t) {
  return c(a(t));
}
function v(t) {
  for (var i = [], n = 1; n < arguments.length; n++) i[n - 1] = arguments[n];
  for (var s = 0, h = i; s < h.length; s++) {
    var r = h[s];
    for (var u in r) void 0 !== r[u] && ("object" != typeof r[u] || void 0 === t[u] ? t[u] = r[u] : v(t[u], r[u]));
  }
  return t;
}
function d(t) {
  return "number" == typeof t && isFinite(t);
}
function M(t) {
  return "number" == typeof t && t % 1 == 0;
}
function w(t) {
  return "string" == typeof t;
}
function b(t) {
  return !(t <= 0 || t > 0);
}
function m(t) {
  return "boolean" == typeof t;
}
function p(t) {
  var i,
    n,
    s,
    h = t;
  if (!h || "object" != typeof h) return h;
  for (n in i = Array.isArray(h) ? [] : {}, h) h.hasOwnProperty(n) && (s = h[n], i[n] = s && "object" == typeof s ? p(s) : s);
  return i;
}
function g(t) {
  return null !== t;
}
function y(t) {
  return null === t ? void 0 : t;
}
var k = function () {
    function t() {
      this.t = [];
    }
    return t.prototype.setRenderers = function (t) {
      this.t = t;
    }, t.prototype.draw = function (t, i, n, s) {
      this.t.forEach(function (h) {
        t.save(), h.draw(t, i, n, s), t.restore();
      });
    }, t;
  }(),
  N = function () {
    function t() {}
    return t.prototype.draw = function (t, i, n, s) {
      t.save(), t.scale(i, i), this._drawImpl(t, n, s), t.restore();
    }, t.prototype.drawBackground = function (t, i, n, s) {
      t.save(), t.scale(i, i), this._drawBackgroundImpl(t, n, s), t.restore();
    }, t.prototype._drawBackgroundImpl = function (t, i, n) {}, t;
  }(),
  S = function (t) {
    function i() {
      var i = null !== t && t.apply(this, arguments) || this;
      return i._data = null, i;
    }
    return u(i, t), i.prototype.setData = function (t) {
      this._data = t;
    }, i.prototype._drawImpl = function (t) {
      if (null !== this._data && null !== this._data.visibleRange) {
        var i = this._data.visibleRange,
          n = this._data,
          s = function s(_s) {
            t.beginPath();
            for (var h = i.to - 1; h >= i.from; --h) {
              var r = n.items[h];
              t.moveTo(r.x, r.y), t.arc(r.x, r.y, _s, 0, 2 * Math.PI);
            }
            t.fill();
          };
        t.fillStyle = n.backColor, s(n.radius + 2), t.fillStyle = n.lineColor, s(n.radius);
      }
    }, i;
  }(N);
var x,
  D,
  C,
  T,
  E = {
    from: 0,
    to: 1
  },
  L = function () {
    function t(t, i) {
      this.i = new k(), this.s = [], this.u = [], this.o = !0, this.l = t, this.v = i, this.i.setRenderers(this.s);
    }
    return t.prototype.update = function (t) {
      var i = this,
        n = this.l.serieses();
      n.length !== this.s.length && (this.u = n.map(function () {
        return {
          items: [{
            x: 0,
            y: 0,
            time: 0,
            price: 0
          }],
          lineColor: "",
          backColor: i.l.options().layout.backgroundColor,
          radius: 0,
          visibleRange: null
        };
      }), this.s = this.u.map(function (t) {
        var i = new S();
        return i.setData(t), i;
      }), this.i.setRenderers(this.s)), this.o = !0;
    }, t.prototype.renderer = function (t, i, n) {
      return this.o && (this.M(), this.o = !1), this.i;
    }, t.prototype.M = function () {
      var t = this,
        i = this.l.serieses(),
        n = this.v.appliedIndex(),
        s = this.l.timeScale();
      i.forEach(function (i, h) {
        var r = t.u[h],
          u = i.markerDataAtIndex(n);
        if (null !== u) {
          var e = c(i.firstValue());
          r.lineColor = i.barColorer().barStyle(n).barColor, r.backColor = t.l.options().layout.backgroundColor, r.radius = u.radius, r.items[0].price = u.price, r.items[0].y = i.priceScale().priceToCoordinate(u.price, e.value), r.items[0].time = n, r.items[0].x = s.indexToCoordinate(n), r.visibleRange = E;
        } else r.visibleRange = null;
      });
    }, t;
  }(),
  A = function () {
    function t(t) {
      this.m = t;
    }
    return t.prototype.draw = function (t, i, n, r) {
      if (null !== this.m) {
        var u = this.m.vertLine.visible,
          e = this.m.horzLine.visible;
        if (u || e) {
          t.save();
          var o = Math.round(this.m.x * i),
            f = Math.round(this.m.y * i),
            a = Math.ceil(this.m.w * i),
            c = Math.ceil(this.m.h * i);
          t.lineCap = "butt", u && o >= 0 && (t.lineWidth = Math.floor(this.m.vertLine.lineWidth * i), t.strokeStyle = this.m.vertLine.color, t.fillStyle = this.m.vertLine.color, s(t, this.m.vertLine.lineStyle), function (t, i, n, s) {
            t.beginPath();
            var h = t.lineWidth % 2 ? .5 : 0;
            t.moveTo(i + h, n), t.lineTo(i + h, s), t.stroke();
          }(t, o, 0, c)), e && f >= 0 && (t.lineWidth = Math.floor(this.m.horzLine.lineWidth * i), t.strokeStyle = this.m.horzLine.color, t.fillStyle = this.m.horzLine.color, s(t, this.m.horzLine.lineStyle), h(t, f, 0, a)), t.restore();
        }
      }
    }, t;
  }(),
  B = function () {
    function t(t) {
      this.o = !0, this.p = {
        vertLine: {
          lineWidth: 1,
          lineStyle: 0,
          color: "",
          visible: !1
        },
        horzLine: {
          lineWidth: 1,
          lineStyle: 0,
          color: "",
          visible: !1
        },
        w: 0,
        h: 0,
        x: 0,
        y: 0
      }, this.g = new A(this.p), this.k = t;
    }
    return t.prototype.update = function () {
      this.o = !0;
    }, t.prototype.renderer = function (t, i) {
      return this.o && this.M(), this.g;
    }, t.prototype.M = function () {
      var t = this.k.visible(),
        i = c(this.k.pane()),
        n = i.model().options().crosshair,
        s = this.p;
      s.horzLine.visible = t && this.k.horzLineVisible(i), s.vertLine.visible = t && this.k.vertLineVisible(), s.horzLine.lineWidth = n.horzLine.width, s.horzLine.lineStyle = n.horzLine.style, s.horzLine.color = n.horzLine.color, s.vertLine.lineWidth = n.vertLine.width, s.vertLine.lineStyle = n.vertLine.style, s.vertLine.color = n.vertLine.color, s.w = i.width(), s.h = i.height(), s.x = this.k.appliedX(), s.y = this.k.appliedY();
    }, t;
  }(),
  z = {
    aliceblue: "#f0f8ff",
    antiquewhite: "#faebd7",
    aqua: "#00ffff",
    aquamarine: "#7fffd4",
    azure: "#f0ffff",
    beige: "#f5f5dc",
    bisque: "#ffe4c4",
    black: "#000000",
    blanchedalmond: "#ffebcd",
    blue: "#0000ff",
    blueviolet: "#8a2be2",
    brown: "#a52a2a",
    burlywood: "#deb887",
    cadetblue: "#5f9ea0",
    chartreuse: "#7fff00",
    chocolate: "#d2691e",
    coral: "#ff7f50",
    cornflowerblue: "#6495ed",
    cornsilk: "#fff8dc",
    crimson: "#dc143c",
    cyan: "#00ffff",
    darkblue: "#00008b",
    darkcyan: "#008b8b",
    darkgoldenrod: "#b8860b",
    darkgray: "#a9a9a9",
    darkgreen: "#006400",
    darkkhaki: "#bdb76b",
    darkmagenta: "#8b008b",
    darkolivegreen: "#556b2f",
    darkorange: "#ff8c00",
    darkorchid: "#9932cc",
    darkred: "#8b0000",
    darksalmon: "#e9967a",
    darkseagreen: "#8fbc8f",
    darkslateblue: "#483d8b",
    darkslategray: "#2f4f4f",
    darkturquoise: "#00ced1",
    darkviolet: "#9400d3",
    deeppink: "#ff1493",
    deepskyblue: "#00bfff",
    dimgray: "#696969",
    dodgerblue: "#1e90ff",
    feldspar: "#d19275",
    firebrick: "#b22222",
    floralwhite: "#fffaf0",
    forestgreen: "#228b22",
    fuchsia: "#ff00ff",
    gainsboro: "#dcdcdc",
    ghostwhite: "#f8f8ff",
    gold: "#ffd700",
    goldenrod: "#daa520",
    gray: "#808080",
    green: "#008000",
    greenyellow: "#adff2f",
    honeydew: "#f0fff0",
    hotpink: "#ff69b4",
    indianred: "#cd5c5c",
    indigo: "#4b0082",
    ivory: "#fffff0",
    khaki: "#f0e68c",
    lavender: "#e6e6fa",
    lavenderblush: "#fff0f5",
    lawngreen: "#7cfc00",
    lemonchiffon: "#fffacd",
    lightblue: "#add8e6",
    lightcoral: "#f08080",
    lightcyan: "#e0ffff",
    lightgoldenrodyellow: "#fafad2",
    lightgreen: "#90ee90",
    lightgrey: "#d3d3d3",
    lightpink: "#ffb6c1",
    lightsalmon: "#ffa07a",
    lightseagreen: "#20b2aa",
    lightskyblue: "#87cefa",
    lightslateblue: "#8470ff",
    lightslategray: "#778899",
    lightsteelblue: "#b0c4de",
    lightyellow: "#ffffe0",
    lime: "#00ff00",
    limegreen: "#32cd32",
    linen: "#faf0e6",
    magenta: "#ff00ff",
    maroon: "#800000",
    mediumaquamarine: "#66cdaa",
    mediumblue: "#0000cd",
    mediumorchid: "#ba55d3",
    mediumpurple: "#9370d8",
    mediumseagreen: "#3cb371",
    mediumslateblue: "#7b68ee",
    mediumspringgreen: "#00fa9a",
    mediumturquoise: "#48d1cc",
    mediumvioletred: "#c71585",
    midnightblue: "#191970",
    mintcream: "#f5fffa",
    mistyrose: "#ffe4e1",
    moccasin: "#ffe4b5",
    navajowhite: "#ffdead",
    navy: "#000080",
    oldlace: "#fdf5e6",
    olive: "#808000",
    olivedrab: "#6b8e23",
    orange: "#ffa500",
    orangered: "#ff4500",
    orchid: "#da70d6",
    palegoldenrod: "#eee8aa",
    palegreen: "#98fb98",
    paleturquoise: "#afeeee",
    palevioletred: "#d87093",
    papayawhip: "#ffefd5",
    peachpuff: "#ffdab9",
    peru: "#cd853f",
    pink: "#ffc0cb",
    plum: "#dda0dd",
    powderblue: "#b0e0e6",
    purple: "#800080",
    red: "#ff0000",
    rosybrown: "#bc8f8f",
    royalblue: "#4169e1",
    saddlebrown: "#8b4513",
    salmon: "#fa8072",
    sandybrown: "#f4a460",
    seagreen: "#2e8b57",
    seashell: "#fff5ee",
    sienna: "#a0522d",
    silver: "#c0c0c0",
    skyblue: "#87ceeb",
    slateblue: "#6a5acd",
    slategray: "#708090",
    snow: "#fffafa",
    springgreen: "#00ff7f",
    steelblue: "#4682b4",
    tan: "#d2b48c",
    teal: "#008080",
    thistle: "#d8bfd8",
    tomato: "#ff6347",
    turquoise: "#40e0d0",
    violet: "#ee82ee",
    violetred: "#d02090",
    wheat: "#f5deb3",
    white: "#ffffff",
    whitesmoke: "#f5f5f5",
    yellow: "#ffff00",
    yellowgreen: "#9acd32"
  };
function V(t) {
  return function (t, i, n) {
    return b(i) ? t : i < t ? t : i > n ? n : Math.round(i);
  }(0, t, 255);
}
function F(t) {
  return function (t, i, n) {
    return b(i) ? t : i < t ? t : i > n ? n : Math.round(1e4 * i) / 1e4;
  }(0, t, 1);
}
function P(t) {
  (t = t.toLowerCase()) in z && (t = z[t]);
  var i,
    n,
    s = (i = t, null !== (n = C.re.exec(i)) ? C.parse(n) : null);
  if (null !== s) return s;
  var h = function (t) {
    var i = D.re.exec(t);
    return null !== i ? D.parse(i) : null;
  }(t);
  if (null !== h) return h;
  var r = function (t) {
    var i = x.re.exec(t);
    return null !== i ? x.parse(i) : null;
  }(t);
  if (null !== r) return r;
  var u = function (t) {
    var i = T.re.exec(t);
    return null !== i ? T.parse(i) : null;
  }(t);
  return null !== u ? [u[0], u[1], u[2]] : null;
}
function I(t) {
  var i = P(t);
  if (null !== i) return i;
  throw new Error("Passed color string " + t + " does not match any of the known color representations");
}
function O(t, i) {
  if (i < 0 || i > 255) throw new Error("invalid threshold value, valid values are [0, 255]");
  return function (t) {
    return .199 * t[0] + .687 * t[1] + .114 * t[2];
  }(t) >= i ? "white" : "black";
}
function R(t) {
  return function (t) {
    return 0 === t.indexOf("#");
  }(t) ? t : (n = I(t), s = 1, "rgba(" + (i = [n[0], n[1], n[2], F(s)])[0] + ", " + i[1] + ", " + i[2] + ", " + i[3] + ")");
  var i, n, s;
}
function W(t) {
  return "black" === O(I(t), 160) ? "white" : "black";
}
function U(t, i, n, s, h, r) {
  t.fillRect(i, n, r, h), t.fillRect(i + r, n, s - 2 * r, r), t.fillRect(i + r, n + h - r, s - 2 * r, r), t.fillRect(i + s - r, n, r, h);
}
function q(t, i, n) {
  t.save(), t.scale(i, i), n(), t.restore();
}
function j(t, i, n, s, h, r) {
  t.save(), t.globalCompositeOperation = "copy", t.fillStyle = r, t.fillRect(i, n, s, h), t.restore();
}
!function (t) {
  t.re = /^#([0-9a-fA-F])([0-9a-fA-F])([0-9a-fA-F])$/, t.parse = function (t) {
    return [V(parseInt(t[1] + t[1], 16)), V(parseInt(t[2] + t[2], 16)), V(parseInt(t[3] + t[3], 16))];
  };
}(x || (x = {})), function (t) {
  t.re = /^#([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/, t.parse = function (t) {
    return [V(parseInt(t[1], 16)), V(parseInt(t[2], 16)), V(parseInt(t[3], 16))];
  };
}(D || (D = {})), function (t) {
  t.re = /^rgb\(\s*(-?\d{1,10})\s*,\s*(-?\d{1,10})\s*,\s*(-?\d{1,10})\s*\)$/, t.parse = function (t) {
    return [V(parseInt(t[1], 10)), V(parseInt(t[2], 10)), V(parseInt(t[3], 10))];
  };
}(C || (C = {})), function (t) {
  t.re = /^rgba\(\s*(-?\d{1,10})\s*,\s*(-?\d{1,10})\s*,\s*(-?\d{1,10})\s*,\s*(-?[\d]{0,10}(?:\.\d+)?)\s*\)$/, t.parse = function (t) {
    return [V(parseInt(t[1], 10)), V(parseInt(t[2], 10)), V(parseInt(t[3], 10)), F(parseFloat(t[4]))];
  };
}(T || (T = {}));
var H,
  Y = function () {
    function t(t, i) {
      this.setData(t, i);
    }
    return t.prototype.setData = function (t, i) {
      this.m = t, this.N = i;
    }, t.prototype.draw = function (t, i, n, s, h, r) {
      if (this.m.visible) {
        t.font = i.font;
        var u = this.m.tickVisible ? i.tickLength : 0,
          e = i.borderSize,
          o = i.paddingTop,
          f = i.paddingBottom,
          a = i.paddingInner,
          c = i.paddingOuter,
          l = this.m.text,
          v = Math.ceil(n.measureText(t, l)),
          d = i.baselineOffset,
          M = i.fontSize + o + f,
          w = Math.ceil(.5 * M),
          b = e + v + a + c + u,
          m = this.N.coordinate;
        this.N.fixedCoordinate && (m = this.N.fixedCoordinate);
        var p,
          g,
          y = (m = Math.round(m)) - w,
          k = y + M,
          N = "right" === h,
          S = N ? s : 0,
          x = Math.ceil(s * r),
          D = S;
        if (t.fillStyle = R(this.N.background), t.lineWidth = 1, t.lineCap = "butt", l) {
          N ? (p = S - u, g = (D = S - b) + c) : (D = S + b, p = S + u, g = S + e + u + a);
          var C = Math.max(1, Math.floor(r)),
            T = Math.max(1, Math.floor(e * r)),
            E = N ? x : 0,
            L = Math.round(y * r),
            A = Math.round(D * r),
            B = Math.round(m * r) - Math.floor(.5 * r),
            z = B + C + (B - L),
            V = Math.round(p * r);
          t.save(), t.beginPath(), t.moveTo(E, L), t.lineTo(A, L), t.lineTo(A, z), t.lineTo(E, z), t.fill(), t.fillStyle = this.m.borderColor, t.fillRect(N ? x - T : 0, L, T, z - L), this.m.tickVisible && (t.fillStyle = this.N.color, t.fillRect(E, B, V - E, C)), t.textAlign = "left", t.fillStyle = this.N.color, q(t, r, function () {
            t.fillText(l, g, k - f - d);
          }), t.restore();
        }
      }
    }, t.prototype.height = function (t, i) {
      return this.m.visible ? t.fontSize + t.paddingTop + t.paddingBottom : 0;
    }, t;
  }(),
  K = function () {
    function t(t) {
      this.S = {
        coordinate: 0,
        color: "#FFF",
        background: "#000"
      }, this.D = {
        text: "",
        visible: !1,
        tickVisible: !0,
        borderColor: ""
      }, this.C = {
        text: "",
        visible: !1,
        tickVisible: !1,
        borderColor: ""
      }, this.o = !0, this.T = new (t || Y)(this.D, this.S), this.L = new (t || Y)(this.C, this.S);
    }
    return t.prototype.text = function () {
      return this.D.text;
    }, t.prototype.background = function () {
      return this.S.background;
    }, t.prototype.color = function () {
      return W(this.background());
    }, t.prototype.coordinate = function () {
      return this.A(), this.S.coordinate;
    }, t.prototype.update = function () {
      this.o = !0;
    }, t.prototype.height = function (t, i) {
      return void 0 === i && (i = !1), Math.max(this.T.height(t, i), this.L.height(t, i));
    }, t.prototype.getFixedCoordinate = function () {
      return this.S.fixedCoordinate || 0;
    }, t.prototype.setFixedCoordinate = function (t) {
      this.S.fixedCoordinate = t;
    }, t.prototype.isVisible = function () {
      return this.A(), this.D.visible || this.C.visible;
    }, t.prototype.isAxisLabelVisible = function () {
      return this.A(), this.D.visible;
    }, t.prototype.isPaneLabelVisible = function () {
      return this.A(), this.C.visible;
    }, t.prototype.renderer = function () {
      return this.A(), this.T.setData(this.D, this.S), this.L.setData(this.C, this.S), this.T;
    }, t.prototype.paneRenderer = function () {
      return this.A(), this.T.setData(this.D, this.S), this.L.setData(this.C, this.S), this.L;
    }, t.prototype.A = function () {
      this.o && (this._updateRendererData(this.D, this.C, this.S), this.o = !1);
    }, t;
  }(),
  $ = function (t) {
    function i(i, n, s) {
      var h = t.call(this) || this;
      return h.k = i, h.B = n, h.V = s, h;
    }
    return u(i, t), i.prototype._updateRendererData = function (t, i, n) {
      t.visible = !1;
      var s = this.k.options().horzLine;
      if (s.labelVisible) {
        var h = this.B.firstValue();
        if (this.k.visible() && !this.B.isEmpty() && null !== h) {
          n.background = s.labelBackgroundColor, n.color = W(s.labelBackgroundColor);
          var r = this.V(this.B);
          n.coordinate = r.coordinate, t.text = this.B.formatPrice(r.price, h), t.visible = !0;
        }
      }
    }, i;
  }(K),
  _ = /[1-9]/g,
  X = function () {
    function t() {
      this.m = null;
    }
    return t.prototype.setData = function (t) {
      this.m = t;
    }, t.prototype.draw = function (t, i, n) {
      var s = this;
      if (null !== this.m && !1 !== this.m.visible && 0 !== this.m.text.length) {
        t.font = i.font;
        var h = Math.round(i.widthCache.measureText(t, this.m.text, _));
        if (!(h <= 0)) {
          t.save();
          var r = i.paddingHorizontal,
            u = h + 2 * r,
            e = u / 2,
            o = this.m.width,
            f = this.m.coordinate,
            a = Math.floor(f - e) + .5;
          a < 0 ? (f += Math.abs(0 - a), a = Math.floor(f - e) + .5) : a + u > o && (f -= Math.abs(o - (a + u)), a = Math.floor(f - e) + .5);
          var l = a + u,
            v = 0 + i.borderSize + i.paddingTop + i.fontSize + i.paddingBottom;
          t.fillStyle = this.m.background;
          var d = Math.round(a * n),
            M = Math.round(0 * n),
            w = Math.round(l * n),
            b = Math.round(v * n);
          t.fillRect(d, M, w - d, b - M);
          var m = Math.round(this.m.coordinate * n),
            p = M,
            g = Math.round((p + i.borderSize + i.tickLength) * n);
          t.fillStyle = this.m.color;
          var y = Math.max(1, Math.floor(n)),
            k = Math.floor(.5 * n);
          t.fillRect(m - k, p, y, g - p);
          var N = v - i.baselineOffset - i.paddingBottom;
          t.textAlign = "left", t.fillStyle = this.m.color, q(t, n, function () {
            t.fillText(c(s.m).text, a + r, N);
          }), t.restore();
        }
      }
    }, t;
  }(),
  Z = function (t) {
    function i(i, n, s) {
      var h = t.call(this) || this;
      return h.o = !0, h.g = new X(), h.p = {
        visible: !1,
        background: "#4c525e",
        color: "white",
        text: "",
        width: 0,
        coordinate: NaN
      }, h.v = i, h.F = n, h.V = s, h;
    }
    return u(i, t), i.prototype.update = function () {
      this.o = !0;
    }, i.prototype.renderer = function () {
      return this.o && (this.M(), this.o = !1), this.g.setData(this.p), this.g;
    }, i.prototype.M = function () {
      var t = this.p;
      t.visible = !1;
      var i = this.v.options().vertLine;
      if (i.labelVisible) {
        var n = this.F.timeScale();
        if (!n.isEmpty()) {
          var s = n.indexToUserTime(this.v.appliedIndex());
          t.width = n.width();
          var h = this.V();
          h.time && (t.coordinate = h.coordinate, t.text = n.formatDateTime(c(s)), t.visible = !0, t.background = i.labelBackgroundColor, t.color = W(i.labelBackgroundColor));
        }
      }
    }, i;
  }(function () {
    function t() {
      this._text = "", this._background = "#585858", this._coordinate = 0;
    }
    return t.prototype.text = function () {
      return this._text;
    }, t.prototype.background = function () {
      return this._background;
    }, t.prototype.color = function () {
      return "black" === O(I(this._background), 150) ? "white" : "black";
    }, t.prototype.coordinate = function () {
      return this._coordinate;
    }, t;
  }()),
  J = function () {
    function t() {
      this._priceScale = null, this.P = 0;
    }
    return t.prototype.zorder = function () {
      return this.P;
    }, t.prototype.setZorder = function (t) {
      this.P = t;
    }, t.prototype.priceScale = function () {
      return this._priceScale;
    }, t.prototype.setPriceScale = function (t) {
      this._priceScale = t;
    }, t.prototype.priceAxisViews = function (t, i) {
      return [];
    }, t.prototype.paneViews = function (t) {
      return [];
    }, t.prototype.timeAxisViews = function () {
      return [];
    }, t;
  }();
!function (t) {
  t[t.Normal = 0] = "Normal", t[t.Magnet = 1] = "Magnet";
}(H || (H = {}));
var G = function (t) {
    function i(i, n) {
      var s = t.call(this) || this;
      s.I = null, s.O = NaN, s.R = 0, s.W = !0, s.U = new Map(), s.q = !1, s.j = NaN, s.H = NaN, s.Y = NaN, s.K = NaN, s.F = i, s.$ = n, s._ = new L(i, s);
      var h, r;
      s.X = (h = function h() {
        return s.O;
      }, r = function r() {
        return s.H;
      }, function (t) {
        var i = r(),
          n = h();
        if (t === c(s.I).defaultPriceScale()) return {
          price: n,
          coordinate: i
        };
        var u = c(t.firstValue());
        return {
          price: t.coordinateToPrice(i, u),
          coordinate: i
        };
      });
      var u = function (t, i) {
        return function () {
          return {
            time: s.F.timeScale().indexToUserTime(t()),
            coordinate: i()
          };
        };
      }(function () {
        return s.R;
      }, function () {
        return s.appliedX();
      });
      return s.Z = new Z(s, i, u), s.J = new B(s), s;
    }
    return u(i, t), i.prototype.index = function () {
      return this.R;
    }, i.prototype.options = function () {
      return this.$;
    }, i.prototype.saveOriginCoord = function (t, i) {
      this.Y = t, this.K = i;
    }, i.prototype.clearOriginCoord = function () {
      this.Y = NaN, this.K = NaN;
    }, i.prototype.originCoordX = function () {
      return this.Y;
    }, i.prototype.originCoordY = function () {
      return this.K;
    }, i.prototype.setPosition = function (t, i, n) {
      this.q || (this.q = !0), this.W = !0, this.G(t, i, n);
    }, i.prototype.appliedIndex = function () {
      return this.R;
    }, i.prototype.appliedX = function () {
      return this.j;
    }, i.prototype.appliedY = function () {
      return this.H;
    }, i.prototype.visible = function () {
      return this.W;
    }, i.prototype.clearPosition = function () {
      this.W = !1, this.tt(), this.O = NaN, this.j = NaN, this.H = NaN, this.I = null, this.clearOriginCoord();
    }, i.prototype.paneViews = function (t) {
      return null !== this.I ? [this.J, this._] : [];
    }, i.prototype.horzLineVisible = function (t) {
      return t === this.I && this.$.horzLine.visible;
    }, i.prototype.vertLineVisible = function () {
      return this.$.vertLine.visible;
    }, i.prototype.priceAxisViews = function (t, i) {
      this.W && this.I === t || this.U.clear();
      var n = [];
      return this.I === t && n.push(this.it(this.U, i, this.X)), n;
    }, i.prototype.timeAxisViews = function () {
      return this.W ? [this.Z] : [];
    }, i.prototype.pane = function () {
      return this.I;
    }, i.prototype.updateAllViews = function () {
      this.U.forEach(function (t) {
        return t.update();
      }), this.Z.update(), this._.update();
    }, i.prototype.nt = function (t) {
      return t && !t.defaultPriceScale().isEmpty() ? t.defaultPriceScale() : null;
    }, i.prototype.G = function (t, i, n) {
      this.st(t, i, n) && this.updateAllViews();
    }, i.prototype.st = function (t, i, n) {
      var s = this.j,
        h = this.H,
        r = this.O,
        u = this.R,
        e = this.I,
        o = this.nt(n);
      this.R = t, this.j = isNaN(t) ? NaN : this.F.timeScale().indexToCoordinate(t), this.I = n;
      var f = null !== o ? o.firstValue() : null;
      return null !== o && null !== f ? (this.O = i, this.H = o.priceToCoordinate(i, f)) : (this.O = NaN, this.H = NaN), s !== this.j || h !== this.H || u !== this.R || r !== this.O || e !== this.I;
    }, i.prototype.tt = function () {
      var t = this.F.serieses().map(function (t) {
          return t.bars().lastIndex();
        }).filter(g),
        i = 0 === t.length ? null : Math.max.apply(Math, t);
      this.R = null !== i ? i : NaN;
    }, i.prototype.it = function (t, i, n) {
      var s = t.get(i);
      return void 0 === s && (s = new $(this, i, n), t.set(i, s)), s;
    }, i;
  }(J),
  Q = ".",
  tt = "'";
function it(t, i) {
  if (!d(t)) return "n/a";
  if (!M(i)) throw new TypeError("invalid length");
  if (i < 0 || i > 16) throw new TypeError("invalid length");
  if (0 === i) return t.toString();
  return ("0000000000000000" + t.toString()).slice(-i);
}
var nt,
  st = function () {
    function t(t, i, n, s) {
      if (i || (i = 1), d(t) && M(t) || (t = 100), t < 0) throw new TypeError("invalid base");
      this.B = t, this.ht = i, this.rt = s, n && void 0 !== s && s > 0 && 2 !== s && 4 !== s && 8 !== s || (this.ut = n, this.et());
    }
    return t.prototype.format = function (t) {
      var i = t < 0 ? "−" : "";
      return t = Math.abs(t), this.ut ? i + this.ot(t) : i + this.ft(t);
    }, t.prototype.et = function () {
      if (this._fractionalLength = 0, this.B > 0 && this.ht > 0) {
        var t = this.B;
        for (this.ut && this.rt && (t /= this.rt); t > 1;) t /= 10, this._fractionalLength++;
      }
    }, t.prototype.ft = function (t) {
      var i;
      i = this.ut ? Math.pow(10, this._fractionalLength || 0) : this.B / this.ht;
      var n = Math.floor(t),
        s = "",
        h = void 0 !== this._fractionalLength ? this._fractionalLength : NaN;
      if (i > 1) {
        var r = +(Math.round(t * i) - n * i).toFixed(this._fractionalLength);
        r >= i && (r -= i, n += 1), s = Q + it(+r.toFixed(this._fractionalLength) * this.ht, h);
      } else n = Math.round(n * i) / i, h > 0 && (s = Q + it(0, h));
      return n.toFixed(0) + s;
    }, t.prototype.ot = function (t) {
      var i = this.B / this.ht,
        n = Math.floor(t),
        s = Math.round(t * i) - n * i;
      if (s === i && (s = 0, n += 1), !this._fractionalLength) throw new Error("_fractionalLength is not calculated");
      var h = "";
      if (this.rt) {
        var r = s % this.rt,
          u = it(s = (s - r) / this.rt, this._fractionalLength),
          e = 2 === this.rt ? ["0", "5"][r] : 8 === this.rt ? ["0", "1", "2", "3", "4", "5", "6", "7"][r] : ["0", "2", "5", "7"][r];
        h = u + tt + e;
      } else h = it(s * this.ht, this._fractionalLength);
      return n.toString() + tt + h;
    }, t;
  }(),
  ht = function (t) {
    function i(i) {
      return void 0 === i && (i = 100), t.call(this, i) || this;
    }
    return u(i, t), i.prototype.format = function (i) {
      return t.prototype.format.call(this, i) + "%";
    }, i;
  }(st),
  rt = function () {
    function t() {
      this.at = [];
    }
    return t.prototype.subscribe = function (t, i, n) {
      var s = {
        callback: t,
        linkedObject: i,
        singleshot: !0 === n
      };
      this.at.push(s);
    }, t.prototype.unsubscribe = function (t) {
      var i = this.at.findIndex(function (i) {
        return t === i.callback;
      });
      i > -1 && this.at.splice(i, 1);
    }, t.prototype.unsubscribeAll = function (t) {
      this.at = this.at.filter(function (i) {
        return i.linkedObject === t;
      });
    }, t.prototype.fire = function (t, i) {
      var n = o(this.at);
      this.at = this.at.filter(function (t) {
        return !t.singleshot;
      }), n.forEach(function (n) {
        return n.callback(t, i);
      });
    }, t.prototype.hasListeners = function () {
      return this.at.length > 0;
    }, t.prototype.destroy = function () {
      this.at = [];
    }, t;
  }(),
  ut = function (t) {
    function i(i) {
      var n = t.call(this) || this;
      return n.F = i, n;
    }
    return u(i, t), i.prototype.model = function () {
      return this.F;
    }, i.prototype.minMove = function () {
      return 0;
    }, i.prototype.autoscaleInfo = function (t, i) {
      return null;
    }, i;
  }(J),
  et = function () {
    function t(t, i) {
      this.ct = t, this.lt = i;
    }
    return t.prototype.equals = function (t) {
      return null !== t && this.ct === t.ct && this.lt === t.lt;
    }, t.prototype.clone = function () {
      return new t(this.ct, this.lt);
    }, t.prototype.minValue = function () {
      return this.ct;
    }, t.prototype.setMinValue = function (t) {
      this.ct = t;
    }, t.prototype.maxValue = function () {
      return this.lt;
    }, t.prototype.setMaxValue = function (t) {
      this.lt = t;
    }, t.prototype.length = function () {
      return this.lt - this.ct;
    }, t.prototype.isEmpty = function () {
      return this.lt === this.ct || Number.isNaN(this.lt) || Number.isNaN(this.ct);
    }, t.prototype.merge = function (i) {
      return null === i ? this : new t(Math.min(this.minValue(), i.minValue()), Math.max(this.maxValue(), i.maxValue()));
    }, t.prototype.apply = function (t, i) {
      this.ct = Math.min(this.ct, t), this.lt = Math.max(this.lt, i);
    }, t.prototype.set = function (t, i) {
      this.ct = t, this.lt = i;
    }, t.prototype.scaleAroundCenter = function (t) {
      if (d(t) && 0 !== this.lt - this.ct) {
        var i = .5 * (this.lt + this.ct),
          n = this.lt - i,
          s = this.ct - i;
        n *= t, s *= t, this.lt = i + n, this.ct = i + s;
      }
    }, t.prototype.shift = function (t) {
      d(t) && (this.lt += t, this.ct += t);
    }, t.prototype.containsStrictly = function (t) {
      return t.minValue() > this.ct && t.maxValue() < this.lt;
    }, t;
  }();
function ot(t, i, n) {
  return Math.min(Math.max(t, i), n);
}
function ft(t, i, n) {
  return i - t <= n;
}
function at(t) {
  return t <= 0 ? NaN : Math.log(t) / Math.log(10);
}
function ct(t) {
  var i = Math.ceil(t);
  return i % 2 != 0 ? i - 1 : i;
}
function lt(t) {
  var i = Math.ceil(t);
  return i % 2 == 0 ? i - 1 : i;
}
function vt(t, i) {
  var n = 100 * (t - i) / i;
  return i < 0 ? -n : n;
}
function dt(t, i) {
  var n = vt(t.minValue(), i),
    s = vt(t.maxValue(), i);
  return new et(n, s);
}
function Mt(t, i) {
  var n = 100 * (t - i) / i + 100;
  return i < 0 ? -n : n;
}
function wt(t, i) {
  var n = Mt(t.minValue(), i),
    s = Mt(t.maxValue(), i);
  return new et(n, s);
}
function bt(t) {
  var i = Math.abs(t);
  if (i < 1e-8) return 0;
  var n = at(i + 1e-4) + 4;
  return t < 0 ? -n : n;
}
function mt(t) {
  var i = Math.abs(t);
  if (i < 1e-8) return 0;
  var n = Math.pow(10, i - 4) - 1e-4;
  return t < 0 ? -n : n;
}
function pt(t) {
  if (null === t) return null;
  var i = bt(t.minValue()),
    n = bt(t.maxValue());
  return new et(i, n);
}
!function (t) {
  t[t.LogicalOffset = 4] = "LogicalOffset", t[t.CoordOffset = 1e-4] = "CoordOffset";
}(nt || (nt = {}));
var gt = function () {
    function t(t, i) {
      if (this.vt = t, this.dt = i, function (t) {
        if (t < 0) return !1;
        for (var i = t; i > 1; i /= 10) if (i % 10 != 0) return !1;
        return !0;
      }(this.vt)) this.Mt = [2, 2.5, 2];else {
        this.Mt = [];
        for (var n = this.vt; 1 !== n;) {
          if (n % 2 == 0) this.Mt.push(2), n /= 2;else {
            if (n % 5 != 0) throw new Error("unexpected base");
            this.Mt.push(2), this.Mt.push(2.5), n /= 5;
          }
          if (this.Mt.length > 100) throw new Error("something wrong with base");
        }
      }
    }
    return t.prototype.tickSpan = function (t, i, n) {
      for (var s, h, r, u = 0 === this.vt ? 0 : 1 / this.vt, e = Math.pow(10, Math.max(0, Math.ceil(at(t - i)))), o = 0, f = this.dt[0];;) {
        var a = ft(e, u, 1e-9) && e > u + 1e-9,
          c = ft(e, n * f, 1e-9),
          l = ft(e, 1, 1e-9);
        if (!(a && c && l)) break;
        e /= f, f = this.dt[++o % this.dt.length];
      }
      if (e <= u + 1e-9 && (e = u), e = Math.max(1, e), this.Mt.length > 0 && (s = e, h = 1, r = 1e-9, Math.abs(s - h) < r)) for (o = 0, f = this.Mt[0]; ft(e, n * f, 1e-9) && e > u + 1e-9;) e /= f, f = this.Mt[++o % this.Mt.length];
      return e;
    }, t;
  }(),
  yt = function () {
    function t(t, i, n, s) {
      this.wt = [], this.B = t, this.vt = i, this.bt = n, this.pt = s;
    }
    return t.prototype.setBase = function (t) {
      if (t < 0) throw new Error("base < 0");
      this.vt = t;
    }, t.prototype.tickSpan = function (t, i) {
      if (t < i) throw new Error("high < low");
      var n = this.B.height(),
        s = (t - i) * this.gt() / n,
        h = new gt(this.vt, [2, 2.5, 2]),
        r = new gt(this.vt, [2, 2, 2.5]),
        u = new gt(this.vt, [2.5, 2, 2]),
        e = [];
      return e.push(h.tickSpan(t, i, s)), e.push(r.tickSpan(t, i, s)), e.push(u.tickSpan(t, i, s)), function (t) {
        if (t.length < 1) throw Error("array is empty");
        for (var i = t[0], n = 1; n < t.length; ++n) t[n] < i && (i = t[n]);
        return i;
      }(e);
    }, t.prototype.rebuildTickMarks = function () {
      var t = this.B,
        i = t.firstValue();
      if (null !== i) {
        var n = t.height(),
          s = this.bt(n - 1, i),
          h = this.bt(0, i),
          r = this.B.options().entireTextOnly ? this.yt() / 2 : 0,
          u = r,
          e = n - 1 - r,
          o = Math.max(s, h),
          f = Math.min(s, h);
        if (o !== f) {
          for (var a = this.tickSpan(o, f), c = o % a, l = o >= f ? 1 : -1, v = null, d = 0, M = o - (c += c < 0 ? a : 0); M > f; M -= a) {
            var w = this.pt(M, i, !0);
            null !== v && Math.abs(w - v) < this.gt() || w < u || w > e || (d < this.wt.length ? (this.wt[d].coord = w, this.wt[d].label = t.formatLogical(M)) : this.wt.push({
              coord: w,
              label: t.formatLogical(M)
            }), d++, v = w, t.isLog() && (a = this.tickSpan(M * l, f)));
          }
          this.wt.length = d;
        } else this.wt = [];
      } else this.wt = [];
    }, t.prototype.marks = function () {
      return this.wt;
    }, t.prototype.yt = function () {
      return this.B.fontSize();
    }, t.prototype.gt = function () {
      return Math.ceil(2.5 * this.yt());
    }, t;
  }(),
  kt = function () {
    function t(t) {
      this.kt = t;
    }
    return t.prototype.format = function (t) {
      var i = "";
      return t < 0 && (i = "-", t = -t), t < 995 ? i + this.Nt(t) : t < 999995 ? i + this.Nt(t / 1e3) + "K" : t < 999999995 ? (t = 1e3 * Math.round(t / 1e3), i + this.Nt(t / 1e6) + "M") : (t = 1e6 * Math.round(t / 1e6), i + this.Nt(t / 1e9) + "B");
    }, t.prototype.Nt = function (t) {
      var i = Math.pow(10, this.kt);
      return ((t = Math.round(t * i) / i) >= 1e-15 && t < 1 ? t.toFixed(this.kt).replace(/\.?0+$/, "") : String(t)).replace(/(\.[1-9]*)0+$/, function (t, i) {
        return i;
      });
    }, t;
  }();
function Nt(t, i, n, s) {
  if (0 !== i.length) {
    var h = i[s.from].x,
      r = i[s.from].y;
    t.moveTo(h, r);
    for (var u = s.from + 1; u < s.to; ++u) {
      var e = i[u];
      if (1 === n) {
        var o = i[u - 1].y,
          f = e.x;
        t.lineTo(f, o);
      }
      t.lineTo(e.x, e.y);
    }
  }
}
var St = function (t) {
    function i() {
      var i = null !== t && t.apply(this, arguments) || this;
      return i._data = null, i;
    }
    return u(i, t), i.prototype.setData = function (t) {
      this._data = t;
    }, i.prototype._drawImpl = function (t) {
      if (null !== this._data && 0 !== this._data.items.length && null !== this._data.visibleRange) {
        t.lineCap = "butt", t.strokeStyle = this._data.lineColor, t.lineWidth = this._data.lineWidth, s(t, this._data.lineStyle), t.lineWidth = 1, t.beginPath(), t.moveTo(this._data.items[this._data.visibleRange.from].x, this._data.bottom), t.lineTo(this._data.items[this._data.visibleRange.from].x, this._data.items[this._data.visibleRange.from].y), Nt(t, this._data.items, this._data.lineType, this._data.visibleRange), t.lineTo(this._data.items[this._data.visibleRange.to - 1].x, this._data.bottom), t.lineTo(this._data.items[this._data.visibleRange.from].x, this._data.bottom), t.closePath();
        var i = t.createLinearGradient(0, 0, 0, this._data.bottom);
        i.addColorStop(0, this._data.topColor), i.addColorStop(1, this._data.bottomColor), t.fillStyle = i, t.fill();
      }
    }, i;
  }(N),
  xt = function (t) {
    function i() {
      var i = null !== t && t.apply(this, arguments) || this;
      return i._data = null, i;
    }
    return u(i, t), i.prototype.setData = function (t) {
      this._data = t;
    }, i.prototype._drawImpl = function (t) {
      null !== this._data && 0 !== this._data.items.length && null !== this._data.visibleRange && (t.lineCap = "square", t.lineWidth = this._data.lineWidth, s(t, this._data.lineStyle), t.strokeStyle = this._data.lineColor, t.lineJoin = "miter", t.beginPath(), Nt(t, this._data.items, this._data.lineType, this._data.visibleRange), t.stroke());
    }, i;
  }(N);
function Dt(t, i, n, s, h) {
  void 0 === s && (s = 0), void 0 === h && (h = t.length);
  for (var r = h - s; 0 < r;) {
    var u = r >> 1,
      e = s + u;
    n(t[e], i) ? (s = e + 1, r -= u + 1) : r = u;
  }
  return s;
}
function Ct(t, i, n, s, h) {
  void 0 === s && (s = 0), void 0 === h && (h = t.length);
  for (var r = h - s; 0 < r;) {
    var u = r >> 1,
      e = s + u;
    n(i, t[e]) ? r = u : (s = e + 1, r -= u + 1);
  }
  return s;
}
function Tt(t, i) {
  return t.time < i;
}
function Et(t, i) {
  return t < i.time;
}
function Lt(t, i, n) {
  var s = i.firstBar(),
    h = i.lastBar(),
    r = Dt(t, s, Tt),
    u = Ct(t, h, Et);
  if (!n) return {
    from: r,
    to: u
  };
  var e = r,
    o = u;
  return r > 0 && r < t.length && t[r].time >= s && (e = r - 1), u > 0 && u < t.length && t[u - 1].time <= h && (o = u + 1), {
    from: e,
    to: o
  };
}
var At = function () {
    function t(t, i, n) {
      this._invalidated = !0, this._dataInvalidated = !0, this._items = [], this._itemsVisibleRange = null, this._series = t, this._model = i, this.St = n;
    }
    return t.prototype.update = function (t) {
      this._invalidated = !0, "data" === t && (this._dataInvalidated = !0);
    }, t.prototype._makeValid = function () {
      this._dataInvalidated && (this._fillRawPoints(), this._dataInvalidated = !1), this._invalidated && (this._updatePoints(), this._invalidated = !1);
    }, t.prototype._clearVisibleRange = function () {
      this._itemsVisibleRange = null;
    }, t.prototype._updatePoints = function () {
      var t = this._series.priceScale(),
        i = this._model.timeScale();
      if (this._clearVisibleRange(), !i.isEmpty() && !t.isEmpty()) {
        var n = i.visibleBars();
        if (null !== n && 0 !== this._series.data().bars().size()) {
          var s = this._series.firstValue();
          null !== s && (this._itemsVisibleRange = Lt(this._items, n, this.St), this._convertToCoordinates(t, i, s.value));
        }
      }
    }, t;
  }(),
  Bt = function (t) {
    function i(i, n) {
      return t.call(this, i, n, !0) || this;
    }
    return u(i, t), i.prototype._convertToCoordinates = function (t, i, n) {
      i.indexesToCoordinates(this._items, y(this._itemsVisibleRange)), t.pointsArrayToCoordinates(this._items, n, y(this._itemsVisibleRange));
    }, i.prototype._createRawItemBase = function (t, i) {
      return {
        time: t,
        price: i,
        x: NaN,
        y: NaN
      };
    }, i.prototype._fillRawPoints = function () {
      var t = this,
        i = this._series.barFunction(),
        n = [],
        s = this._series.barColorer();
      this._series.bars().each(function (h, r) {
        var u = i(r.value),
          e = t._createRawItem(h, u, s);
        return n.push(e), !1;
      }), this._items = n;
    }, i;
  }(At),
  zt = function (t) {
    function i(i, n) {
      var s = t.call(this, i, n) || this;
      return s.g = new k(), s.xt = new St(), s.Dt = new xt(), s.g.setRenderers([s.xt, s.Dt]), s;
    }
    return u(i, t), i.prototype.renderer = function (t, i) {
      this._makeValid();
      var n = this._series.options(),
        s = {
          lineType: n.lineType,
          items: this._items,
          lineColor: n.lineColor,
          lineStyle: n.lineStyle,
          lineWidth: n.lineWidth,
          topColor: n.topColor,
          bottomColor: n.bottomColor,
          bottom: t,
          visibleRange: this._itemsVisibleRange
        };
      return this.xt.setData(s), this.Dt.setData(s), this.g;
    }, i.prototype._createRawItem = function (t, i) {
      return this._createRawItemBase(t, i);
    }, i;
  }(Bt);
var Vt,
  Ft = function () {
    function t() {
      this.m = null, this.Ct = 0, this.Tt = 0;
    }
    return t.prototype.setData = function (t) {
      this.m = t;
    }, t.prototype.draw = function (t, i, n, s) {
      if (null !== this.m && 0 !== this.m.bars.length && null !== this.m.visibleRange) {
        if (this.Ct = Math.max(1, Math.floor(function (t, i) {
          return Math.floor(.3 * t * i);
        }(this.m.barSpacing, i))), this.Ct >= 2) Math.floor(i) % 2 != this.Ct % 2 && this.Ct--;
        this.Tt = this.m.thinBars ? Math.min(this.Ct, Math.floor(i)) : this.Ct;
        for (var h = null, r = this.m.visibleRange.from; r < this.m.visibleRange.to; ++r) {
          var u = this.m.bars[r];
          h !== u.color && (t.fillStyle = u.color, h = u.color);
          var e = Math.floor(.5 * this.Tt),
            o = Math.round(u.x * i),
            f = o - e,
            a = this.Tt,
            c = f + a - 1,
            l = Math.round(u.highY * i) - e,
            v = Math.round(u.lowY * i) + e,
            d = Math.max(v - l, this.Tt);
          t.fillRect(f, l, a, d);
          var M = Math.ceil(1.5 * this.Ct);
          if (this.Tt <= this.Ct) {
            if (this.m.openVisible) {
              var w = o - M,
                b = Math.max(l, Math.round(u.openY * i) - e),
                m = b + a - 1;
              m > l + d - 1 && (b = (m = l + d - 1) - a + 1), t.fillRect(w, b, f - w, m - b + 1);
            }
            var p = o + M,
              g = Math.max(l, Math.round(u.closeY * i) - e),
              y = g + a - 1;
            y > l + d - 1 && (g = (y = l + d - 1) - a + 1), t.fillRect(c + 1, g, p - c, y - g + 1);
          }
        }
      }
    }, t;
  }(),
  Pt = function (t) {
    function i(i, n) {
      return t.call(this, i, n, !1) || this;
    }
    return u(i, t), i.prototype._convertToCoordinates = function (t, i, n) {
      i.indexesToCoordinates(this._items, y(this._itemsVisibleRange)), t.barPricesToCoordinates(this._items, n, y(this._itemsVisibleRange));
    }, i.prototype._createDefaultItem = function (t, i, n) {
      return {
        time: t,
        open: i.value[0],
        high: i.value[1],
        low: i.value[2],
        close: i.value[3],
        x: NaN,
        openY: NaN,
        highY: NaN,
        lowY: NaN,
        closeY: NaN
      };
    }, i.prototype._fillRawPoints = function () {
      var t = this,
        i = [],
        n = this._series.barColorer();
      this._series.bars().each(function (s, h) {
        var r = t._createRawItem(s, h, n);
        return i.push(r), !1;
      }), this._items = i;
    }, i;
  }(At),
  It = function (t) {
    function i(i, n) {
      var s = t.call(this, i, n) || this;
      return s.g = new Ft(), s;
    }
    return u(i, t), i.prototype.renderer = function (t, i) {
      this._makeValid();
      var n = this._series.options(),
        s = {
          bars: this._items,
          barSpacing: this._model.timeScale().barSpacing(),
          openVisible: n.openVisible,
          thinBars: n.thinBars,
          visibleRange: this._itemsVisibleRange
        };
      return this.g.setData(s), this.g;
    }, i.prototype._createRawItem = function (t, i, n) {
      return _e(_e({}, this._createDefaultItem(t, i, n)), {
        color: n.barStyle(t).barColor
      });
    }, i;
  }(Pt);
!function (t) {
  t[t.BarBorderWidth = 1] = "BarBorderWidth";
}(Vt || (Vt = {}));
var Ot = function () {
    function t() {
      this.m = null, this.Ct = 0;
    }
    return t.prototype.setData = function (t) {
      this.m = t;
    }, t.prototype.draw = function (t, i, n, s) {
      if (null !== this.m && 0 !== this.m.bars.length && null !== this.m.visibleRange) {
        if (this.Ct = function (t, i) {
          var n = Math.floor(.8 * t * i),
            s = Math.floor(t * i),
            h = Math.min(n, s - 1);
          return Math.max(1, h);
        }(this.m.barSpacing, i), this.Ct >= 2) Math.floor(i) % 2 != this.Ct % 2 && this.Ct--;
        var h = this.m.bars;
        this.m.wickVisible && this.Et(t, h, this.m.visibleRange, i), this.m.borderVisible && this.Lt(t, h, this.m.visibleRange, this.m.barSpacing, i);
        var r = this.At(i);
        (!this.m.borderVisible || this.Ct > 2 * r) && this.Bt(t, h, this.m.visibleRange, i);
      }
    }, t.prototype.Et = function (t, i, n, s) {
      if (null !== this.m) {
        var h = "",
          r = Math.min(Math.floor(s), Math.floor(this.m.barSpacing * s));
        r = Math.min(r, this.Ct);
        for (var u = Math.floor(.5 * r), e = n.from; e < n.to; e++) {
          var o = i[e];
          o.wickColor !== h && (t.fillStyle = o.wickColor, h = o.wickColor);
          var f = Math.round(Math.min(o.openY, o.closeY) * s),
            a = Math.round(Math.max(o.openY, o.closeY) * s),
            c = Math.round(o.highY * s),
            l = Math.round(o.lowY * s),
            v = Math.round(s * o.x);
          t.fillRect(v - u, c, r, f - c), t.fillRect(v - u, a + 1, r, l - a);
        }
      }
    }, t.prototype.At = function (t) {
      var i = Math.floor(1 * t);
      this.Ct <= 2 * i && (i = Math.floor(.5 * (this.Ct - 1)));
      var n = Math.max(1, i);
      return this.Ct <= 2 * n ? Math.floor(1 * t) : n;
    }, t.prototype.Lt = function (t, i, n, s, h) {
      for (var r = "", u = this.At(h), e = n.from; e < n.to; e++) {
        var o = i[e];
        o.borderColor !== r && (t.fillStyle = o.borderColor, r = o.borderColor);
        var f = Math.round(o.x * h) - Math.floor(.5 * this.Ct),
          a = f + this.Ct - 1,
          c = Math.round(Math.min(o.openY, o.closeY) * h),
          l = Math.round(Math.max(o.openY, o.closeY) * h);
        s > 2 * u ? U(t, f, c, a - f + 1, l - c + 1, u) : t.fillRect(f, c, a - f + 1, l - c + 1);
      }
    }, t.prototype.Bt = function (t, i, n, s) {
      if (null !== this.m) for (var h = "", r = this.At(s), u = n.from; u < n.to; u++) {
        var e = i[u],
          o = Math.round(Math.min(e.openY, e.closeY) * s),
          f = Math.round(Math.max(e.openY, e.closeY) * s),
          a = Math.round(e.x * s) - Math.floor(.5 * this.Ct),
          c = a + this.Ct - 1;
        if (this.m.borderVisible && (a += r, o += r, c -= r, f -= r), !(o > f)) {
          if (e.color !== h) {
            var l = e.color;
            t.fillStyle = l, h = l;
          }
          t.fillRect(a, o, c - a + 1, f - o + 1);
        }
      }
    }, t;
  }(),
  Rt = function (t) {
    function i(i, n) {
      var s = t.call(this, i, n) || this;
      return s.g = new Ot(), s;
    }
    return u(i, t), i.prototype.renderer = function (t, i) {
      this._makeValid();
      var n = this._series.options(),
        s = {
          bars: this._items,
          barSpacing: this._model.timeScale().barSpacing(),
          wickVisible: n.wickVisible,
          borderVisible: n.borderVisible,
          visibleRange: this._itemsVisibleRange
        };
      return this.g.setData(s), this.g;
    }, i.prototype._createRawItem = function (t, i, n) {
      var s = n.barStyle(t);
      return _e(_e({}, this._createDefaultItem(t, i, n)), {
        color: s.barColor,
        wickColor: s.barWickColor,
        borderColor: s.barBorderColor
      });
    }, i;
  }(Pt),
  Wt = function () {
    function t() {
      this.m = null, this.zt = [];
    }
    return t.prototype.setData = function (t) {
      this.m = t, this.zt = [];
    }, t.prototype.draw = function (t, i, n, s) {
      if (null !== this.m && 0 !== this.m.items.length && null !== this.m.visibleRange) {
        this.zt.length || this.Vt(i);
        for (var h = Math.round(this.m.histogramBase * i), r = Math.max(1, Math.floor(i)), u = this.m.visibleRange.from; u < this.m.visibleRange.to; u++) {
          var e = this.m.items[u],
            o = this.zt[u - this.m.visibleRange.from],
            f = Math.round(e.y * i);
          t.fillStyle = e.color, t.fillRect(o.left, f, o.right - o.left + 1, h - f + r);
        }
      }
    }, t.prototype.Vt = function (t) {
      if (null !== this.m && 0 !== this.m.items.length && null !== this.m.visibleRange) {
        var i = Math.ceil(this.m.barSpacing * t) <= 3 ? 0 : Math.max(1, Math.floor(t)),
          n = Math.round(this.m.barSpacing * t) - i;
        this.zt = new Array(this.m.visibleRange.to - this.m.visibleRange.from);
        for (var s = this.m.visibleRange.from; s < this.m.visibleRange.to; s++) {
          var h,
            r = this.m.items[s],
            u = Math.round(r.x * t),
            e = void 0,
            o = void 0;
          if (n % 2) e = u - (h = (n - 1) / 2), o = u + h;else e = u - (h = n / 2), o = u + h - 1;
          this.zt[s - this.m.visibleRange.from] = {
            left: e,
            right: o,
            roundedCenter: u,
            center: r.x * t,
            time: r.time
          };
        }
        for (s = this.m.visibleRange.from + 1; s < this.m.visibleRange.to; s++) {
          var f = this.zt[s - this.m.visibleRange.from],
            a = this.zt[s - this.m.visibleRange.from - 1];
          f.time === a.time + 1 && f.left - a.right !== i + 1 && (a.roundedCenter > a.center ? a.right = f.left - i - 1 : f.left = a.right + i + 1);
        }
        var c = Math.ceil(this.m.barSpacing * t);
        for (s = this.m.visibleRange.from; s < this.m.visibleRange.to; s++) {
          (f = this.zt[s - this.m.visibleRange.from]).right < f.left && (f.right = f.left);
          var l = f.right - f.left + 1;
          c = Math.min(l, c);
        }
        if (i > 0 && c < 4) for (s = this.m.visibleRange.from; s < this.m.visibleRange.to; s++) {
          (l = (f = this.zt[s - this.m.visibleRange.from]).right - f.left + 1) > c && (f.roundedCenter > f.center ? f.right -= 1 : f.left += 1);
        }
      } else this.zt = [];
    }, t;
  }();
function Ut(t) {
  return {
    items: [],
    barSpacing: t,
    histogramBase: NaN,
    visibleRange: null
  };
}
var qt,
  jt = function (t) {
    function i(i, n) {
      var s = t.call(this, i, n, !1) || this;
      return s.i = new k(), s.Ft = Ut(0), s.Pt = new Int32Array(0), s.g = new Wt(), s;
    }
    return u(i, t), i.prototype.renderer = function (t, i) {
      return this._makeValid(), this.i;
    }, i.prototype._fillRawPoints = function () {
      var t = this,
        i = this._model.timeScale().barSpacing(),
        n = this._series.palette();
      this.Ft = Ut(i);
      var s = this._series.barFunction();
      this.Pt = new Int32Array(this._series.bars().size());
      var h = 0,
        r = 0,
        u = 0,
        e = this._series.options().color;
      this._series.bars().each(function (i, o) {
        var f = s(o.value),
          a = o.value[4],
          c = function (t, i, n) {
            return {
              time: t,
              price: i,
              x: NaN,
              y: NaN,
              color: n
            };
          }(i, f, null != a ? n.colorByIndex(a) : e),
          l = null == a ? 0 : a + 1;
        return ++r < t.Ft.items.length ? t.Ft.items[r] = c : t.Ft.items.push(c), t._items[u++] = {
          time: i,
          x: 0
        }, t.Pt[h++] = l, !1;
      }), this.g.setData(this.Ft), this.i.setRenderers([this.g]);
    }, i.prototype._clearVisibleRange = function () {
      t.prototype._clearVisibleRange.call(this), this.Ft.visibleRange = null;
    }, i.prototype._convertToCoordinates = function (t, i, n) {
      if (null !== this._itemsVisibleRange) {
        var s = i.barSpacing(),
          h = c(i.visibleBars()),
          r = t.priceToCoordinate(this._series.options().base, n);
        i.indexesToCoordinates(this.Ft.items), t.pointsArrayToCoordinates(this.Ft.items, n), this.Ft.histogramBase = r, this.Ft.visibleRange = Lt(this.Ft.items, h, !1), this.Ft.barSpacing = s, this.g.setData(this.Ft);
      }
    }, i;
  }(At),
  Ht = function (t) {
    function i(i, n) {
      var s = t.call(this, i, n) || this;
      return s.Dt = new xt(), s;
    }
    return u(i, t), i.prototype.renderer = function (t, i) {
      this._makeValid();
      var n = this._series.options(),
        s = {
          items: this._items,
          lineColor: n.color,
          lineStyle: n.lineStyle,
          lineType: n.lineType,
          lineWidth: n.lineWidth,
          visibleRange: this._itemsVisibleRange
        };
      return this.Dt.setData(s), this.Dt;
    }, i.prototype._createRawItem = function (t, i) {
      return this._createRawItemBase(t, i);
    }, i;
  }(Bt),
  Yt = /[2-9]/g,
  Kt = function () {
    function t(t) {
      void 0 === t && (t = 50), this.It = 0, this.Ot = 1, this.Rt = 1, this.Wt = {}, this.Ut = {}, this.qt = t;
    }
    return t.prototype.reset = function () {
      this.It = 0, this.Ut = {}, this.Ot = 1, this.Rt = 1, this.Wt = {};
    }, t.prototype.measureText = function (t, i, n) {
      var s = n || Yt,
        h = String(i).replace(s, "0");
      if (this.Ut[h]) return this.Ut[h].width;
      if (this.It === this.qt) {
        var r = this.Wt[this.Rt];
        delete this.Wt[this.Rt], delete this.Ut[r], this.Rt++, this.It--;
      }
      var u = t.measureText(h).width;
      return 0 === u && i.length ? 0 : (this.Ut[h] = {
        width: u,
        tick: this.Ot
      }, this.Wt[this.Ot] = h, this.It++, this.Ot++, u);
    }, t;
  }(),
  $t = function () {
    function t(t) {
      this.jt = null, this.Ht = null, this.Yt = "right", this.Kt = 0, this.$t = t;
    }
    return t.prototype.setParams = function (t, i, n, s) {
      this.jt = t, this.Ht = i, this.Kt = n, this.Yt = s;
    }, t.prototype.draw = function (t, i) {
      null !== this.Ht && null !== this.jt && this.jt.draw(t, this.Ht, this.$t, this.Kt, this.Yt, i);
    }, t;
  }(),
  _t = function () {
    function t(t, i, n) {
      this._t = t, this.$t = new Kt(50), this.Xt = i, this.l = n, this.Zt = -1, this.g = new $t(this.$t);
    }
    return t.prototype.update = function () {
      this._t.update();
    }, t.prototype.renderer = function (t, i) {
      var n = this.l.paneForSource(this.Xt);
      if (null === n) return null;
      if (null === this.Xt.priceScale()) return null;
      var s = n.priceScalePosition();
      if ("overlay" === s) return null;
      var h = this.l.priceAxisRendererOptions();
      return h.fontSize !== this.Zt && (this.Zt = h.fontSize, this.$t.reset()), this.g.setParams(this._t.paneRenderer(), h, i, s), this.g;
    }, t;
  }(),
  Xt = function () {
    function t() {
      this.m = null;
    }
    return t.prototype.setData = function (t) {
      this.m = t;
    }, t.prototype.draw = function (t, i, n, r) {
      if (null !== this.m && !1 !== this.m.visible) {
        var u = Math.round(this.m.y * i);
        if (!(u < 0 || u > Math.ceil(this.m.height * i))) {
          var e = Math.ceil(this.m.width * i);
          t.lineCap = "butt", t.strokeStyle = this.m.color, t.lineWidth = Math.floor(this.m.lineWidth * i), s(t, this.m.lineStyle), h(t, u, 0, e);
        }
      }
    }, t;
  }(),
  Zt = function () {
    function t(t) {
      this._lineRendererData = {
        width: 0,
        height: 0,
        y: 0,
        color: "rgba(0, 0, 0, 0)",
        lineWidth: 1,
        lineStyle: 0,
        visible: !1
      }, this._lineRenderer = new Xt(), this.o = !0, this._series = t, this._model = t.model(), this._lineRenderer.setData(this._lineRendererData);
    }
    return t.prototype.update = function () {
      this.o = !0;
    }, t.prototype.renderer = function (t, i) {
      return this.o && (this._updateImpl(t, i), this.o = !1), this._lineRenderer;
    }, t;
  }(),
  Jt = function (t) {
    function i(i) {
      return t.call(this, i) || this;
    }
    return u(i, t), i.prototype._updateImpl = function (t, i) {
      this._lineRendererData.visible = !1;
      var n = this._series.priceScale(),
        s = n.mode().mode;
      if (2 === s || 3 === s) {
        var h = this._series.options();
        if (h.baseLineVisible) {
          var r = this._series.firstValue();
          null !== r && (this._lineRendererData.visible = !0, this._lineRendererData.y = n.priceToCoordinate(r.value, r.value), this._lineRendererData.width = i, this._lineRendererData.height = t, this._lineRendererData.color = h.baseLineColor, this._lineRendererData.lineWidth = h.baseLineWidth, this._lineRendererData.lineStyle = h.baseLineStyle);
        }
      }
    }, i;
  }(Zt);
function Gt(t, i) {
  return lt(Math.min(Math.max(t, 12), 30) * i);
}
function Qt(t, i) {
  switch (t) {
    case "arrowDown":
    case "arrowUp":
      return Gt(i, 1);
    case "circle":
      return Gt(i, .8);
    case "square":
      return Gt(i, .7);
  }
}
function ti(t) {
  return ct(Gt(t, 1));
}
function ii(t) {
  return Math.max(Gt(t, .1), 3);
}
function ni(t, i, n, s, h) {
  var r = Qt("square", n),
    u = (r - 1) / 2,
    e = t - u,
    o = i - u;
  return s >= e && s <= e + r && h >= o && h <= o + r;
}
function si(t, i, n, s, h, r) {
  var u = (Qt("arrowUp", r) - 1) / 2,
    e = (lt(r / 2) - 1) / 2;
  i.fillStyle = h, i.beginPath(), t ? (i.moveTo(n - u, s), i.lineTo(n, s - u), i.lineTo(n + u, s), i.lineTo(n + e, s), i.lineTo(n + e, s + u), i.lineTo(n - e, s + u), i.lineTo(n - e, s)) : (i.moveTo(n - u, s), i.lineTo(n, s + u), i.lineTo(n + u, s), i.lineTo(n + e, s), i.lineTo(n + e, s - u), i.lineTo(n - e, s - u), i.lineTo(n - e, s)), i.fill();
}
function hi(t, i, n, s, h, r) {
  return ni(i, n, s, h, r);
}
!function (t) {
  t[t.MinShapeSize = 12] = "MinShapeSize", t[t.MaxShapeSize = 30] = "MaxShapeSize", t[t.MinShapeMargin = 3] = "MinShapeMargin";
}(qt || (qt = {}));
var ri = function (t) {
  function i() {
    var i = null !== t && t.apply(this, arguments) || this;
    return i.m = null, i;
  }
  return u(i, t), i.prototype.setData = function (t) {
    this.m = t;
  }, i.prototype.hitTest = function (t, i) {
    if (null === this.m || null === this.m.visibleRange) return null;
    for (var n = this.m.visibleRange.from; n < this.m.visibleRange.to; n++) {
      var s = this.m.items[n];
      if (ei(s, t, i)) return {
        hitTestData: s.internalId,
        externalId: s.externalId
      };
    }
    return null;
  }, i.prototype._drawImpl = function (t, i, n) {
    if (null !== this.m && null !== this.m.visibleRange) for (var s = this.m.visibleRange.from; s < this.m.visibleRange.to; s++) {
      ui(this.m.items[s], t);
    }
  }, i;
}(N);
function ui(t, i) {
  switch (t.shape) {
    case "arrowDown":
      return void si(!1, i, t.x, t.y, t.color, t.size);
    case "arrowUp":
      return void si(!0, i, t.x, t.y, t.color, t.size);
    case "circle":
      return void function (t, i, n, s, h) {
        var r = (Qt("circle", h) - 1) / 2;
        t.fillStyle = s, t.beginPath(), t.arc(i, n, r, 0, 2 * Math.PI, !1), t.fill();
      }(i, t.x, t.y, t.color, t.size);
    case "square":
      return void function (t, i, n, s, h) {
        var r = Qt("square", h),
          u = (r - 1) / 2,
          e = i - u,
          o = n - u;
        t.fillStyle = s, t.fillRect(e, o, r, r);
      }(i, t.x, t.y, t.color, t.size);
  }
  t.shape;
}
function ei(t, i, n) {
  switch (t.shape) {
    case "arrowDown":
    case "arrowUp":
      return hi(0, t.x, t.y, t.size, i, n);
    case "circle":
      return function (t, i, n, s, h) {
        var r = 2 + Qt("circle", n) / 2,
          u = t - s,
          e = i - h;
        return Math.sqrt(u * u + e * e) <= r;
      }(t.x, t.y, t.size, i, n);
    case "square":
      return ni(t.x, t.y, t.size, i, n);
  }
  t.shape;
}
function oi(t, i, n, s, h, r, u, e) {
  var o = d(n) ? n : n.close,
    f = d(n) ? n : n.high,
    a = d(n) ? n : n.low,
    c = ti(u.barSpacing());
  switch (t.size = c, i.position) {
    case "inBar":
      return void (t.y = r.priceToCoordinate(o, e));
    case "aboveBar":
      return t.y = r.priceToCoordinate(f, e) - c / 2 - s.aboveBar, void (s.aboveBar += c + h);
    case "belowBar":
      return t.y = r.priceToCoordinate(a, e) + c / 2 + s.belowBar, void (s.belowBar += c + h);
  }
  i.position;
}
var fi,
  ai = function () {
    function t(t, i) {
      this.o = !0, this.Jt = !0, this.Gt = !0, this.Qt = null, this.g = new ri(), this.ti = t, this.F = i, this.m = {
        items: [],
        visibleRange: null
      };
    }
    return t.prototype.update = function (t) {
      this.o = !0, this.Gt = !0, "data" === t && (this.Jt = !0);
    }, t.prototype.renderer = function (t, i, n) {
      return this.o && this._makeValid(), this.g.setData(this.m), this.g;
    }, t.prototype.autoScaleMargins = function () {
      if (this.Gt) {
        if (this.ti.indexedMarkers().length > 0) {
          var t = this.F.timeScale().barSpacing(),
            i = ii(t),
            n = 1.5 * ti(t) + 2 * i;
          this.Qt = {
            above: n,
            below: n
          };
        } else this.Qt = null;
        this.Gt = !1;
      }
      return this.Qt;
    }, t.prototype._makeValid = function () {
      var t = this.ti.priceScale(),
        i = this.F.timeScale(),
        n = this.ti.indexedMarkers();
      this.Jt && (this.m.items = n.map(function (t) {
        return {
          time: t.time,
          x: 0,
          y: 0,
          size: 0,
          shape: t.shape,
          color: t.color,
          internalId: t.internalId,
          externalId: t.id
        };
      }), this.Jt = !1), this.m.visibleRange = null;
      var s = i.visibleBars();
      if (null !== s) {
        var h = this.ti.firstValue();
        if (null !== h && 0 !== this.m.items.length) {
          var r = NaN,
            u = ii(i.barSpacing()),
            e = {
              aboveBar: u,
              belowBar: u
            };
          this.m.visibleRange = Lt(this.m.items, s, !0);
          for (var o = this.m.visibleRange.from; o < this.m.visibleRange.to; o++) {
            var f = n[o];
            f.time !== r && (e.aboveBar = u, e.belowBar = u, r = f.time);
            var a = this.m.items[o];
            a.x = i.indexToCoordinate(f.time);
            var c = this.ti.dataAt(f.time);
            null !== c && oi(a, f, c, e, u, t, i, h.value);
          }
          this.o = !1;
        }
      }
    }, t;
  }(),
  ci = function (t) {
    function i(i) {
      return t.call(this, i) || this;
    }
    return u(i, t), i.prototype._updateImpl = function (t, i) {
      var n = this._lineRendererData;
      n.visible = !1;
      var s = this._series.options();
      if (s.priceLineVisible) {
        var h = this._series.lastValueData(void 0, 0 === s.priceLineSource);
        h.noData || (n.visible = !0, n.y = h.coordinate, n.color = this._series.priceLineColor(h.color), n.width = i, n.height = t, n.lineWidth = s.priceLineWidth, n.lineStyle = s.priceLineStyle);
      }
    }, i;
  }(Zt),
  li = function (t) {
    function i(i, n) {
      var s = t.call(this) || this;
      return s.k = i, s.m = n, s;
    }
    return u(i, t), i.prototype._getSource = function () {
      return this.k;
    }, i.prototype._getData = function () {
      return this.m;
    }, i.prototype._updateRendererData = function (t, i, n) {
      t.visible = !1, i.visible = !1;
      var s = this.k.options(),
        h = s.lastValueVisible,
        r = "" !== this.k.title(),
        u = 0 === s.seriesLastValueMode,
        e = this.k.lastValueData(void 0, !1);
      e.noData || (h && (t.text = this._axisText(e, h, u), t.visible = 0 !== t.text.length), (r || u) && (i.text = this._paneText(e, h, r, u), i.visible = i.text.length > 0), n.background = this.k.priceLineColor(e.color), n.color = W(n.background), n.coordinate = e.coordinate, i.borderColor = this.k.model().options().layout.backgroundColor, t.borderColor = n.background);
    }, i.prototype._paneText = function (t, i, n, s) {
      var h = "",
        r = this.k.title();
      return n && 0 !== r.length && (h += r + " "), i && s && (h += this.k.priceScale().isPercentage() ? t.formattedPriceAbsolute : t.formattedPricePercentage), h.trim();
    }, i.prototype._axisText = function (t, i, n) {
      return i ? n ? this.k.priceScale().isPercentage() ? t.formattedPricePercentage : t.formattedPriceAbsolute : t.text : "";
    }, i;
  }(K),
  vi = function (t) {
    function i(i, n) {
      var s = t.call(this, i) || this;
      return s.ii = n, s;
    }
    return u(i, t), i.prototype._updateImpl = function (t, i) {
      var n = this._lineRendererData;
      n.visible = !1;
      var s = this.ii.yCoord();
      if (null !== s) {
        var h = this.ii.options();
        n.visible = !0, n.y = s, n.color = h.color, n.width = i, n.height = t, n.lineWidth = h.lineWidth, n.lineStyle = h.lineStyle;
      }
    }, i;
  }(Zt),
  di = function (t) {
    function i(i, n) {
      var s = t.call(this) || this;
      return s.ti = i, s.ii = n, s;
    }
    return u(i, t), i.prototype._updateRendererData = function (t, i, n) {
      t.visible = !1, i.visible = !1;
      var s = this.ii.options();
      if (s.axisLabelVisible) {
        var h = this.ii.yCoord();
        null !== h && (t.text = this.ti.priceScale().formatPriceAbsolute(s.price), t.visible = !0, n.background = s.color, n.color = W(s.color), n.coordinate = h);
      }
    }, i;
  }(K),
  Mi = function () {
    function t(t, i) {
      this.ti = t, this.$ = i, this.ni = new vi(t, this), this._t = new di(t, this);
    }
    return t.prototype.applyOptions = function (t) {
      v(this.$, t), this.update(), this.ti.model().lightUpdate();
    }, t.prototype.options = function () {
      return this.$;
    }, t.prototype.paneView = function () {
      return this.ni;
    }, t.prototype.priceAxisView = function () {
      return this._t;
    }, t.prototype.update = function () {
      this.ni.update(), this._t.update();
    }, t.prototype.yCoord = function () {
      var t = this.ti,
        i = t.priceScale();
      if (t.model().timeScale().isEmpty() || i.isEmpty()) return null;
      var n = t.firstValue();
      return null === n ? null : i.priceToCoordinate(this.$.price, n.value);
    }, t;
  }(),
  wi = function () {
    function t() {
      this.si = 0, this.hi = new Map(), this.ri = new Map();
    }
    return t.prototype.colorByIndex = function (t) {
      return a(this.ri.get(t));
    }, t.prototype.addColor = function (t) {
      var i = this.hi.get(t);
      return void 0 === i && (i = this.si++, this.hi.set(t, i), this.ri.set(i, t)), i;
    }, t.prototype.clear = function () {
      this.si = 0, this.hi.clear(), this.ri.clear();
    }, t.prototype.size = function () {
      return this.ri.size;
    }, t;
  }(),
  bi = {
    barColor: "",
    barBorderColor: "",
    barWickColor: ""
  },
  mi = function () {
    function t(t) {
      this.ti = t;
    }
    return t.prototype.barStyle = function (t, i) {
      var n = this.ti.seriesType(),
        s = this.ti.options();
      switch (n) {
        case "Line":
          return this.ui(s);
        case "Area":
          return this.ei(s);
        case "Bar":
          return this.oi(s, t, i);
        case "Candlestick":
          return this.fi(s, t, i);
        case "Histogram":
          return this.ai(s, t, i);
      }
      throw new Error("Unknown chart style");
    }, t.prototype.oi = function (t, i, n) {
      var s = _e({}, bi),
        h = t.upColor,
        r = t.downColor,
        u = h,
        o = r,
        f = c(this.ci(i, n)),
        a = l(f.value[0]) <= l(f.value[3]);
      return s.barColor = a ? h : r, s.barBorderColor = a ? u : o, s;
    }, t.prototype.fi = function (t, i, n) {
      var s = _e({}, bi),
        h = t.upColor,
        r = t.downColor,
        u = t.borderUpColor,
        o = t.borderDownColor,
        f = t.wickUpColor,
        a = t.wickDownColor,
        v = c(this.ci(i, n)),
        d = l(v.value[0]) <= l(v.value[3]);
      return s.barColor = d ? h : r, s.barBorderColor = d ? u : o, s.barWickColor = d ? f : a, s;
    }, t.prototype.ei = function (t) {
      return _e(_e({}, bi), {
        barColor: t.lineColor
      });
    }, t.prototype.ui = function (t) {
      return _e(_e({}, bi), {
        barColor: t.color
      });
    }, t.prototype.ai = function (t, i, n) {
      var s = _e({}, bi),
        h = c(this.ci(i, n)).value[4];
      if (null != h) {
        var r = c(this.ti.palette());
        s.barColor = r.colorByIndex(h);
      } else s.barColor = t.color;
      return s;
    }, t.prototype.li = function () {
      return this.ti.bars();
    }, t.prototype.ci = function (t, i) {
      return void 0 !== i ? i.value : this.li().valueAt(t);
    }, t;
  }();
!function (t) {
  t[t.NearestLeft = -1] = "NearestLeft", t[t.Exact = 0] = "Exact", t[t.NearestRight = 1] = "NearestRight";
}(fi || (fi = {}));
var pi,
  gi = function () {
    function t(t, i) {
      void 0 === t && (t = null), void 0 === i && (i = null), this.vi = [], this.di = 0, this.Mi = 0, this.wi = !1, this.bi = new Map(), this.mi = new Map(), this.pi = new Map(), this.gi = t || new Map(), this.yi = i;
    }
    return t.prototype.clear = function () {
      this.vi = [], this.di = 0, this.Mi = 0, this.wi = !1, this.bi.clear(), this.mi.clear(), this.pi.clear();
    }, t.prototype.first = function () {
      return this.size() > 0 ? this.vi[this.di] : null;
    }, t.prototype.last = function () {
      return this.size() > 0 ? this.vi[this.Mi - 1] : null;
    }, t.prototype.firstIndex = function () {
      return this.size() > 0 ? this.ki(this.di) : null;
    }, t.prototype.lastIndex = function () {
      return this.size() > 0 ? this.ki(this.Mi - 1) : null;
    }, t.prototype.size = function () {
      return this.Mi - this.di;
    }, t.prototype.isEmpty = function () {
      return 0 === this.size();
    }, t.prototype.contains = function (t) {
      return null !== this.Ni(t, 0);
    }, t.prototype.valueAt = function (t) {
      return this.search(t);
    }, t.prototype.add = function (t, i, n) {
      if (this.wi) return !1;
      var s = {
          index: t,
          value: n,
          time: i
        },
        h = this.Ni(t, 0);
      return this.mi.clear(), this.pi.clear(), null === h ? (this.vi.splice(this.Si(t), 0, s), this.di = 0, this.Mi = this.vi.length, !0) : (this.vi[h] = s, !1);
    }, t.prototype.search = function (t, i, n) {
      void 0 === i && (i = 0);
      var s = this.Ni(t, i, n);
      if (null === s) return null;
      var h = this.xi(s);
      return {
        index: this.ki(s),
        time: h.time,
        value: h.value
      };
    }, t.prototype.each = function (t) {
      for (var i = this.di; i < this.Mi; ++i) {
        if (t(this.ki(i), this.xi(i))) break;
      }
    }, t.prototype.range = function (i, n) {
      var s = new t(this.gi, this.yi);
      return s.vi = this.vi, s.di = this.Si(i), s.Mi = this.Di(n), s.wi = !0, s;
    }, t.prototype.minMaxOnRangeCached = function (t, i, n) {
      if (this.isEmpty()) return null;
      for (var s = null, h = 0, r = n; h < r.length; h++) {
        var u = r[h];
        s = yi(s, this.Ci(t, i, u));
      }
      return s;
    }, t.prototype.merge = function (t) {
      return this.wi ? null : 0 === t.length ? null : this.isEmpty() || t[t.length - 1].index < this.vi[0].index ? this.Ti(t) : t[0].index > this.vi[this.vi.length - 1].index ? this.Ei(t) : 1 === t.length && t[0].index === this.vi[this.vi.length - 1].index ? (this.Li(t[0]), t[0]) : this.Ai(t);
    }, t.prototype.remove = function (t) {
      if (this.wi) return null;
      var i = this.Ni(t, 1);
      if (null === i) return null;
      var n = this.vi.splice(i);
      return this.Mi = this.vi.length, this.bi.clear(), this.mi.clear(), this.pi.clear(), n.length > 0 ? n[0] : null;
    }, t.prototype.ki = function (t) {
      return this.vi[t].index;
    }, t.prototype.xi = function (t) {
      return this.vi[t];
    }, t.prototype.Ni = function (t, i, n) {
      var s = this.Bi(t);
      if (null === s && 0 !== i) switch (i) {
        case -1:
          return this.zi(t, n);
        case 1:
          return this.Vi(t, n);
        default:
          throw new TypeError("Unknown search mode");
      }
      if (!n || null === s || 0 === i) return s;
      switch (i) {
        case -1:
          return this.Fi(s);
        case 1:
          return this.Pi(s);
        default:
          throw new TypeError("Unknown search mode");
      }
    }, t.prototype.Pi = function (t) {
      for (var i = c(this.yi); t < this.Mi && i(this.xi(t).value);) t += 1;
      return t === this.Mi ? null : t;
    }, t.prototype.Fi = function (t) {
      for (var i = c(this.yi); t >= this.di && i(this.xi(t).value);) t -= 1;
      return t < this.di ? null : t;
    }, t.prototype.zi = function (t, i) {
      var n = this.Si(t);
      n > this.di && (n -= 1);
      var s = n !== this.Mi && this.ki(n) < t ? n : null;
      return i && null !== s ? this.Fi(s) : s;
    }, t.prototype.Vi = function (t, i) {
      var n = this.Di(t),
        s = n !== this.Mi && t < this.ki(n) ? n : null;
      return i && null !== s ? this.Pi(s) : s;
    }, t.prototype.Bi = function (t) {
      var i = this.Si(t);
      return i === this.Mi || t < this.vi[i].index ? null : i;
    }, t.prototype.Si = function (t) {
      return Dt(this.vi, t, function (t, i) {
        return t.index < i;
      }, this.di, this.Mi);
    }, t.prototype.Di = function (t) {
      return Ct(this.vi, t, function (t, i) {
        return i.index > t;
      }, this.di, this.Mi);
    }, t.prototype.Ii = function (t, i, n) {
      var s = null,
        h = this.gi.get(n.name);
      if (void 0 === h) throw new Error('Plot "' + n.name + '" is not registered');
      for (var r = t; r < i; r++) {
        var u = h(this.vi[r].value);
        null == u || Number.isNaN(u) || (null === s ? s = {
          min: u,
          max: u
        } : (u < s.min && (s.min = u), u > s.max && (s.max = u)));
      }
      return s;
    }, t.prototype.Oi = function (t) {
      var i = Math.floor(t.index / 30);
      this.bi.forEach(function (t) {
        return t.delete(i);
      });
    }, t.prototype.Ti = function (t) {
      return f(!this.wi, "collection should not be readonly"), f(0 !== t.length, "plotRows should not be empty"), this.mi.clear(), this.pi.clear(), this.bi.clear(), this.vi = t.concat(this.vi), this.di = 0, this.Mi = this.vi.length, t[0];
    }, t.prototype.Ei = function (t) {
      return f(!this.wi, "collection should not be readonly"), f(0 !== t.length, "plotRows should not be empty"), this.mi.clear(), this.pi.clear(), this.bi.clear(), this.vi = this.vi.concat(t), this.di = 0, this.Mi = this.vi.length, t[0];
    }, t.prototype.Li = function (t) {
      f(!this.isEmpty(), "plot list should not be empty"), f(this.vi[this.Mi - 1].index === t.index, "last row index should match new row index"), this.Oi(t), this.mi.delete(t.index), this.pi.delete(t.index), this.vi[this.Mi - 1] = t;
    }, t.prototype.Ai = function (t) {
      return f(0 !== t.length, "plot rows should not be empty"), this.mi.clear(), this.pi.clear(), this.bi.clear(), this.vi = function (t, i) {
        var n = function (t, i) {
            var n = t.length,
              s = i.length,
              h = n + s,
              r = 0,
              u = 0;
            for (; r < n && u < s;) t[r].index < i[u].index ? r++ : t[r].index > i[u].index ? u++ : (r++, u++, h--);
            return h;
          }(t, i),
          s = new Array(n),
          h = 0,
          r = 0,
          u = t.length,
          e = i.length,
          o = 0;
        for (; h < u && r < e;) t[h].index < i[r].index ? (s[o] = t[h], h++) : t[h].index > i[r].index ? (s[o] = i[r], r++) : (s[o] = i[r], h++, r++), o++;
        for (; h < u;) s[o] = t[h], h++, o++;
        for (; r < e;) s[o] = i[r], r++, o++;
        return s;
      }(this.vi, t), this.di = 0, this.Mi = this.vi.length, t[0];
    }, t.prototype.Ci = function (t, i, n) {
      if (this.isEmpty()) return null;
      var s = null,
        h = c(this.firstIndex()),
        r = c(this.lastIndex()),
        u = t - n.offset,
        e = i - n.offset;
      u = Math.max(u, h), e = Math.min(e, r);
      var o = 30 * Math.ceil(u / 30),
        f = Math.max(o, 30 * Math.floor(e / 30)),
        a = this.Si(u),
        l = this.Di(Math.min(e, o, i));
      s = yi(s, this.Ii(a, l, n));
      var v = this.bi.get(n.name);
      void 0 === v && (v = new Map(), this.bi.set(n.name, v));
      for (var d = Math.max(o + 1, u); d < f; d += 30) {
        var M = Math.floor(d / 30),
          w = v.get(M);
        if (void 0 === w) {
          var b = this.Si(30 * M),
            m = this.Di(30 * (M + 1) - 1);
          w = this.Ii(b, m, n), v.set(M, w);
        }
        s = yi(s, w);
      }
      a = this.Si(f), l = this.Di(e);
      return s = yi(s, this.Ii(a, l, n));
    }, t;
  }();
function yi(t, i) {
  return null === t ? i : null === i ? t : {
    min: Math.min(t.min, i.min),
    max: Math.max(t.max, i.max)
  };
}
!function (t) {
  t[t.Open = 0] = "Open", t[t.High = 1] = "High", t[t.Low = 2] = "Low", t[t.Close = 3] = "Close", t[t.Color = 4] = "Color";
}(pi || (pi = {}));
var ki = {
    open: function open(t) {
      return t[0];
    },
    high: function high(t) {
      return t[1];
    },
    low: function low(t) {
      return t[2];
    },
    close: function close(t) {
      return t[3];
    },
    hl2: function hl2(t) {
      return (t[1] + t[2]) / 2;
    },
    hlc3: function hlc3(t) {
      return (t[1] + t[2] + t[3]) / 3;
    },
    ohlc4: function ohlc4(t) {
      return (t[0] + t[1] + t[2] + t[3]) / 4;
    }
  },
  Ni = ["open", "high", "low", "close", "hl2", "hlc3", "ohlc4"];
function Si(t) {
  return ki[t];
}
var xi,
  Di = function () {
    function t() {
      var t;
      this.Ri = new gi((t = new Map(), Ni.forEach(function (i, n) {
        t.set(i, Si(i));
      }), t));
    }
    return t.prototype.bars = function () {
      return this.Ri;
    }, t.prototype.size = function () {
      return this.Ri.size();
    }, t.prototype.each = function (t) {
      this.Ri.each(t);
    }, t.prototype.clear = function () {
      this.Ri.clear();
    }, t.prototype.isEmpty = function () {
      return this.Ri.isEmpty();
    }, t.prototype.first = function () {
      return this.Ri.first();
    }, t.prototype.last = function () {
      return this.Ri.last();
    }, t.prototype.search = function (t, i) {
      return this.bars().search(t, i);
    }, t.prototype.valueAt = function (t) {
      return this.search(t);
    }, t;
  }(),
  Ci = function (t) {
    function i(i, n, s) {
      var h = t.call(this, i) || this;
      h.m = new Di(), h.ni = new ci(h), h.Wi = [], h.Ui = new Jt(h), h.qi = !1, h.ji = null, h.Hi = new wi(), h.Yi = [], h.Ki = [], h.$ = n, h.$i = s;
      var r = new li(h, {
        model: i
      });
      return h.U = [r], h._i = new _t(r, h, i), h.Xi(), h.Zi(), h.Ji = h.barFunction(), h.Gi(), h;
    }
    return u(i, t), i.prototype.destroy = function () {}, i.prototype.endOfData = function () {
      return this.qi;
    }, i.prototype.priceLineColor = function (t) {
      return this.$.priceLineColor || t;
    }, i.prototype.lastValueData = function (t, i, n) {
      var s = {
          noData: !0
        },
        h = this.priceScale();
      if (this.model().timeScale().isEmpty() || h.isEmpty() || this.data().isEmpty()) return s;
      var r,
        u,
        e = this.model().timeScale().visibleBars(),
        o = this.firstValue();
      if (null === e || null === o) return s;
      if (i) {
        var f = this.data().bars().last();
        if (null === f) return s;
        r = f, u = f.index;
      } else {
        var a = this.data().bars().search(e.lastBar(), -1);
        if (null === a) return s;
        if (null === (r = this.data().bars().valueAt(a.index))) return s;
        u = a.index;
      }
      var c = void 0 !== t ? r.value[t] : this.Ji(r.value),
        l = this.barColorer().barStyle(u, {
          value: r
        }),
        v = h.priceToCoordinate(c, o.value);
      return {
        noData: !1,
        price: n ? c : void 0,
        text: h.formatPrice(c, o.value),
        formattedPriceAbsolute: h.formatPriceAbsolute(c),
        formattedPricePercentage: h.formatPricePercentage(c, o.value),
        color: l.barColor,
        coordinate: v,
        index: u
      };
    }, i.prototype.data = function () {
      return this.m;
    }, i.prototype.barColorer = function () {
      return null !== this.ji ? this.ji : (this.ji = new mi(this), this.ji);
    }, i.prototype.options = function () {
      return this.$;
    }, i.prototype.applyOptions = function (t) {
      var i = this.$.overlay;
      v(this.$, t), this.$.overlay = i, i && null !== this._priceScale && void 0 !== t.scaleMargins && this._priceScale.applyOptions({
        scaleMargins: this.$.scaleMargins
      }), void 0 !== t.priceFormat && this.Xi(), this.model().updateSource(this);
    }, i.prototype.clearData = function () {
      this.m.clear(), this.Hi.clear(), this.Gi();
    }, i.prototype.updateData = function (t, i) {
      void 0 === i && (i = !1), i && this.m.clear(), this.m.bars().merge(t), this.Qi(), this.J.update("data"), this._.update("data");
      var n = this.model().paneForSource(this);
      this.model().recalculatePane(n), this.model().updateSource(this), this.model().updateCrosshair(), this.model().lightUpdate();
    }, i.prototype.setMarkers = function (t) {
      this.Yi = t.map(function (t) {
        return _e({}, t);
      }), this.Qi();
      var i = this.model().paneForSource(this);
      this._.update("data"), this.model().recalculatePane(i), this.model().updateSource(this), this.model().updateCrosshair(), this.model().lightUpdate();
    }, i.prototype.markers = function () {
      return this.Yi;
    }, i.prototype.indexedMarkers = function () {
      return this.Ki;
    }, i.prototype.createPriceLine = function (t) {
      var i = new Mi(this, t);
      return this.Wi.push(i), this.model().updateSource(this), i;
    }, i.prototype.removePriceLine = function (t) {
      var i = this.Wi.indexOf(t);
      -1 !== i && this.Wi.splice(i, 1), this.model().updateSource(this);
    }, i.prototype.palette = function () {
      return this.Hi;
    }, i.prototype.seriesType = function () {
      return this.$i;
    }, i.prototype.firstValue = function () {
      var t = this.firstBar();
      return null === t ? null : {
        value: this.Ji(t.value),
        timePoint: t.time
      };
    }, i.prototype.firstBar = function () {
      var t = this.model().timeScale().visibleBars();
      if (null === t) return null;
      var i = t.firstBar();
      return this.data().search(i, 1);
    }, i.prototype.bars = function () {
      return this.m.bars();
    }, i.prototype.nearestIndex = function (t, i) {
      var n = this.nearestData(t, i);
      return n ? n.index : null;
    }, i.prototype.nearestData = function (t, i) {
      return M(t) ? this.data().search(t, i) : null;
    }, i.prototype.dataAt = function (t) {
      var i = this.data().valueAt(t);
      return null === i ? null : "Bar" === this.$i || "Candlestick" === this.$i ? {
        open: i.value[0],
        high: i.value[1],
        low: i.value[2],
        close: i.value[3]
      } : this.barFunction()(i.value);
    }, i.prototype.paneViews = function () {
      var t = [];
      this.priceScale() === this.model().mainPriceScale() && t.push(this.Ui);
      for (var i = 0, n = this.Wi; i < n.length; i++) {
        var s = n[i];
        t.push(s.paneView());
      }
      return t.push(this.J), t.push(this.ni), t.push(this._i), t.push(this._), t;
    }, i.prototype.priceAxisViews = function (t, i) {
      for (var n = o(this.U), s = 0, h = this.Wi; s < h.length; s++) {
        var r = h[s];
        n.push(r.priceAxisView());
      }
      return n;
    }, i.prototype.autoscaleInfo = function (t, i) {
      if (!M(t) || !M(i) || this.data().isEmpty()) return null;
      var n,
        s = "Line" === this.$i || "Area" === this.$i || "Histogram" === this.$i ? "close" : null,
        h = null !== (n = null !== s ? this.data().bars().minMaxOnRangeCached(t, i, [{
          name: s,
          offset: 0
        }]) : this.data().bars().minMaxOnRangeCached(t, i, [{
          name: "low",
          offset: 0
        }, {
          name: "high",
          offset: 0
        }])) ? new et(n.min, n.max) : null;
      if ("Histogram" === this.seriesType()) {
        var r = this.$.base,
          u = new et(r, r);
        h = null !== h ? h.merge(u) : u;
      }
      return {
        priceRange: h,
        margins: this._.autoScaleMargins()
      };
    }, i.prototype.minMove = function () {
      return this.$.priceFormat.minMove;
    }, i.prototype.formatter = function () {
      return this.tn;
    }, i.prototype.barFunction = function () {
      return this.Ji;
    }, i.prototype.updateAllViews = function () {
      this.J.update(), this._.update();
      for (var t = 0, i = this.U; t < i.length; t++) {
        i[t].update();
      }
      for (var n = 0, s = this.Wi; n < s.length; n++) {
        s[n].update();
      }
      this.ni.update(), this.Ui.update();
    }, i.prototype.setPriceScale = function (t) {
      this._priceScale !== t && (this._priceScale = t);
    }, i.prototype.priceScale = function () {
      return c(this._priceScale);
    }, i.prototype.markerDataAtIndex = function (t) {
      if (!(("Line" === this.$i || "Area" === this.$i) && this.$.crosshairMarkerVisible)) return null;
      var i = this.m.valueAt(t);
      return null === i ? null : {
        price: this.Ji(i.value),
        radius: this.in()
      };
    }, i.prototype.title = function () {
      return this.$.title;
    }, i.prototype.in = function () {
      switch (this.$i) {
        case "Line":
        case "Area":
          return this.$.crosshairMarkerRadius;
      }
      return 0;
    }, i.prototype.Xi = function () {
      switch (this.$.priceFormat.type) {
        case "custom":
          this.tn = {
            format: this.$.priceFormat.formatter
          };
          break;
        case "volume":
          this.tn = new kt(this.$.priceFormat.precision);
          break;
        case "percent":
          this.tn = new ht(this.$.priceFormat.precision);
          break;
        default:
          var t = Math.pow(10, this.$.priceFormat.precision);
          this.tn = new st(t, this.$.priceFormat.minMove * t, !1, void 0);
      }
      null !== this._priceScale && this._priceScale.updateFormatter();
    }, i.prototype.Zi = function () {
      this.Ji = Si("close");
    }, i.prototype.Qi = function () {
      var t = this.model().timeScale().points();
      this.Ki = this.Yi.map(function (i, n) {
        return {
          time: c(t.indexOf(i.time.timestamp, !0)),
          position: i.position,
          shape: i.shape,
          color: i.color,
          id: i.id,
          internalId: n
        };
      });
    }, i.prototype.Gi = function () {
      switch (this._ = new ai(this, this.model()), this.$i) {
        case "Bar":
          this.J = new It(this, this.model());
          break;
        case "Candlestick":
          this.J = new Rt(this, this.model());
          break;
        case "Line":
          this.J = new Ht(this, this.model());
          break;
        case "Area":
          this.J = new zt(this, this.model());
          break;
        case "Histogram":
          this.J = new jt(this, this.model());
          break;
        default:
          throw Error("Unknown chart style assigned: " + this.$i);
      }
    }, i;
  }(ut);
function Ti(t) {
  return t.slice().sort(function (t, i) {
    return c(t.zorder()) - c(i.zorder());
  });
}
!function (t) {
  t[t.Normal = 0] = "Normal", t[t.Logarithmic = 1] = "Logarithmic", t[t.Percentage = 2] = "Percentage", t[t.IndexedTo100 = 3] = "IndexedTo100";
}(xi || (xi = {}));
var Ei,
  Li,
  Ai = new ht(),
  Bi = new st(100, 1),
  zi = function () {
    function t(t, i, n) {
      this.nn = 0, this.sn = null, this.hn = new rt(), this.rn = null, this.un = null, this.en = new rt(), this.on = {
        isValid: !1,
        visibleBars: null
      }, this.fn = 0, this.an = 0, this.cn = new rt(), this.ln = new rt(), this.vn = [], this.dn = null, this.Mn = !1, this.wn = null, this.bn = null, this.mn = null, this.pn = null, this.tn = Bi, this.gn = new rt(), this.$ = t, this.yn = i, this.kn = n, this.Nn = new yt(this, 100, this.Sn.bind(this), this.xn.bind(this));
    }
    return t.prototype.options = function () {
      return this.$;
    }, t.prototype.applyOptions = function (t) {
      if (v(this.$, t), this.updateFormatter(), void 0 !== t.mode && this.setMode({
        mode: t.mode
      }), this.gn.fire(), void 0 !== t.scaleMargins) {
        var i = a(t.scaleMargins.top),
          n = a(t.scaleMargins.bottom);
        if (i < 0 || i > 1) throw new Error("Invalid top margin - expect value between 0 and 1, given=" + i);
        if (n < 0 || n > 1 || i + n > 1) throw new Error("Invalid bottom margin - expect value between 0 and 1, given=" + n);
        if (i + n > 1) throw new Error("Invalid margins - sum of margins must be less than 1, given=" + (i + n));
        this.Dn(), this.bn = null;
      }
    }, t.prototype.optionsChanged = function () {
      return this.gn;
    }, t.prototype.isAutoScale = function () {
      return this.$.autoScale;
    }, t.prototype.isLog = function () {
      return 1 === this.$.mode;
    }, t.prototype.isPercentage = function () {
      return 2 === this.$.mode;
    }, t.prototype.isIndexedTo100 = function () {
      return 3 === this.$.mode;
    }, t.prototype.mode = function () {
      return {
        autoScale: this.$.autoScale,
        isInverted: this.$.invertScale,
        mode: this.$.mode
      };
    }, t.prototype.setMode = function (t) {
      var i = this.mode(),
        n = null;
      void 0 !== t.autoScale && (this.$.autoScale = t.autoScale), void 0 !== t.mode && (this.$.mode = t.mode, 2 !== t.mode && 3 !== t.mode || (this.$.autoScale = !0), this.on.isValid = !1), 1 === i.mode && t.mode !== i.mode && (!function (t) {
        if (null === t) return !1;
        var i = mt(t.minValue()),
          n = mt(t.maxValue());
        return isFinite(i) && isFinite(n);
      }(this.rn) ? this.$.autoScale = !0 : null !== (n = function (t) {
        if (null === t) return null;
        var i = mt(t.minValue()),
          n = mt(t.maxValue());
        return new et(i, n);
      }(this.rn)) && this.setPriceRange(n)), 1 === t.mode && t.mode !== i.mode && null !== (n = pt(this.rn)) && this.setPriceRange(n);
      var s = i.mode !== this.$.mode;
      s && (2 === i.mode || this.isPercentage()) && this.updateFormatter(), s && (3 === i.mode || this.isIndexedTo100()) && this.updateFormatter(), void 0 !== t.isInverted && i.isInverted !== t.isInverted && (this.$.invertScale = t.isInverted, this.Cn()), this.ln.fire(i, this.mode());
    }, t.prototype.modeChanged = function () {
      return this.ln;
    }, t.prototype.fontSize = function () {
      return this.yn.fontSize;
    }, t.prototype.height = function () {
      return this.nn;
    }, t.prototype.setHeight = function (t) {
      this.nn !== t && (this.nn = t, this.Dn(), this.bn = null);
    }, t.prototype.internalHeight = function () {
      if (this.sn) return this.sn;
      var t = this.height() - this.Tn() - this.En();
      return this.sn = t, t;
    }, t.prototype.internalHeightChanged = function () {
      return this.hn;
    }, t.prototype.priceRange = function () {
      return this.Ln(), this.rn;
    }, t.prototype.priceRangeChanged = function () {
      return this.en;
    }, t.prototype.setPriceRange = function (t, i, n) {
      var s = this.rn;
      (i || null === s && null !== t || null !== s && !s.equals(t)) && (this.bn = null, this.rn = t, n || this.en.fire(s, t));
    }, t.prototype.isEmpty = function () {
      return this.Ln(), 0 === this.nn || !this.rn || this.rn.isEmpty();
    }, t.prototype.invertedCoordinate = function (t) {
      return this.isInverted() ? t : this.height() - 1 - t;
    }, t.prototype.priceToCoordinate = function (t, i) {
      return this.isPercentage() ? t = vt(t, i) : this.isIndexedTo100() && (t = Mt(t, i)), this.xn(t, i);
    }, t.prototype.pointsArrayToCoordinates = function (t, i, n) {
      this.Ln();
      for (var s = this.En(), h = c(this.priceRange()), r = h.minValue(), u = h.maxValue(), e = this.internalHeight() - 1, o = this.isInverted(), f = e / (u - r), a = void 0 === n ? 0 : n.from, l = void 0 === n ? t.length : n.to, v = this.An(), d = a; d < l; d++) {
        var M = t[d],
          w = M.price;
        if (!isNaN(w)) {
          var b = w;
          null !== v && (b = v(M.price, i));
          var m = s + f * (b - r),
            p = o ? m : this.nn - 1 - m;
          M.y = p;
        }
      }
    }, t.prototype.barPricesToCoordinates = function (t, i, n) {
      this.Ln();
      for (var s = this.En(), h = c(this.priceRange()), r = h.minValue(), u = h.maxValue(), e = this.internalHeight() - 1, o = this.isInverted(), f = e / (u - r), a = void 0 === n ? 0 : n.from, l = void 0 === n ? t.length : n.to, v = this.An(), d = a; d < l; d++) {
        var M = t[d],
          w = M.open,
          b = M.high,
          m = M.low,
          p = M.close;
        null !== v && (w = v(M.open, i), b = v(M.high, i), m = v(M.low, i), p = v(M.close, i));
        var g = s + f * (w - r),
          y = o ? g : this.nn - 1 - g;
        M.openY = y, g = s + f * (b - r), y = o ? g : this.nn - 1 - g, M.highY = y, g = s + f * (m - r), y = o ? g : this.nn - 1 - g, M.lowY = y, g = s + f * (p - r), y = o ? g : this.nn - 1 - g, M.closeY = y;
      }
    }, t.prototype.coordinateToPrice = function (t, i) {
      var n = this.Sn(t, i);
      return this.logicalToPrice(n, i);
    }, t.prototype.logicalToPrice = function (t, i) {
      var n = t;
      return this.isPercentage() ? n = function (t, i) {
        return i < 0 && (t = -t), t / 100 * i + i;
      }(n, i) : this.isIndexedTo100() && (n = function (t, i) {
        return t -= 100, i < 0 && (t = -t), t / 100 * i + i;
      }(n, i)), n;
    }, t.prototype.dataSources = function () {
      return this.vn;
    }, t.prototype.orderedSources = function () {
      if (this.dn) return this.dn;
      for (var t = [], i = 0; i < this.vn.length; i++) {
        var n = this.vn[i];
        null === n.zorder() && n.setZorder(i + 1), t.push(n);
      }
      return t = Ti(t), this.dn = t, this.dn;
    }, t.prototype.hasSeries = function () {
      return this.Mn;
    }, t.prototype.addDataSource = function (t) {
      -1 === this.vn.indexOf(t) && (t instanceof Ci && (this.Mn = !0), this.vn.push(t), this.wn = null, this.updateFormatter(), this.invalidateSourcesCache());
    }, t.prototype.removeDataSource = function (t) {
      var i = this.vn.indexOf(t);
      if (-1 === i) throw new Error("source is not attached to scale");
      this.vn.splice(i, 1), t instanceof Ci && (this.Mn = !1), this.mainSource() || this.setMode({
        autoScale: !0
      }), this.wn = null, this.updateFormatter(), this.invalidateSourcesCache();
    }, t.prototype.mainSource = function () {
      if (null !== this.wn) return this.wn;
      for (var t = null, i = 0; i < this.vn.length; i++) {
        var n = this.vn[i];
        if (n instanceof Ci) {
          t = n;
          break;
        }
        null === t && n instanceof ut && (t = n);
      }
      return this.wn = t, this.wn;
    }, t.prototype.firstValue = function () {
      for (var t = null, i = 0, n = this.vn; i < n.length; i++) {
        var s = n[i];
        if (s instanceof ut) {
          var h = s.firstValue();
          if (null === h) continue;
          (null === t || h.timePoint < t.timePoint) && (t = h);
        }
      }
      return null === t ? null : t.value;
    }, t.prototype.isInverted = function () {
      return this.$.invertScale;
    }, t.prototype.marks = function () {
      return this.bn ? this.bn : (this.Nn.rebuildTickMarks(), this.bn = this.Nn.marks(), this.cn.fire(), this.bn);
    }, t.prototype.onMarksChanged = function () {
      return this.cn;
    }, t.prototype.startScale = function (t) {
      this.isPercentage() || this.isIndexedTo100() || null === this.mn && null === this.un && (this.isEmpty() || (this.mn = this.nn - t, this.un = c(this.priceRange()).clone()));
    }, t.prototype.scaleTo = function (t) {
      if (!this.isPercentage() && !this.isIndexedTo100() && null !== this.mn) {
        this.setMode({
          autoScale: !1
        }), (t = this.nn - t) < 0 && (t = 0);
        var i = (this.mn + .2 * (this.nn - 1)) / (t + .2 * (this.nn - 1)),
          n = c(this.un).clone();
        i = Math.max(i, .1), n.scaleAroundCenter(i), this.setPriceRange(n);
      }
    }, t.prototype.endScale = function () {
      this.isPercentage() || this.isIndexedTo100() || (this.mn = null, this.un = null);
    }, t.prototype.startScroll = function (t) {
      this.isAutoScale() || null === this.pn && null === this.un && (this.isEmpty() || (this.pn = t, this.un = c(this.priceRange()).clone()));
    }, t.prototype.scrollTo = function (t) {
      if (!this.isAutoScale() && null !== this.pn) {
        var i = c(this.priceRange()).length() / (this.internalHeight() - 1),
          n = t - this.pn;
        this.isInverted() && (n *= -1);
        var s = n * i,
          h = c(this.un).clone();
        h.shift(s), this.setPriceRange(h, !0), this.bn = null;
      }
    }, t.prototype.endScroll = function () {
      this.isAutoScale() || null !== this.pn && (this.pn = null, this.un = null);
    }, t.prototype.formatter = function () {
      return this.tn || this.updateFormatter(), this.tn;
    }, t.prototype.formatPrice = function (t, i) {
      switch (this.$.mode) {
        case 2:
          return this.formatter().format(vt(t, i));
        case 3:
          return this.formatter().format(Mt(t, i));
        default:
          return this.Bn(t);
      }
    }, t.prototype.formatLogical = function (t) {
      switch (this.$.mode) {
        case 2:
        case 3:
          return this.formatter().format(t);
        default:
          return this.Bn(t);
      }
    }, t.prototype.formatPriceAbsolute = function (t) {
      return this.Bn(t, this.zn());
    }, t.prototype.formatPricePercentage = function (t, i) {
      return t = vt(t, i), Ai.format(t);
    }, t.prototype.sourcesForAutoScale = function () {
      return this.vn.filter(function (t) {
        return t instanceof ut;
      });
    }, t.prototype.recalculatePriceRange = function (t) {
      this.on = {
        visibleBars: t,
        isValid: !1
      };
    }, t.prototype.updateAllViews = function () {
      this.vn.forEach(function (t) {
        return t.updateAllViews();
      });
    }, t.prototype.updateFormatter = function () {
      this.bn = null;
      var t = this.mainSource(),
        i = 100;
      null !== t && (i = Math.round(1 / t.minMove())), this.tn = Bi, this.isPercentage() ? (this.tn = Ai, i = 100) : this.isIndexedTo100() ? (this.tn = new st(100, 1), i = 100) : null !== t && (this.tn = t.formatter()), this.Nn = new yt(this, i, this.Sn.bind(this), this.xn.bind(this)), this.Nn.rebuildTickMarks();
    }, t.prototype.invalidateSourcesCache = function () {
      this.dn = null;
    }, t.prototype.Tn = function () {
      return this.isInverted() ? this.$.scaleMargins.bottom * this.height() + this.an : this.$.scaleMargins.top * this.height() + this.fn;
    }, t.prototype.En = function () {
      return this.isInverted() ? this.$.scaleMargins.top * this.height() + this.fn : this.$.scaleMargins.bottom * this.height() + this.an;
    }, t.prototype.Ln = function () {
      this.on.isValid || (this.on.isValid = !0, this.Vn());
    }, t.prototype.Dn = function () {
      this.sn = null, this.hn.fire();
    }, t.prototype.xn = function (t, i) {
      if (this.Ln(), this.isEmpty()) return 0;
      t = this.isLog() && t ? bt(t) : t;
      var n = c(this.priceRange()),
        s = this.En() + (this.internalHeight() - 1) * (t - n.minValue()) / n.length();
      return this.invertedCoordinate(s);
    }, t.prototype.Sn = function (t, i) {
      if (this.Ln(), this.isEmpty()) return 0;
      var n = this.invertedCoordinate(t),
        s = c(this.priceRange()),
        h = s.minValue() + s.length() * ((n - this.En()) / (this.internalHeight() - 1));
      return this.isLog() ? mt(h) : h;
    }, t.prototype.Cn = function () {
      this.bn = null, this.Nn.rebuildTickMarks();
    }, t.prototype.zn = function () {
      return c(this.mainSource()).formatter();
    }, t.prototype.Vn = function () {
      var t = this.on.visibleBars;
      if (null !== t) {
        for (var i = null, n = 0, s = 0, h = 0, r = this.sourcesForAutoScale(); h < r.length; h++) {
          var u = r[h],
            e = u.firstValue();
          if (null !== e) {
            var o = u.autoscaleInfo(t.firstBar(), t.lastBar()),
              f = o && o.priceRange;
            if (null !== f) {
              switch (this.$.mode) {
                case 1:
                  f = pt(f);
                  break;
                case 2:
                  f = dt(f, e.value);
                  break;
                case 3:
                  f = wt(f, e.value);
              }
              i = null === i ? f : i.merge(c(f)), null !== o && null !== o.margins && (n = Math.max(n, o.margins.above), s = Math.max(n, o.margins.below));
            }
          }
        }
        if (n === this.fn && s === this.an || (this.fn = n, this.an = s, this.bn = null, this.Dn()), null !== i) {
          if (i.minValue() === i.maxValue()) {
            var a = this.mainSource(),
              l = 5 * (null === a || this.isPercentage() || this.isIndexedTo100() ? 1 : a.minMove());
            i = new et(i.minValue() - l, i.maxValue() + l);
          }
          this.setPriceRange(i);
        } else null === this.rn && this.setPriceRange(new et(-.5, .5));
        this.on.isValid = !0;
      }
    }, t.prototype.An = function () {
      return this.isPercentage() ? vt : this.isIndexedTo100() ? Mt : this.isLog() ? bt : null;
    }, t.prototype.Bn = function (t, i) {
      return void 0 === this.kn.priceFormatter ? (void 0 === i && (i = this.formatter()), i.format(t)) : this.kn.priceFormatter(t);
    }, t;
  }();
function Vi(t) {
  void 0 !== t.borderColor && (t.borderUpColor = t.borderColor, t.borderDownColor = t.borderColor), void 0 !== t.wickColor && (t.wickUpColor = t.wickColor, t.wickDownColor = t.wickColor);
}
function Fi(t) {
  return !d(t) && !w(t);
}
function Pi(t) {
  return d(t);
}
!function (t) {
  t[t.LastPriceAndPercentageValue = 0] = "LastPriceAndPercentageValue", t[t.LastValueAccordingToScale = 1] = "LastValueAccordingToScale";
}(Ei || (Ei = {})), function (t) {
  t[t.LastBar = 0] = "LastBar", t[t.LastVisible = 1] = "LastVisible";
}(Li || (Li = {}));
var Ii;
function Oi(t, i, n) {
  return void 0 !== n ? n += " " : n = "", void 0 === i && (i = "'Trebuchet MS', Roboto, Ubuntu, sans-serif"), "" + n + t + "px " + i;
}
!function (t) {
  t[t.BorderSize = 1] = "BorderSize", t[t.TickLength = 4] = "TickLength";
}(Ii || (Ii = {}));
var Ri,
  Wi = function () {
    function t(t) {
      this.Ht = {
        borderSize: 1,
        tickLength: 4,
        fontSize: NaN,
        font: "",
        fontFamily: "",
        color: "",
        paddingBottom: 0,
        paddingInner: 0,
        paddingOuter: 0,
        paddingTop: 0,
        baselineOffset: 0
      }, this.l = t;
    }
    return t.prototype.options = function () {
      var t = this.Ht,
        i = this.Zt(),
        n = this.Fn();
      return t.fontSize === i && t.fontFamily === n || (t.fontSize = i, t.fontFamily = n, t.font = Oi(i, n), t.paddingTop = Math.floor(i / 3.5), t.paddingBottom = t.paddingTop, t.paddingInner = Math.max(Math.ceil(i / 2 - t.tickLength / 2), 0), t.paddingOuter = Math.ceil(i / 2 + t.tickLength / 2), t.baselineOffset = Math.round(i / 10)), t.color = this.Pn(), this.Ht;
    }, t.prototype.Pn = function () {
      return this.l.options().layout.textColor;
    }, t.prototype.Zt = function () {
      return this.l.options().layout.fontSize;
    }, t.prototype.Fn = function () {
      return this.l.options().layout.fontFamily;
    }, t;
  }(),
  Ui = function () {
    function t() {
      this.m = null;
    }
    return t.prototype.setData = function (t) {
      this.m = t;
    }, t.prototype.draw = function (t, i, n, h) {
      var r = this;
      if (null !== this.m) {
        var u = Math.floor(i);
        t.lineWidth = u;
        var e = Math.ceil(this.m.h * i),
          o = Math.ceil(this.m.w * i);
        !function (t, i) {
          t.save(), t.lineWidth % 2 && t.translate(.5, .5), i(), t.restore();
        }(t, function () {
          var n = c(r.m);
          if (n.vertLinesVisible) {
            t.strokeStyle = n.vertLinesColor, s(t, n.vertLineStyle), t.beginPath();
            for (var h = 0, f = n.timeMarks; h < f.length; h++) {
              var a = f[h],
                l = Math.round(a.coord * i);
              t.moveTo(l, -u), t.lineTo(l, e + u);
            }
            t.stroke();
          }
          if (n.horzLinesVisible) {
            t.strokeStyle = n.horzLinesColor, s(t, n.horzLineStyle), t.beginPath();
            for (var v = 0, d = n.priceMarks; v < d.length; v++) {
              var M = d[v],
                w = Math.round(M.coord * i);
              t.moveTo(-u, w), t.lineTo(o + u, w);
            }
            t.stroke();
          }
        });
      }
    }, t;
  }(),
  qi = function () {
    function t(t) {
      this.g = new Ui(), this.o = !0, this.I = t;
    }
    return t.prototype.update = function () {
      this.o = !0;
    }, t.prototype.renderer = function (t, i) {
      if (this.o) {
        var n = this.I.model().options().grid,
          s = {
            h: t,
            w: i,
            horzLinesVisible: n.horzLines.visible,
            vertLinesVisible: n.vertLines.visible,
            horzLinesColor: n.horzLines.color,
            vertLinesColor: n.vertLines.color,
            horzLineStyle: n.horzLines.style,
            vertLineStyle: n.vertLines.style,
            priceMarks: this.I.defaultPriceScale().marks(),
            timeMarks: this.I.model().timeScale().marks() || []
          };
        this.g.setData(s), this.o = !1;
      }
      return this.g;
    }, t;
  }(),
  ji = function () {
    function t() {
      this.In = new WeakMap(), this.o = !0;
    }
    return t.prototype.paneViews = function (t) {
      var i = this.In.get(t);
      return void 0 === i && (i = [new qi(t)], this.In.set(t, i)), this.o && (i.forEach(function (t) {
        return t.update();
      }), this.o = !1), i;
    }, t.prototype.invalidate = function () {
      this.o = !0;
    }, t;
  }();
!function (t) {
  t[t.None = 0] = "None", t[t.Cursor = 1] = "Cursor", t[t.Light = 2] = "Light", t[t.Full = 3] = "Full";
}(Ri || (Ri = {}));
var Hi = function () {
    function t(t) {
      this.On = new Map(), this.Rn = !1, this.Wn = !1, this.Un = null, this.qn = t;
    }
    return t.prototype.invalidatePane = function (t, i) {
      var n = function (t, i) {
        return void 0 === t ? i : {
          level: Math.max(t.level, i.level),
          autoScale: t.autoScale || i.autoScale
        };
      }(this.On.get(t), i);
      this.On.set(t, n);
    }, t.prototype.invalidateAll = function (t) {
      this.qn = Math.max(this.qn, t);
    }, t.prototype.fullInvalidation = function () {
      return this.qn;
    }, t.prototype.invalidateForPane = function (t) {
      var i = this.On.get(t);
      return void 0 === i ? {
        level: this.qn
      } : {
        level: Math.max(this.qn, i.level),
        autoScale: i.autoScale
      };
    }, t.prototype.setFitContent = function () {
      this.Wn = !0, this.Un = null;
    }, t.prototype.getFitContent = function () {
      return this.Wn;
    }, t.prototype.setTargetTimeRange = function (t) {
      this.Un = t, this.Wn = !1;
    }, t.prototype.getTargetTimeRange = function () {
      return this.Un;
    }, t.prototype.merge = function (t) {
      var i = this;
      this.Rn = this.Rn || t.Rn, t.Wn && this.setFitContent(), t.Un && this.setTargetTimeRange(t.Un), this.qn = Math.max(this.qn, t.qn), t.On.forEach(function (t, n) {
        i.invalidatePane(n, t);
      });
    }, t;
  }(),
  Yi = function () {
    function t(t) {
      this.$ = t;
    }
    return t.prototype.align = function (t, i, n) {
      var s = t;
      if (0 === this.$.mode) return s;
      var h = n.defaultPriceScale(),
        r = h.firstValue();
      if (null === r) return s;
      var u = h.priceToCoordinate(t, r),
        e = n.dataSources().filter(function (t) {
          return t instanceof Ci;
        }).reduce(function (t, s) {
          if (n.isOverlay(s)) return t;
          var h = s.priceScale(),
            r = s.bars();
          if (h.isEmpty() || !r.contains(i)) return t;
          var u = r.valueAt(i);
          if (null === u) return t;
          var e = [u.value[3]],
            o = l(s.firstValue());
          return t.concat(e.map(function (t) {
            return h.priceToCoordinate(t, o.value);
          }));
        }, []);
      if (0 === e.length) return s;
      e.sort(function (t, i) {
        return Math.abs(t - u) - Math.abs(i - u);
      });
      var o = e[0];
      return s = h.coordinateToPrice(o, r);
    }, t;
  }(),
  Ki = function () {
    function t(t, i) {
      this.vn = [], this.jn = [], this.nn = 0, this.Kt = 0, this.Hn = 1e3, this.Yn = null, this.dn = null, this.Kn = new rt(), this.$n = t, this.F = i, this.model().mainPriceScaleOptionsChanged().subscribe(this.onPriceScaleOptionsChanged.bind(this), this), this._n = this.Xn();
    }
    return t.prototype.onPriceScaleOptionsChanged = function () {
      this._n.applyOptions(this.F.options().priceScale);
    }, t.prototype.destroy = function () {
      this.model().mainPriceScaleOptionsChanged().unsubscribeAll(this), this._n.modeChanged().unsubscribeAll(this), this.vn.forEach(function (t) {
        t.destroy && t.destroy();
      }), this.Kn.fire();
    }, t.prototype.stretchFactor = function () {
      return this.Hn;
    }, t.prototype.setStretchFactor = function (t) {
      this.Hn = t;
    }, t.prototype.model = function () {
      return this.F;
    }, t.prototype.width = function () {
      return this.Kt;
    }, t.prototype.height = function () {
      return this.nn;
    }, t.prototype.setWidth = function (t) {
      this.Kt = t, this.updateAllViews();
    }, t.prototype.setHeight = function (t) {
      var i = this;
      this.nn = t, this._n.setHeight(t), this.vn.forEach(function (n) {
        if (i.isOverlay(n)) {
          var s = n.priceScale();
          null !== s && s.setHeight(t);
        }
      }), this.updateAllViews();
    }, t.prototype.dataSources = function () {
      return this.vn;
    }, t.prototype.isOverlay = function (t) {
      var i = t.priceScale();
      return null === i || this._n !== i;
    }, t.prototype.addDataSource = function (t, i, n) {
      var s = this.Zn().minZOrder - 1;
      this.Jn(t, i, s);
    }, t.prototype.removeDataSource = function (t) {
      var i = this.vn.indexOf(t);
      f(-1 !== i, "removeDataSource: invalid data source"), this.vn.splice(i, 1), t === this.Yn && (this.Yn = null);
      var n = this.jn.indexOf(t);
      -1 !== n && this.jn.splice(n, 1);
      var s = t.priceScale();
      if (s && s.dataSources().indexOf(t) >= 0 && s.removeDataSource(t), s && null === s.mainSource()) {
        var h = s.dataSources().length;
        f(0 === h, "Invalid priceScale state: empty mainSource but non-empty data sources=" + h), s !== this._n && s.modeChanged().unsubscribeAll(this);
      }
      t instanceof ut && this.Gn(), s && t instanceof ut && (s.invalidateSourcesCache(), this.recalculatePriceScale(s)), this.dn = null;
    }, t.prototype.priceScalePosition = function () {
      var t = this.F.options().priceScale.position;
      return "none" === t ? "overlay" : t;
    }, t.prototype.startScalePrice = function (t, i) {
      t.startScale(i);
    }, t.prototype.scalePriceTo = function (t, i) {
      t.scaleTo(i), this.updateAllViews();
    }, t.prototype.endScalePrice = function (t) {
      t.endScale();
    }, t.prototype.startScrollPrice = function (t, i) {
      t.startScroll(i);
    }, t.prototype.scrollPriceTo = function (t, i) {
      t.scrollTo(i), this.updateAllViews();
    }, t.prototype.endScrollPrice = function (t) {
      t.endScroll();
    }, t.prototype.setPriceAutoScale = function (t, i) {
      t.setMode({
        autoScale: i
      }), this.$n.isEmpty() ? t.setPriceRange(null) : this.recalculatePriceScale(t);
    }, t.prototype.updateAllViews = function () {
      this.vn.forEach(function (t) {
        t.updateAllViews();
      });
    }, t.prototype.defaultPriceScale = function () {
      var t = this.mainDataSource(),
        i = null !== t ? t.priceScale() : null;
      return null === i && (i = this._n), i;
    }, t.prototype.mainDataSource = function () {
      return this.Yn;
    }, t.prototype.recalculatePriceScale = function (t) {
      null !== t && t.isAutoScale() && this.Qn(t);
    }, t.prototype.resetPriceScale = function (t) {
      var i = this.$n.visibleBars();
      t.setMode({
        autoScale: !0
      }), null !== i && t.recalculatePriceRange(i), this.updateAllViews();
    }, t.prototype.momentaryAutoScale = function () {
      this.Qn(this._n);
    }, t.prototype.recalculate = function () {
      var t = this;
      this.recalculatePriceScale(this._n), this.vn.forEach(function (i) {
        t.isOverlay(i) && t.recalculatePriceScale(i.priceScale());
      }), this.updateAllViews(), this.F.lightUpdate();
    }, t.prototype.isEmpty = function () {
      return null === this.Yn;
    }, t.prototype.containsSeries = function () {
      return this.vn.some(function (t) {
        return t instanceof Ci;
      });
    }, t.prototype.orderedSources = function () {
      return null === this.dn && (this.dn = Ti(this.vn)), this.dn;
    }, t.prototype.onDestroyed = function () {
      return this.Kn;
    }, t.prototype.ts = function (t, i) {
      return "overlay" !== i ? this._n : this.Xn(!0);
    }, t.prototype.Qn = function (t) {
      var i = t.sourcesForAutoScale();
      if (i && i.length > 0 && !this.$n.isEmpty()) {
        var n = this.$n.visibleBars();
        null !== n && t.recalculatePriceRange(n);
      }
      t.updateAllViews();
    }, t.prototype.Zn = function () {
      var t = this.orderedSources();
      if (0 === t.length) return {
        minZOrder: 0,
        maxZOrder: 0
      };
      for (var i = 0, n = 0, s = 0; s < t.length; s++) {
        var h = t[s].zorder();
        null !== h && (h < i && (i = h), h > n && (n = h));
      }
      return {
        minZOrder: i,
        maxZOrder: n
      };
    }, t.prototype.Jn = function (t, i, n) {
      var s = "overlay",
        h = null;
      if (!i) {
        var r = this.model().options().priceScale.position;
        s = "none" === r ? "overlay" : r;
      }
      t instanceof ut && (h = this.ts(t, s)), this.vn.push(t), i && this.jn.push(t), null !== h && (h.addDataSource(t), t.setPriceScale(h)), t.setZorder(n), this.Gn(), t instanceof ut && this.recalculatePriceScale(h), this.dn = null;
    }, t.prototype.ns = function (t, i, n) {
      i.mode !== n.mode && this.Qn(t);
    }, t.prototype.Gn = function () {
      if (null === this.Yn || -1 !== this.jn.indexOf(this.Yn)) {
        for (var t = 0, i = this.vn; t < i.length; t++) {
          if ((h = i[t]) instanceof ut && !this.isOverlay(h)) return void this.ss(h);
        }
        for (var n = 0, s = this.jn; n < s.length; n++) {
          var h;
          if ((h = s[n]) instanceof ut) return void this.ss(h);
        }
      }
    }, t.prototype.ss = function (t) {
      var i = c(t.priceScale());
      this.defaultPriceScale().modeChanged().unsubscribeAll(this), i.modeChanged().subscribe(this.ns.bind(this, i), this), this.Yn = t;
    }, t.prototype.Xn = function (t) {
      var i = p(this.F.options().priceScale);
      t && (i.autoScale = !0, i.mode = 0);
      var n = new zi(i, this.F.options().layout, this.F.options().localization);
      return n.setHeight(this.height()), n;
    }, t;
  }(),
  $i = function $i(t) {
    return t.getUTCFullYear();
  },
  _i = function _i(t) {
    return it(function (t) {
      return t.getUTCDate();
    }(t), 2);
  },
  Xi = function Xi(t, i) {
    return new Date(t.getUTCFullYear(), t.getUTCMonth(), 1).toLocaleString(i, {
      month: "long"
    });
  },
  Zi = function Zi(t, i) {
    return new Date(t.getUTCFullYear(), t.getUTCMonth(), 1).toLocaleString(i, {
      month: "short"
    });
  },
  Ji = function Ji(t) {
    return it(function (t) {
      return t.getUTCMonth() + 1;
    }(t), 2);
  },
  Gi = function Gi(t) {
    return it($i(t) % 100, 2);
  },
  Qi = function Qi(t) {
    return it($i(t), 4);
  },
  tn = {
    "'yy MMM dd": function yyMMMDd(t, i) {
      return "'" + Gi(t) + " " + Zi(t, i) + " " + _i(t);
    },
    "'yy MMMM dd": function yyMMMMDd(t, i) {
      return "'" + Gi(t) + " " + Xi(t, i) + " " + _i(t);
    },
    "yyyy MMM dd": function yyyyMMMDd(t, i) {
      return Qi(t) + " " + Zi(t, i) + " " + _i(t);
    },
    "yyyy MMMM dd": function yyyyMMMMDd(t, i) {
      return Qi(t) + " " + Xi(t, i) + " " + _i(t);
    },
    "dd MMM 'yy": function ddMMMYy(t, i) {
      return _i(t) + " " + Zi(t, i) + " '" + Gi(t);
    },
    "dd MMMM 'yy": function ddMMMMYy(t, i) {
      return _i(t) + " " + Xi(t, i) + " '" + Gi(t);
    },
    "dd MMM yyyy": function ddMMMYyyy(t, i) {
      return _i(t) + " " + Zi(t, i) + " " + Qi(t);
    },
    "dd MMMM yyyy": function ddMMMMYyyy(t, i) {
      return _i(t) + " " + Xi(t, i) + " " + Qi(t);
    },
    "MMM dd, 'yy": function MMMDdYy(t, i) {
      return Zi(t, i) + " " + _i(t) + ", '" + Gi(t);
    },
    "MMMM dd, 'yy": function MMMMDdYy(t, i) {
      return Xi(t, i) + " " + _i(t) + ", '" + Gi(t);
    },
    "MMM dd, yyyy": function MMMDdYyyy(t, i) {
      return Zi(t, i) + " " + _i(t) + ", " + Qi(t);
    },
    "MMMM dd, yyyy": function MMMMDdYyyy(t, i) {
      return Xi(t, i) + " " + _i(t) + ", " + Qi(t);
    },
    "yyyy-MM-dd": function yyyyMMDd(t, i) {
      return Qi(t) + "-" + Ji(t) + "-" + _i(t);
    },
    "yy-MM-dd": function yyMMDd(t, i) {
      return Gi(t) + "-" + Ji(t) + "-" + _i(t);
    },
    "yy/MM/dd": function yyMMDd(t, i) {
      return Gi(t) + "/" + Ji(t) + "/" + _i(t);
    },
    "yyyy/MM/dd": function yyyyMMDd(t, i) {
      return Qi(t) + "/" + Ji(t) + "/" + _i(t);
    },
    "yy.MM.dd": function yyMMDd(t, i) {
      return Gi(t) + "." + Ji(t) + "." + _i(t);
    },
    "yyyy.MM.dd": function yyyyMMDd(t, i) {
      return Qi(t) + "." + Ji(t) + "." + _i(t);
    },
    "dd-MM-yyyy": function ddMMYyyy(t, i) {
      return _i(t) + "-" + Ji(t) + "-" + Qi(t);
    },
    "dd-MM-yy": function ddMMYy(t, i) {
      return _i(t) + "-" + Ji(t) + "-" + Gi(t);
    },
    "dd/MM/yy": function ddMMYy(t, i) {
      return _i(t) + "/" + Ji(t) + "/" + Gi(t);
    },
    "dd/MM/yyyy": function ddMMYyyy(t, i) {
      return _i(t) + "/" + Ji(t) + "/" + Qi(t);
    },
    "dd.MM.yy": function ddMMYy(t, i) {
      return _i(t) + "." + Ji(t) + "." + Gi(t);
    },
    "dd.MM.yyyy": function ddMMYyyy(t, i) {
      return _i(t) + "." + Ji(t) + "." + Qi(t);
    },
    "MM-dd-yy": function MMDdYy(t, i) {
      return Ji(t) + "-" + _i(t) + "-" + Gi(t);
    },
    "MM-dd-yyyy": function MMDdYyyy(t, i) {
      return Ji(t) + "-" + _i(t) + "-" + Qi(t);
    },
    "MM/dd/yy": function MMDdYy(t, i) {
      return Ji(t) + "/" + _i(t) + "/" + Gi(t);
    },
    "MM/dd/yyyy": function MMDdYyyy(t, i) {
      return Ji(t) + "/" + _i(t) + "/" + Qi(t);
    },
    "MM.dd.yy": function MMDdYy(t, i) {
      return Ji(t) + "." + _i(t) + "." + Gi(t);
    },
    "MM.dd.yyyy": function MMDdYyyy(t, i) {
      return Ji(t) + "." + _i(t) + "." + Qi(t);
    }
  },
  nn = function () {
    function t(t, i) {
      void 0 === t && (t = "yyyy-MM-dd"), void 0 === i && (i = "default"), this.hs = tn[t], this.rs = i;
    }
    return t.prototype.format = function (t) {
      return this.hs(t, this.rs);
    }, t;
  }(),
  sn = function () {
    function t(t) {
      this.us = t || "%h:%m:%s";
    }
    return t.prototype.format = function (t) {
      return this.us.replace("%h", it(t.getUTCHours(), 2)).replace("%m", it(t.getUTCMinutes(), 2)).replace("%s", it(t.getUTCSeconds(), 2));
    }, t;
  }(),
  hn = {
    dateFormat: "yyyy-MM-dd",
    timeFormat: "%h:%m:%s",
    dateTimeSeparator: " ",
    locale: "default"
  },
  rn = function () {
    function t(t) {
      void 0 === t && (t = {});
      var i = _e(_e({}, hn), t);
      this.es = new nn(i.dateFormat, i.locale), this.os = new sn(i.timeFormat), this.fs = i.dateTimeSeparator;
    }
    return t.prototype.format = function (t) {
      return "" + this.es.format(t) + this.fs + this.os.format(t);
    }, t;
  }(),
  un = function () {
    function t(t, i) {
      f(t <= i, "The last bar in the bars range should be greater than or equal to the first bar"), this.as = t, this.cs = i;
    }
    return t.prototype.firstBar = function () {
      return this.as;
    }, t.prototype.lastBar = function () {
      return this.cs;
    }, t.prototype.count = function () {
      return this.cs - this.as + 1;
    }, t.prototype.contains = function (t) {
      return this.as <= t && t <= this.cs;
    }, t.prototype.equals = function (t) {
      return this.as === t.firstBar() && this.cs === t.lastBar();
    }, t;
  }(),
  en = function () {
    function t(t, i) {
      void 0 === i && (i = 50), this.It = 0, this.Ot = 1, this.Rt = 1, this.Ut = new Map(), this.Wt = new Map(), this.ls = t, this.qt = i;
    }
    return t.prototype.format = function (t) {
      var i = this.Ut.get(t.valueOf());
      if (void 0 !== i) return i.string;
      if (this.It === this.qt) {
        var n = this.Wt.get(this.Rt);
        this.Wt.delete(this.Rt), this.Ut.delete(a(n)), this.Rt++, this.It--;
      }
      var s = this.ls(t);
      return this.Ut.set(t.valueOf(), {
        string: s,
        tick: this.Ot
      }), this.Wt.set(this.Ot, t.valueOf()), this.It++, this.Ot++, s;
    }, t;
  }();
function on(t, i) {
  return t.index - i.index;
}
var fn,
  an,
  cn = function () {
    function t() {
      this.vs = 1 / 0, this.ds = -1 / 0, this.Ms = new Map(), this.ws = [], this.bs = new rt(), this.Ut = null, this.ms = NaN;
    }
    return t.prototype.reset = function () {
      this.Ms.clear(), this.ws = [], this.vs = 1 / 0, this.ds = -1 / 0, this.Ut = null, this.bs.fire();
    }, t.prototype.merge = function (t) {
      for (var i = this.ws, n = {}, s = 0, h = t; s < h.length; s++) {
        var r = h[s],
          u = r.index,
          e = r.span,
          o = this.Ms.get(r.index);
        if (o) {
          if (o.index === r.index && o.span === r.span) {
            o.time = r.time;
            continue;
          }
          this.ps(o);
        }
        this.Ms.set(u, r), this.vs > u && (this.vs = u), this.ds < u && (this.ds = u), void 0 === (f = i[e]) && (f = [], i[e] = f), f.push(r), n[e] = !0;
      }
      for (e = i.length; e--;) {
        var f;
        void 0 !== (f = i[e]) && (0 === f.length && delete i[e], n[e] && f.sort(on));
      }
      this.Ut = null, this.bs.fire();
    }, t.prototype.indexToTime = function (t) {
      var i = this.Ms.get(t);
      return void 0 === i ? null : i.time;
    }, t.prototype.nearestIndex = function (t) {
      for (var i = this.vs, n = this.ds; n - i > 2;) {
        if (1e3 * a(this.Ms.get(i)).time.timestamp === t) return i;
        if (1e3 * a(this.Ms.get(n)).time.timestamp === t) return n;
        var s = Math.round((i + n) / 2);
        1e3 * a(this.Ms.get(s)).time.timestamp > t ? n = s : i = s;
      }
      return i;
    }, t.prototype.build = function (t, i) {
      var n = Math.ceil(i / t);
      if (this.ms === n && this.Ut) return this.Ut;
      this.ms = n;
      for (var s = [], h = this.ws.length; h--;) if (this.ws[h]) {
        var r = s;
        s = [];
        for (var u = r.length, e = 0, o = a(this.ws[h]), f = o.length, c = 1 / 0, l = -1 / 0, v = 0; v < f; v++) {
          for (var d = o[v], M = d.index; e < u;) {
            var w = r[e],
              b = w.index;
            if (!(b < M)) {
              c = b;
              break;
            }
            e++, s.push(w), l = b, c = 1 / 0;
          }
          c - M >= n && M - l >= n && (s.push(d), l = M);
        }
        for (; e < u; e++) s.push(r[e]);
      }
      return this.Ut = s, this.Ut;
    }, t.prototype.ps = function (t) {
      var i = t.index;
      if (this.Ms.get(i) === t) {
        this.Ms.delete(i), i <= this.vs && this.vs++, i >= this.ds && this.ds--, this.ds < this.vs && (this.vs = 1 / 0, this.ds = -1 / 0);
        var n = a(this.ws[t.span]),
          s = n.indexOf(t);
        -1 !== s && n.splice(s, 1);
      }
    }, t;
  }(),
  ln = function () {
    function t() {
      this.vi = [];
    }
    return t.prototype.clear = function () {
      this.vi = [];
    }, t.prototype.size = function () {
      return this.vi.length;
    }, t.prototype.firstIndex = function () {
      return this.gs(0);
    }, t.prototype.lastIndex = function () {
      return this.gs(this.vi.length - 1);
    }, t.prototype.merge = function (t, i) {
      if (0 !== i.length) if (0 !== this.vi.length) {
        var n = t;
        if (n < 0) {
          var s = Math.abs(n);
          if (i.length < s) return;
          this.vi = new Array(s).concat(this.vi);
          for (var h = 0; h < i.length; ++h) this.vi[t + h] = i[h];
        } else {
          for (var r = n; r < this.vi.length && r - n < i.length; ++r) this.vi[r] = i[r - n];
          var u = n + i.length;
          if (u > this.vi.length) {
            s = u - this.vi.length;
            for (var e = r; e < r + s; ++e) this.vi.push(i[e - n]);
          }
        }
      } else this.vi = i;
    }, t.prototype.valueAt = function (t) {
      var i = this.ys(t);
      return null !== i ? this.vi[i] : null;
    }, t.prototype.indexOf = function (t, i) {
      if (this.vi.length < 1) return null;
      if (t > this.vi[this.vi.length - 1].timestamp) return i ? this.vi.length - 1 : null;
      for (var n = 0; n < this.vi.length; ++n) {
        if (t === this.vi[n].timestamp) return n;
        if (t < this.vi[n].timestamp) return i ? n : null;
      }
      return null;
    }, t.prototype.closestIndexLeft = function (t) {
      var i = this.vi;
      if (!i.length) return null;
      if (Number.isNaN(t.timestamp)) return null;
      var n = i.length - 1;
      if (t >= i[n]) return n;
      var s = 0,
        h = i[s];
      if (t < h) return null;
      if (t === h) return s;
      for (; n > s + 1;) {
        var r = s + n >> 1,
          u = i[r];
        if (u.timestamp > t.timestamp) n = r;else {
          if (!(u.timestamp < t.timestamp)) return u.timestamp === t.timestamp ? r : null;
          s = r;
        }
      }
      return s;
    }, t.prototype.gs = function (t) {
      return 0 <= t && t < this.size() ? t : null;
    }, t.prototype.ys = function (t) {
      return 0 <= t && t < this.size() ? t : null;
    }, t;
  }();
!function (t) {
  t[t.DefaultAnimationDuration = 400] = "DefaultAnimationDuration", t[t.MinBarSpacing = .5] = "MinBarSpacing", t[t.MinVisibleBarsCount = 2] = "MinVisibleBarsCount";
}(fn || (fn = {})), function (t) {
  t[t.Minute = 20] = "Minute", t[t.Hour = 30] = "Hour", t[t.Day = 40] = "Day", t[t.Week = 50] = "Week", t[t.Month = 60] = "Month", t[t.Year = 70] = "Year";
}(an || (an = {}));
var vn = function () {
    function t(t, i, n) {
      this.Kt = 0, this.ks = null, this.Ns = new ln(), this.pn = null, this.mn = null, this.Ss = new cn(), this.xs = new Map(), this.Ds = null, this.Cs = !0, this.Ts = new rt(), this.Es = new rt(), this.Ls = null, this.As = null, this.Bs = null, this.zs = [], this.$ = i, this.kn = n, this.Vs = i.rightOffset, this.Fs = i.barSpacing, this.F = t, this.Ps();
    }
    return t.prototype.options = function () {
      return this.$;
    }, t.prototype.applyLocalizationOptions = function (t) {
      v(this.kn, t), this.Is(), this.Ps();
    }, t.prototype.applyOptions = function (t, i) {
      v(this.$, t), this.$.fixLeftEdge ? this.Os() : this.Ls = null, void 0 !== t.barSpacing && this.setBarSpacing(t.barSpacing), void 0 !== t.rightOffset && this.setRightOffset(t.rightOffset), this.Is(), this.Ps(), this.Es.fire();
    }, t.prototype.isEmpty = function () {
      return 0 === this.Kt || 0 === this.Ns.size();
    }, t.prototype.visibleBars = function () {
      return this.Cs && (this.Cs = !1, this.Rs()), this.Ds;
    }, t.prototype.tickMarks = function () {
      return this.Ss;
    }, t.prototype.points = function () {
      return this.Ns;
    }, t.prototype.width = function () {
      return this.Kt;
    }, t.prototype.setWidth = function (t) {
      if (isFinite(t) && !(t <= 0) && this.Kt !== t) {
        if (this.$.lockVisibleTimeRangeOnResize && this.Kt) {
          var i = this.Fs * t / this.Kt;
          this.Ws(i);
        }
        if (null !== this.Ls) if (c(this.visibleBars()).firstBar() <= this.Ls) {
          var n = this.Kt - t;
          this.Vs -= Math.round(n / this.Fs) + 1;
        }
        this.Kt = t, this.Cs = !0, this.Us(), this.qs();
      }
    }, t.prototype.indexToCoordinate = function (t) {
      if (this.isEmpty() || !M(t)) return 0;
      var i = this.baseIndex() + this.Vs - t;
      return this.Kt - (i + .5) * this.Fs;
    }, t.prototype.indexesToCoordinates = function (t, i) {
      for (var n = this.baseIndex(), s = void 0 === i ? 0 : i.from, h = void 0 === i ? t.length : i.to, r = s; r < h; r++) {
        var u = t[r].time,
          e = n + this.Vs - u,
          o = this.Kt - (e + .5) * this.Fs;
        t[r].x = o;
      }
    }, t.prototype.indexToUserTime = function (t) {
      return this.Ss.indexToTime(t);
    }, t.prototype.coordinateToIndex = function (t) {
      return Math.ceil(this.js(t));
    }, t.prototype.setRightOffset = function (t) {
      this.Cs = !0, this.Vs = t, this.qs(), this.F.recalculateAllPanes(), this.F.lightUpdate();
    }, t.prototype.barSpacing = function () {
      return this.Fs;
    }, t.prototype.setBarSpacing = function (t) {
      this.Ws(t), this.qs(), this.F.recalculateAllPanes(), this.F.lightUpdate();
    }, t.prototype.rightOffset = function () {
      return this.Vs;
    }, t.prototype.marks = function () {
      if (this.isEmpty()) return null;
      if (null !== this.Bs) return this.Bs;
      for (var t = this.Fs, i = 5 * (this.F.options().layout.fontSize + 4), n = Math.round(i / t), s = c(this.visibleBars()), h = Math.max(s.firstBar(), s.firstBar() - n), r = Math.max(s.lastBar(), s.lastBar() - n), u = 0, e = 0, o = this.Ss.build(t, i); e < o.length; e++) {
        var f = o[e];
        if (h <= f.index && f.index <= r) {
          var a = this.Ss.indexToTime(f.index);
          if (null !== a) {
            if (u < this.zs.length) {
              var l = this.zs[u];
              l.coord = this.indexToCoordinate(f.index), l.label = this.Hs(a, f.span), l.span = f.span, l.major = !1;
            } else this.zs.push({
              coord: this.indexToCoordinate(f.index),
              label: this.Hs(a, f.span),
              span: f.span,
              major: !1
            });
            u++;
          }
        }
      }
      return this.zs.length = u, this.Bs = this.zs, this.zs;
    }, t.prototype.reset = function () {
      this.Cs = !0, this.Ns = new ln(), this.pn = null, this.mn = null, this.Ys(), this.Ss.reset(), this.Ls = null;
    }, t.prototype.restoreDefault = function () {
      this.Cs = !0, this.setBarSpacing(this.$.barSpacing), this.setRightOffset(this.$.rightOffset);
    }, t.prototype.fixLeftEdge = function () {
      return this.$.fixLeftEdge;
    }, t.prototype.setBaseIndex = function (t) {
      this.Cs = !0, this.ks = t, this.qs(), this.Os();
    }, t.prototype.zoom = function (t, i) {
      var n = this.js(t),
        s = this.barSpacing(),
        h = s + i * (s / 10);
      this.setBarSpacing(h), this.$.rightBarStaysOnScroll || this.setRightOffset(this.rightOffset() + (n - this.js(t)));
    }, t.prototype.startScale = function (t) {
      this.pn && this.endScroll(), null === this.mn && null === this.As && (this.isEmpty() || (this.mn = t, this.Ks()));
    }, t.prototype.scaleTo = function (t) {
      if (null !== this.As) {
        var i = ot(this.Kt - t, 0, this.Kt),
          n = ot(this.Kt - c(this.mn), 0, this.Kt);
        0 !== i && 0 !== n && this.setBarSpacing(this.As.barSpacing * i / n);
      }
    }, t.prototype.endScale = function () {
      null !== this.mn && (this.mn = null, this.Ys());
    }, t.prototype.startScroll = function (t) {
      null === this.pn && null === this.As && (this.isEmpty() || (this.pn = t, this.Ks()));
    }, t.prototype.scrollTo = function (t) {
      if (this.Cs = !0, null !== this.pn) {
        var i = (this.pn - t) / this.barSpacing();
        this.Vs = c(this.As).rightOffset + i, this.Cs = !0, this.qs();
      }
    }, t.prototype.endScroll = function () {
      null !== this.pn && (this.pn = null, this.Ys());
    }, t.prototype.scrollToRealTime = function () {
      this.scrollToOffsetAnimated(this.$.rightOffset);
    }, t.prototype.scrollToOffsetAnimated = function (t, i) {
      var n = this;
      if (void 0 === i && (i = 400), !isFinite(t)) throw new RangeError("offset is required and must be finite number");
      if (!isFinite(i) || i <= 0) throw new RangeError("animationDuration (optional) must be finite positive number");
      var s = this.Vs,
        h = new Date().getTime(),
        r = function r() {
          var u = (new Date().getTime() - h) / i,
            e = u >= 1,
            o = e ? t : s + (t - s) * u;
          n.setRightOffset(o), e || setTimeout(r, 20);
        };
      r();
    }, t.prototype.update = function (t, i, n) {
      if (this.Cs = !0, i.length > 0) {
        var s = this.Ns.size();
        this.Ns.merge(t, i), this.Vs < 0 && this.Ns.size() === s + 1 && (this.Vs -= 1, this.Cs = !0);
      }
      this.Ss.merge(n), this.qs();
    }, t.prototype.visibleBarsChanged = function () {
      return this.Ts;
    }, t.prototype.optionsApplied = function () {
      return this.Es;
    }, t.prototype.baseIndex = function () {
      return this.ks || 0;
    }, t.prototype.setVisibleRange = function (t) {
      var i = t.count();
      this.Ws(this.Kt / i), this.Vs = t.lastBar() - this.baseIndex(), this.qs(), this.Cs = !0, this.F.recalculateAllPanes(), this.F.lightUpdate();
    }, t.prototype.fitContent = function () {
      var t = this.Ns.firstIndex(),
        i = this.Ns.lastIndex();
      null !== t && null !== i && this.setVisibleRange(new un(t, i + this.$.rightOffset));
    }, t.prototype.setTimePointsRange = function (t) {
      var i = this.points(),
        n = i.firstIndex(),
        s = i.lastIndex();
      if (null !== n && null !== s) {
        var h = c(i.valueAt(n)).timestamp,
          r = c(i.valueAt(s)).timestamp,
          u = new un(c(i.indexOf(Math.max(h, t.from.timestamp), !0)), c(i.indexOf(Math.min(r, t.to.timestamp), !0)));
        this.setVisibleRange(u);
      }
    }, t.prototype.formatDateTime = function (t) {
      return void 0 !== this.kn.timeFormatter ? this.kn.timeFormatter(t.businessDay || t.timestamp) : this.$s.format(new Date(1e3 * t.timestamp));
    }, t.prototype._s = function (t) {
      return (this.Kt + 1 - t) / this.Fs;
    }, t.prototype.js = function (t) {
      var i = this._s(t),
        n = this.baseIndex() + this.Vs - i;
      return Math.round(1e6 * n) / 1e6;
    }, t.prototype.Ws = function (t) {
      var i = this.Fs;
      this.Fs = t, this.Us(), i !== this.Fs && (this.Cs = !0, this.Xs());
    }, t.prototype.Rs = function () {
      if (this.isEmpty()) this.Zs(null);else {
        var t = this.baseIndex(),
          i = Math.ceil(this.Kt / this.Fs) - 1,
          n = Math.round(this.Vs + t),
          s = n - i;
        this.Zs(new un(s, n));
      }
    }, t.prototype.Us = function () {
      if (this.Fs < .5 && (this.Fs = .5, this.Cs = !0), 0 !== this.Kt) {
        var t = .5 * this.Kt;
        this.Fs > t && (this.Fs = t, this.Cs = !0);
      }
    }, t.prototype.qs = function () {
      var t = this.Js();
      this.Vs > t && (this.Vs = t, this.Cs = !0);
      var i = this.Gs();
      null !== i && this.Vs < i && (this.Vs = i, this.Cs = !0);
    }, t.prototype.Gs = function () {
      var t = this.Ns.firstIndex(),
        i = this.ks;
      if (null === t || null === i) return null;
      if (null !== this.Ls) {
        var n = this.Kt / this.Fs;
        return this.Ls - i + n - 1;
      }
      return t - i - 1 + Math.min(2, this.Ns.size());
    }, t.prototype.Js = function () {
      return this.Kt / this.Fs - Math.min(2, this.Ns.size());
    }, t.prototype.Ks = function () {
      this.As = {
        barSpacing: this.barSpacing(),
        rightOffset: this.rightOffset()
      };
    }, t.prototype.Ys = function () {
      this.As = null;
    }, t.prototype.Hs = function (t, i) {
      var n = this,
        s = this.xs.get(i);
      return void 0 === s && (s = new en(function (t) {
        return n.Qs(t, i);
      }), this.xs.set(i, s)), void 0 === t.businessDay ? s.format(new Date(1e3 * t.timestamp)) : s.format(new Date(Date.UTC(t.businessDay.year, t.businessDay.month - 1, t.businessDay.day)));
    }, t.prototype.Qs = function (t, i) {
      var n = {},
        s = this.$.timeVisible;
      return i < 20 && s ? (n.hour12 = !1, n.hour = "2-digit", n.minute = "2-digit", this.$.secondsVisible && (n.second = "2-digit")) : i < 40 && s ? (n.hour12 = !1, n.hour = "2-digit", n.minute = "2-digit") : i < 50 ? n.day = "numeric" : i < 60 ? n.day = "numeric" : i < 70 ? n.month = "short" : n.year = "numeric", new Date(t.getUTCFullYear(), t.getUTCMonth(), t.getUTCDate(), t.getUTCHours(), t.getUTCMinutes(), t.getUTCSeconds(), t.getUTCMilliseconds()).toLocaleString(this.kn.locale, n);
    }, t.prototype.Zs = function (t) {
      if (null !== t || null !== this.Ds) {
        var i = this.Ds;
        this.Ds = t, (null === this.Ds || null !== i && !this.Ds.equals(i)) && this.Ts.fire(), this.Xs();
      }
    }, t.prototype.Xs = function () {
      this.Bs = null;
    }, t.prototype.Is = function () {
      this.Xs(), this.xs.clear();
    }, t.prototype.Ps = function () {
      var t = this.kn.dateFormat;
      this.$.timeVisible ? this.$s = new rn({
        dateFormat: t,
        timeFormat: this.$.secondsVisible ? "%h:%m:%s" : "%h:%m",
        dateTimeSeparator: "   ",
        locale: this.kn.locale
      }) : this.$s = new nn(t, this.kn.locale);
    }, t.prototype.Os = function () {
      if (this.$.fixLeftEdge) {
        var t = this.Ns.firstIndex();
        if (null !== t && this.Ls !== t) {
          this.Ls = t;
          var i = c(this.visibleBars()).firstBar() - t;
          if (i < 0) {
            var n = this.Vs - i - 1;
            this.setRightOffset(n);
          }
        }
      }
    }, t;
  }(),
  dn = function (t) {
    function i(i) {
      var n = t.call(this) || this;
      return n.th = new Map(), n.m = i, n;
    }
    return u(i, t), i.prototype._drawImpl = function (t) {}, i.prototype._drawBackgroundImpl = function (t) {
      if (this.m.visible) {
        t.save();
        for (var i = 0, n = 0, s = this.m.lines; n < s.length; n++) {
          if (0 !== (o = s[n]).text.length) {
            t.font = o.font;
            var h = this.ih(t, o.text);
            h > this.m.width ? o.zoom = this.m.width / h : o.zoom = 1, i += o.lineHeight * o.zoom;
          }
        }
        var r = 0;
        switch (this.m.vertAlign) {
          case "top":
            r = 0;
            break;
          case "center":
            r = Math.max((this.m.height - i) / 2, 0);
            break;
          case "bottom":
            r = Math.max(this.m.height - i, 0);
        }
        t.fillStyle = this.m.color;
        for (var u = 0, e = this.m.lines; u < e.length; u++) {
          var o = e[u];
          t.save();
          var f = 0;
          switch (this.m.horzAlign) {
            case "left":
              t.textAlign = "left", f = o.lineHeight / 2;
              break;
            case "center":
              t.textAlign = "center", f = this.m.width / 2;
              break;
            case "right":
              t.textAlign = "right", f = this.m.width - 1 - o.lineHeight / 2;
          }
          t.translate(f, r), t.textBaseline = "top", t.font = o.font, t.scale(o.zoom, o.zoom), t.fillText(o.text, 0, o.vertOffset), t.restore(), r += o.lineHeight * o.zoom;
        }
        t.restore();
      }
    }, i.prototype.ih = function (t, i) {
      var n = this.nh(t.font),
        s = n.get(i);
      return void 0 === s && (s = t.measureText(i).width, n.set(i, s)), s;
    }, i.prototype.nh = function (t) {
      var i = this.th.get(t);
      return void 0 === i && (i = new Map(), this.th.set(t, i)), i;
    }, i;
  }(N),
  Mn = function () {
    function t(t) {
      this.o = !0, this.p = {
        visible: !1,
        color: "",
        height: 0,
        width: 0,
        lines: [],
        vertAlign: "center",
        horzAlign: "center"
      }, this.g = new dn(this.p), this.k = t;
    }
    return t.prototype.update = function () {
      this.o = !0;
    }, t.prototype.renderer = function (t, i) {
      return this.o && (this.M(t, i), this.o = !1), this.g;
    }, t.prototype.M = function (t, i) {
      var n = this.k.options(),
        s = this.p;
      s.visible = n.visible, s.visible && (s.color = n.color, s.width = i, s.height = t, s.horzAlign = n.horzAlign, s.vertAlign = n.vertAlign, s.lines = [{
        text: n.text,
        font: Oi(n.fontSize),
        lineHeight: 1.2 * n.fontSize,
        vertOffset: 0,
        zoom: 0
      }]);
    }, t;
  }(),
  wn = function (t) {
    function i(i, n) {
      var s = t.call(this) || this;
      return s.$ = n, s.J = new Mn(s), s;
    }
    return u(i, t), i.prototype.paneViews = function () {
      return [this.J];
    }, i.prototype.options = function () {
      return this.$;
    }, i.prototype.updateAllViews = function () {
      this.J.update();
    }, i;
  }(J),
  bn = function () {
    function t(t, i) {
      this.sh = [], this.hh = [], this.Kt = 0, this.rh = null, this.uh = null, this.eh = new rt(), this.oh = new rt(), this.fh = t, this.$ = i, this.ah = new Wi(this), this.$n = new vn(this, i.timeScale, this.$.localization), this.lh = new ji(), this.v = new G(this, i.crosshair), this.vh = new Yi(i.crosshair), this.dh = new wn(this, i.watermark), this.createPane(), this.sh[0].setStretchFactor(2e3), this.sh[0].addDataSource(this.dh, !0, !1);
    }
    return t.prototype.fullUpdate = function () {
      this.Mh(new Hi(3));
    }, t.prototype.lightUpdate = function () {
      this.Mh(new Hi(2));
    }, t.prototype.updateSource = function (t) {
      var i = this.wh(t);
      this.Mh(i);
    }, t.prototype.hoveredSource = function () {
      return this.uh;
    }, t.prototype.setHoveredSource = function (t) {
      var i = this.uh;
      this.uh = t, null !== i && this.updateSource(i.source), null !== t && this.updateSource(t.source);
    }, t.prototype.options = function () {
      return this.$;
    }, t.prototype.applyOptions = function (t) {
      v(this.$, t), void 0 !== t.priceScale && (this.mainPriceScale().applyOptions(t.priceScale), this.eh.fire()), void 0 !== t.timeScale && this.$n.applyOptions(t.timeScale), void 0 !== t.localization && (this.$n.applyLocalizationOptions(t.localization), this.mainPriceScale().updateFormatter()), this.fullUpdate();
    }, t.prototype.updateAllPaneViews = function () {
      this.sh.forEach(function (t) {
        return t.updateAllViews();
      }), this.updateCrosshair();
    }, t.prototype.timeScale = function () {
      return this.$n;
    }, t.prototype.panes = function () {
      return this.sh;
    }, t.prototype.gridSource = function () {
      return this.lh;
    }, t.prototype.watermarkSource = function () {
      return this.dh;
    }, t.prototype.crosshairSource = function () {
      return this.v;
    }, t.prototype.crosshairMoved = function () {
      return this.oh;
    }, t.prototype.width = function () {
      return this.Kt;
    }, t.prototype.setPaneHeight = function (t, i) {
      t.setHeight(i), this.recalculateAllPanes(), this.lightUpdate();
    }, t.prototype.setWidth = function (t) {
      this.Kt = t, this.$n.setWidth(this.Kt), this.sh.forEach(function (i) {
        return i.setWidth(t);
      }), this.recalculateAllPanes();
    }, t.prototype.createPane = function (t) {
      var i = new Ki(this.$n, this);
      void 0 !== t ? this.sh.splice(t, 0, i) : this.sh.push(i);
      var n = void 0 === t ? this.sh.length - 1 : t,
        s = new Hi(3);
      return s.invalidatePane(n, {
        level: 0,
        autoScale: !0
      }), this.invalidate(s), i;
    }, t.prototype.startScalePrice = function (t, i, n) {
      t.startScalePrice(i, n);
    }, t.prototype.scalePriceTo = function (t, i, n) {
      t.scalePriceTo(i, n), this.updateCrosshair(), this.Mh(this.bh(t, 2));
    }, t.prototype.endScalePrice = function (t, i) {
      t.endScalePrice(i), this.Mh(this.bh(t, 2));
    }, t.prototype.startScrollPrice = function (t, i, n) {
      i.isAutoScale() || t.startScrollPrice(i, n);
    }, t.prototype.scrollPriceTo = function (t, i, n) {
      i.isAutoScale() || (t.scrollPriceTo(i, n), this.updateCrosshair(), this.Mh(this.bh(t, 2)));
    }, t.prototype.endScrollPrice = function (t, i) {
      i.isAutoScale() || (t.endScrollPrice(i), this.Mh(this.bh(t, 2)));
    }, t.prototype.setPriceAutoScale = function (t, i, n) {
      t.setPriceAutoScale(i, n), this.Mh(this.bh(t, 2));
    }, t.prototype.resetPriceScale = function (t, i) {
      t.resetPriceScale(i), this.Mh(this.bh(t, 2));
    }, t.prototype.startScaleTime = function (t) {
      this.$n.startScale(t);
    }, t.prototype.zoomTime = function (t, i) {
      var n = this.timeScale();
      if (!n.isEmpty() && 0 !== i) {
        var s = n.width();
        t = Math.max(1, Math.min(t, s)), n.zoom(t, i), this.updateCrosshair(), this.recalculateAllPanes(), this.lightUpdate();
      }
    }, t.prototype.scrollChart = function (t) {
      this.startScrollTime(0), this.scrollTimeTo(t), this.endScrollTime();
    }, t.prototype.scaleTimeTo = function (t) {
      this.$n.scaleTo(t), this.recalculateAllPanes(), this.updateCrosshair(), this.lightUpdate();
    }, t.prototype.endScaleTime = function () {
      this.$n.endScale(), this.lightUpdate();
    }, t.prototype.startScrollTime = function (t) {
      this.rh = t, this.$n.startScroll(t);
    }, t.prototype.scrollTimeTo = function (t) {
      var i = !1;
      return null !== this.rh && Math.abs(t - this.rh) > 20 && (this.rh = null, i = !0), this.$n.scrollTo(t), this.recalculateAllPanes(), this.updateCrosshair(), this.lightUpdate(), i;
    }, t.prototype.endScrollTime = function () {
      this.$n.endScroll(), this.lightUpdate(), this.rh = null;
    }, t.prototype.resetTimeScale = function () {
      this.$n.restoreDefault(), this.recalculateAllPanes(), this.updateCrosshair(), this.lightUpdate();
    }, t.prototype.invalidate = function (t) {
      this.fh && this.fh(t), this.lh.invalidate(), this.lightUpdate();
    }, t.prototype.dataSources = function () {
      return this.sh.reduce(function (t, i) {
        return t.concat(i.dataSources());
      }, []);
    }, t.prototype.serieses = function () {
      return this.hh;
    }, t.prototype.setAndSaveCurrentPosition = function (t, i, n) {
      this.v.saveOriginCoord(t, i);
      var s = NaN,
        h = this.$n.coordinateToIndex(t),
        r = this.$n.visibleBars();
      if (null !== r && (h = Math.min(Math.max(r.firstBar(), h), r.lastBar())), null !== n.mainDataSource()) {
        var u = n.defaultPriceScale(),
          e = u.firstValue();
        null !== e && (s = u.coordinateToPrice(i, e)), s = this.vh.align(s, h, n);
      }
      this.v.setPosition(h, s, n), this.mh(), this.oh.fire(this.v.appliedIndex(), {
        x: t,
        y: i
      });
    }, t.prototype.clearCurrentPosition = function () {
      this.crosshairSource().clearPosition(), this.mh(), this.oh.fire(null, null);
    }, t.prototype.updateCrosshair = function () {
      var t = this.v.pane();
      if (null !== t) {
        var i = this.v.originCoordX(),
          n = this.v.originCoordY();
        this.setAndSaveCurrentPosition(i, n, t);
      }
    }, t.prototype.updateTimeScale = function (t, i, n, s) {
      s && this.$n.reset(), this.$n.update(t, i, n);
    }, t.prototype.updateTimeScaleBaseIndex = function (t) {
      var i = this.hh.reduce(function (t, i) {
        var n = i.bars();
        if (n.isEmpty()) return t;
        var s = c(n.lastIndex());
        return void 0 === t ? s : Math.max(s, t);
      }, void 0);
      if (void 0 !== i) {
        var n = this.$n,
          s = n.baseIndex(),
          h = n.visibleBars();
        if (null !== h) {
          var r = h.contains(s);
          if (void 0 !== t && t > 0 && !r) {
            var u = i - s;
            n.setRightOffset(n.rightOffset() - u);
          }
        }
        n.setBaseIndex(i);
      }
      this.updateCrosshair(), this.recalculateAllPanes(), this.lightUpdate();
    }, t.prototype.recalculatePane = function (t) {
      null !== t && t.recalculate();
    }, t.prototype.paneForSource = function (t) {
      var i = this.sh.find(function (i) {
        return i.orderedSources().includes(t);
      });
      return void 0 === i ? null : i;
    }, t.prototype.recalculateAllPanes = function () {
      this.sh.forEach(function (t) {
        return t.recalculate();
      }), this.updateAllPaneViews();
    }, t.prototype.destroy = function () {
      this.sh.forEach(function (t) {
        return t.destroy();
      }), this.sh.length = 0, this.$.localization.priceFormatter = void 0, this.$.localization.timeFormatter = void 0;
    }, t.prototype.setPriceAutoScaleForAllMainSources = function () {
      this.sh.map(function (t) {
        return t.mainDataSource();
      }).forEach(function (t) {
        null !== t && c(t.priceScale()).setMode({
          autoScale: !0
        });
      });
    }, t.prototype.rendererOptionsProvider = function () {
      return this.ah;
    }, t.prototype.priceAxisRendererOptions = function () {
      return this.ah.options();
    }, t.prototype.mainPriceScaleOptionsChanged = function () {
      return this.eh;
    }, t.prototype.mainPriceScale = function () {
      return this.sh[0].defaultPriceScale();
    }, t.prototype.createSeries = function (t, i) {
      var n = this.sh[0],
        s = this.ph(i, t, n);
      return this.hh.push(s), 1 === this.hh.length ? this.fullUpdate() : this.lightUpdate(), s;
    }, t.prototype.removeSeries = function (t) {
      var i = this.paneForSource(t),
        n = this.hh.indexOf(t);
      f(-1 !== n, "Series not found"), this.hh.splice(n, 1), c(i).removeDataSource(t), t.destroy && t.destroy();
    }, t.prototype.fitContent = function () {
      var t = new Hi(2);
      t.setFitContent(), this.Mh(t);
    }, t.prototype.setTargetTimeRange = function (t) {
      var i = new Hi(2);
      i.setTargetTimeRange(t), this.Mh(i);
    }, t.prototype.bh = function (t, i) {
      var n = new Hi(i);
      if (null !== t) {
        var s = this.sh.indexOf(t);
        n.invalidatePane(s, {
          level: i
        });
      }
      return n;
    }, t.prototype.wh = function (t, i) {
      return void 0 === i && (i = 2), this.bh(this.paneForSource(t), i);
    }, t.prototype.Mh = function (t) {
      this.fh && this.fh(t), this.lh.invalidate();
    }, t.prototype.mh = function () {
      this.Mh(new Hi(1));
    }, t.prototype.ph = function (t, i, n) {
      var s = new Ci(this, t, i);
      return n.addDataSource(s, Boolean(t.overlay), !1), t.overlay && s.applyOptions(t), s;
    }, t;
  }(),
  mn = function () {
    function t(t, i) {
      this.w = t, this.h = i;
    }
    return t.prototype.equals = function (t) {
      return this.w === t.w && this.h === t.h;
    }, t;
  }();
function pn(t) {
  return t.ownerDocument && t.ownerDocument.defaultView && t.ownerDocument.defaultView.devicePixelRatio || 1;
}
function gn(t) {
  var i = c(t.getContext("2d"));
  return i.setTransform(1, 0, 0, 1, 0, 0), i;
}
function yn(t) {
  var i = t.createElement("canvas");
  return function (t) {
    t.style.userSelect = "none", t.style.webkitUserSelect = "none", t.style.msUserSelect = "none", t.style.MozUserSelect = "none", t.style.webkitTapHighlightColor = "transparent";
  }(i), i;
}
function kn(t, i) {
  var n = yn(t),
    s = pn(n);
  return n.style.width = i.w + "px", n.style.height = i.h + "px", n.width = i.w * s, n.height = i.h * s, n;
}
function Nn(i, n) {
  var s = yn(c(i.ownerDocument));
  i.appendChild(s);
  var h = t(s);
  return h.resizeCanvas({
    width: n.w,
    height: n.h
  }), h;
}
var Sn,
  xn = !!navigator.maxTouchPoints || !!navigator.msMaxTouchPoints || "ontouchstart" in window || Boolean(window.DocumentTouch && document instanceof window.DocumentTouch),
  Dn = "onorientationchange" in window && xn,
  Cn = /Android/i.test(navigator.userAgent),
  Tn = /iPhone|iPad|iPod|AppleWebKit.+Mobile/i.test(navigator.userAgent),
  En = Cn || Tn;
!function (t) {
  t[t.ResetClick = 500] = "ResetClick", t[t.LongTap = 240] = "LongTap";
}(Sn || (Sn = {}));
var Ln = function () {
  function t(t, i, n) {
    this.gh = 0, this.yh = null, this.kh = null, this.Nh = !1, this.Sh = null, this.xh = !1, this.Dh = !1, this.Ch = null, this.Th = null, this.Eh = null, this.Lh = null, this.Ah = 0, this.Bh = !1, this.zh = !1, this.Vh = !1, this.Fh = t, this.Ph = i, this.$ = n, this.Ih();
  }
  return t.prototype.destroy = function () {
    null !== this.Ch && (this.Ch(), this.Ch = null), null !== this.Th && (this.Th(), this.Th = null), null !== this.Eh && (this.Eh(), this.Eh = null), this.Oh(), this.Rh();
  }, t.prototype.Wh = function (t) {
    var i = this;
    this.Th && this.Th();
    var n = this.Uh.bind(this);
    this.Th = function () {
      i.Fh.removeEventListener("mousemove", n);
    }, this.Fh.addEventListener("mousemove", n), zn(t) && this.Uh(t);
    var s = this.qh(t);
    this.jh(s, this.Ph.mouseEnterEvent);
  }, t.prototype.Rh = function () {
    null !== this.yh && clearTimeout(this.yh), this.gh = 0, this.yh = null;
  }, t.prototype.Uh = function (t) {
    if (!this.Vh || zn(t)) {
      var i = this.qh(t);
      this.jh(i, this.Ph.mouseMoveEvent);
    }
  }, t.prototype.Hh = function (t) {
    if (!("button" in t && 0 !== t.button) && null === this.Lh) {
      var i = zn(t);
      if (!this.zh || !i) {
        this.Bh = !0;
        var n = this.qh(t),
          s = l(this.Sh),
          h = Math.abs(s.x - n.pageX),
          r = Math.abs(s.y - n.pageY),
          u = h + r > 5;
        if (u || !i) {
          if (u && !this.xh && i) {
            var e = .5 * h,
              o = r >= e && !this.$.treatVertTouchDragAsPageScroll,
              f = e > r && !this.$.treatHorzTouchDragAsPageScroll;
            o || f || (this.zh = !0);
          }
          u && (this.xh = !0, this.Dh = !0, i && this.Oh()), this.zh || (this.jh(n, this.Ph.pressedMouseMoveEvent), i && Vn(t));
        }
      }
    }
  }, t.prototype.Yh = function (t) {
    if (!("button" in t && 0 !== t.button)) {
      var i = this.qh(t);
      this.Oh(), this.Sh = null, this.Vh = !1, this.Eh && (this.Eh(), this.Eh = null), zn(t) && this.Kh(t), this.jh(i, this.Ph.mouseUpEvent), ++this.gh, this.yh && this.gh > 1 ? (this.jh(i, this.Ph.mouseDoubleClickEvent), this.Rh()) : this.Dh || this.jh(i, this.Ph.mouseClickEvent), zn(t) && (Vn(t), this.Kh(t), 0 === t.touches.length && (this.Nh = !1));
    }
  }, t.prototype.Oh = function () {
    null !== this.kh && (clearTimeout(this.kh), this.kh = null);
  }, t.prototype.$h = function (t) {
    if (!("button" in t && 0 !== t.button)) {
      var i = this.qh(t);
      this.Dh = !1, this.xh = !1, this.zh = !1, zn(t) && this.Wh(t), this.Sh = {
        x: i.pageX,
        y: i.pageY
      }, this.Eh && (this.Eh(), this.Eh = null);
      var n = this.Hh.bind(this),
        s = this.Yh.bind(this),
        h = this.Fh.ownerDocument.documentElement;
      this.Eh = function () {
        h.removeEventListener("touchmove", n), h.removeEventListener("touchend", s), h.removeEventListener("mousemove", n), h.removeEventListener("mouseup", s);
      }, h.addEventListener("touchmove", n, {
        passive: !1
      }), h.addEventListener("touchend", s, {
        passive: !1
      }), this.Oh(), zn(t) && 1 === t.touches.length ? this.kh = setTimeout(this._h.bind(this, t), 240) : (h.addEventListener("mousemove", n), h.addEventListener("mouseup", s)), this.Vh = !0, this.jh(i, this.Ph.mouseDownEvent), this.yh || (this.gh = 0, this.yh = setTimeout(this.Rh.bind(this), 500));
    }
  }, t.prototype.Ih = function () {
    var t = this;
    this.Fh.addEventListener("mouseenter", this.Wh.bind(this)), this.Fh.addEventListener("touchcancel", this.Oh.bind(this));
    var i = this.Fh.ownerDocument,
      n = function n(i) {
        t.Ph.mouseDownOutsideEvent && (i.target && t.Fh.contains(i.target) || t.Ph.mouseDownOutsideEvent());
      };
    this.Ch = function () {
      i.removeEventListener("mousedown", n), i.removeEventListener("touchstart", n);
    }, i.addEventListener("mousedown", n), i.addEventListener("touchstart", n, {
      passive: !0
    }), this.Fh.addEventListener("mouseleave", this.Kh.bind(this)), this.Fh.addEventListener("touchstart", this.$h.bind(this), {
      passive: !0
    }), Dn || this.Fh.addEventListener("mousedown", this.$h.bind(this)), this.Xh(), this.Fh.addEventListener("touchmove", function () {}, {
      passive: !1
    });
  }, t.prototype.Xh = function () {
    var t = this;
    void 0 === this.Ph.pinchStartEvent && void 0 === this.Ph.pinchEvent && void 0 === this.Ph.pinchEndEvent || (this.Fh.addEventListener("touchstart", function (i) {
      return t.Zh(i.touches);
    }, {
      passive: !0
    }), this.Fh.addEventListener("touchmove", function (i) {
      if (2 === i.touches.length && null !== t.Lh && void 0 !== t.Ph.pinchEvent) {
        var n = Bn(i.touches[0], i.touches[1]) / t.Ah;
        t.Ph.pinchEvent(t.Lh, n), Vn(i);
      }
    }, {
      passive: !1
    }), this.Fh.addEventListener("touchend", function (i) {
      t.Zh(i.touches);
    }));
  }, t.prototype.Zh = function (t) {
    1 === t.length && (this.Bh = !1), 2 !== t.length || this.Bh || this.Nh ? this.Jh() : this.Gh(t);
  }, t.prototype.Gh = function (t) {
    var i = An(this.Fh);
    this.Lh = {
      x: (t[0].clientX - i.left + (t[1].clientX - i.left)) / 2,
      y: (t[0].clientY - i.top + (t[1].clientY - i.top)) / 2
    }, this.Ah = Bn(t[0], t[1]), void 0 !== this.Ph.pinchStartEvent && this.Ph.pinchStartEvent(), this.Oh();
  }, t.prototype.Jh = function () {
    null !== this.Lh && (this.Lh = null, void 0 !== this.Ph.pinchEndEvent && this.Ph.pinchEndEvent());
  }, t.prototype.Kh = function (t) {
    this.Th && this.Th();
    var i = this.qh(t);
    this.jh(i, this.Ph.mouseLeaveEvent);
  }, t.prototype._h = function (t) {
    var i = this.qh(t);
    this.jh(i, this.Ph.longTapEvent), this.Dh = !0, this.Nh = !0;
  }, t.prototype.jh = function (t, i) {
    i && i.call(this.Ph, t);
  }, t.prototype.qh = function (t) {
    var i;
    i = "touches" in t && t.touches.length ? t.touches[0] : "changedTouches" in t && t.changedTouches.length ? t.changedTouches[0] : t;
    var n = An(this.Fh);
    return {
      clientX: i.clientX,
      clientY: i.clientY,
      pageX: i.pageX,
      pageY: i.pageY,
      screenX: i.screenX,
      screenY: i.screenY,
      localX: i.clientX - n.left,
      localY: i.clientY - n.top,
      ctrlKey: t.ctrlKey,
      altKey: t.altKey,
      shiftKey: t.shiftKey,
      metaKey: t.metaKey,
      type: t.type.startsWith("mouse") ? "mouse" : "touch",
      target: i.target,
      view: t.view
    };
  }, t;
}();
function An(t) {
  return t.getBoundingClientRect() || {
    left: 0,
    top: 0
  };
}
function Bn(t, i) {
  var n = t.clientX - i.clientX,
    s = t.clientY - i.clientY;
  return Math.sqrt(n * n + s * s);
}
function zn(t) {
  return Boolean(t.touches);
}
function Vn(t) {
  t.cancelable && t.preventDefault();
}
var Fn,
  Pn = function () {
    function t(t, i, n, s) {
      if (this.Qh = 0, this.tr = 0, this.ir = 0, this.nr = 0, this.sr = 0, this.hr = 0, this.rr = 0, this.ur = t, this.er = t.paneWidgets()[i], this.or = t.paneWidgets()[n], this.ar = document.createElement("tr"), this.ar.style.height = "1px", this.cr = document.createElement("td"), this.cr.style.padding = "0", this.cr.setAttribute("colspan", "3"), this.lr(), this.ar.appendChild(this.cr), s) this.vr = null, this.dr = null;else {
        this.vr = document.createElement("div"), this.vr.style.position = "absolute", this.vr.style.zIndex = "50", this.vr.style.height = "5px", this.vr.style.width = "100%", this.vr.style.backgroundColor = "rgba(255, 255, 255, 0.02)", this.vr.style.cursor = "ns-resize", this.cr.appendChild(this.vr);
        var h = {
          mouseDownEvent: this.Mr.bind(this),
          pressedMouseMoveEvent: this.wr.bind(this),
          mouseUpEvent: this.br.bind(this)
        };
        this.dr = new Ln(this.vr, h, {
          treatVertTouchDragAsPageScroll: !1,
          treatHorzTouchDragAsPageScroll: !0
        });
      }
    }
    return t.prototype.destroy = function () {
      null !== this.dr && this.dr.destroy();
    }, t.prototype.getElement = function () {
      return this.ar;
    }, t.prototype.getSize = function () {
      return new mn(this.er.getSize().w, 1);
    }, t.prototype.getImage = function () {
      var t = this.getSize(),
        i = kn(document, t),
        n = gn(i);
      return n.fillStyle = this.ur.options().timeScale.borderColor, n.fillRect(0, 0, t.w, t.h), i;
    }, t.prototype.update = function () {
      this.lr();
    }, t.prototype.lr = function () {
      this.cr.style.background = this.ur.options().timeScale.borderColor;
    }, t.prototype.Mr = function (t) {
      this.Qh = t.pageY, this.tr = 0, this.ir = this.er.getSize().h + this.or.getSize().h, this.nr = this.er.stretchFactor() + this.or.stretchFactor(), this.sr = 30, this.hr = this.ir - this.sr, this.rr = this.nr / this.ir;
    }, t.prototype.wr = function (t) {
      this.tr = t.pageY - this.Qh;
      var i = this.er.getSize().h,
        n = ot(i + this.tr, this.sr, this.hr) * this.rr,
        s = this.nr - n;
      this.er.setStretchFactor(n), this.or.setStretchFactor(s), this.ur.adjustSize(), this.er.getSize().h !== i && (this.Qh = t.pageY);
    }, t.prototype.br = function (t) {
      this.Qh = 0, this.tr = 0, this.ir = 0, this.nr = 0, this.sr = 0, this.hr = 0, this.rr = 0;
    }, t;
  }(),
  In = function () {
    function t(t, i, n, s) {
      this.$t = new Kt(200), this.Zt = 0, this.mr = "", this.pr = "", this.gr = [], this.yr = new Map(), this.Zt = t, this.mr = i, this.pr = Oi(t, n, s);
    }
    return t.prototype.destroy = function () {
      delete this.$t, this.gr = [], this.yr.clear();
    }, t.prototype.paintTo = function (t, i, n, s, h) {
      var r = this.kr(t, i);
      if ("left" !== h) {
        var u = pn(t.canvas);
        n -= Math.floor(r.textWidth * u);
      }
      s -= Math.floor(r.height / 2), t.drawImage(r.canvas, n, s, r.width, r.height);
    }, t.prototype.kr = function (t, i) {
      var n,
        s = this;
      if (this.yr.has(i)) n = a(this.yr.get(i));else {
        if (this.gr.length >= 200) {
          var h = a(this.gr.shift());
          this.yr.delete(h);
        }
        var r = pn(t.canvas),
          u = Math.ceil(this.Zt / 4.5),
          e = Math.round(this.Zt / 10),
          o = Math.ceil(this.$t.measureText(t, i)),
          f = ct(Math.round(o + 2 * u)),
          c = ct(this.Zt + 2 * u),
          l = kn(document, new mn(f, c));
        n = {
          text: i,
          textWidth: Math.round(Math.max(1, o)),
          width: Math.ceil(f * r),
          height: Math.ceil(c * r),
          canvas: l
        }, 0 !== o && (this.gr.push(n.text), this.yr.set(n.text, n)), q(t = gn(n.canvas), r, function () {
          t.font = s.pr, t.fillStyle = s.mr, t.fillText(i, 0, c - u - e);
        });
      }
      return n;
    }, t;
  }();
!function (t) {
  t[t.Default = 0] = "Default", t[t.NsResize = 1] = "NsResize";
}(Fn || (Fn = {}));
var On,
  Rn,
  Wn = function () {
    function t(t, i, n, s) {
      var h = this;
      this.B = null, this.Nr = null, this.Sr = null, this.xr = !1, this.Dr = !0, this.Cr = new Kt(50), this.Tr = new In(11, "#000"), this.mr = null, this.pr = null, this.Er = 0, this.Lr = function () {
        h.Ar(h.ah.options()), h.I.chart().model().lightUpdate();
      }, this.Br = function () {
        h.I.chart().model().lightUpdate();
      }, this.I = t, this.$ = i, this.ah = n, this.zr = "left" === s, this.cr = document.createElement("div"), this.cr.style.height = "100%", this.cr.style.overflow = "hidden", this.cr.style.width = "25px", this.cr.style.left = "0", this.cr.style.position = "relative", this.Vr = Nn(this.cr, new mn(16, 16)), this.Vr.subscribeCanvasConfigured(this.Lr);
      var r = this.Vr.canvas;
      r.style.position = "absolute", r.style.zIndex = "1", r.style.left = "0", r.style.top = "0", this.Fr = Nn(this.cr, new mn(16, 16)), this.Fr.subscribeCanvasConfigured(this.Br);
      var u = this.Fr.canvas;
      u.style.position = "absolute", u.style.zIndex = "2", u.style.left = "0", u.style.top = "0";
      var e = {
        mouseDownEvent: this.Mr.bind(this),
        pressedMouseMoveEvent: this.wr.bind(this),
        mouseDownOutsideEvent: this.Pr.bind(this),
        mouseUpEvent: this.br.bind(this),
        mouseDoubleClickEvent: this.Ir.bind(this),
        mouseEnterEvent: this.Or.bind(this),
        mouseLeaveEvent: this.Rr.bind(this)
      };
      this.dr = new Ln(this.Fr.canvas, e, {
        treatVertTouchDragAsPageScroll: !1,
        treatHorzTouchDragAsPageScroll: !0
      });
    }
    return t.prototype.destroy = function () {
      this.dr.destroy(), this.Fr.unsubscribeCanvasConfigured(this.Br), this.Fr.destroy(), this.Vr.unsubscribeCanvasConfigured(this.Lr), this.Vr.destroy(), null !== this.B && (this.B.onMarksChanged().unsubscribeAll(this), this.B.optionsChanged().unsubscribeAll(this)), this.B = null, null !== this.Sr && (clearTimeout(this.Sr), this.Sr = null), this.Tr.destroy();
    }, t.prototype.getElement = function () {
      return this.cr;
    }, t.prototype.backgroundColor = function () {
      return this.$.backgroundColor;
    }, t.prototype.lineColor = function () {
      return this.I.chart().options().priceScale.borderColor;
    }, t.prototype.textColor = function () {
      return this.$.textColor;
    }, t.prototype.fontSize = function () {
      return this.$.fontSize;
    }, t.prototype.baseFont = function () {
      return Oi(this.fontSize(), this.$.fontFamily);
    }, t.prototype.rendererOptions = function () {
      var t = this.ah.options(),
        i = this.mr !== t.color,
        n = this.pr !== t.font;
      return (i || n) && (this.Ar(t), this.mr = t.color), n && (this.Cr.reset(), this.pr = t.font), t;
    }, t.prototype.optimalWidth = function () {
      if (!this.isVisible() || null === this.B) return 0;
      var t = 34,
        i = this.rendererOptions(),
        n = gn(this.Vr.canvas),
        s = this.B.marks();
      n.font = this.baseFont(), s.length > 0 && (t = Math.max(this.Cr.measureText(n, s[0].label), this.Cr.measureText(n, s[s.length - 1].label)));
      for (var h = this.Wr(), r = h.length; r--;) {
        var u = this.Cr.measureText(n, h[r].text());
        u > t && (t = u);
      }
      var e = Math.ceil(i.borderSize + i.tickLength + i.paddingInner + i.paddingOuter + t);
      return e += e % 2;
    }, t.prototype.setSize = function (t) {
      if (t.w < 0 || t.h < 0) throw new Error("Try to set invalid size to PriceAxisWidget " + JSON.stringify(t));
      null !== this.Nr && this.Nr.equals(t) || (this.Nr = t, this.Vr.resizeCanvas({
        width: t.w,
        height: t.h
      }), this.Fr.resizeCanvas({
        width: t.w,
        height: t.h
      }), this.cr.style.width = t.w + "px", this.cr.style.height = t.h + "px", this.cr.style.minWidth = t.w + "px");
    }, t.prototype.getWidth = function () {
      return c(this.Nr).w;
    }, t.prototype.setPriceScale = function (t) {
      this.B !== t && (null !== this.B && (this.B.onMarksChanged().unsubscribeAll(this), this.B.optionsChanged().unsubscribeAll(this)), this.B = t, t.onMarksChanged().subscribe(this.cn.bind(this), this));
    }, t.prototype.priceScale = function () {
      return this.B;
    }, t.prototype.isVisible = function () {
      return this.Dr;
    }, t.prototype.setVisible = function (t) {
      t !== this.Dr && (this.cr.style.display = t ? "table-cell" : "none", this.Dr = t);
    }, t.prototype.setAutoScale = function (t) {
      var i = this.I.state();
      this.I.chart().model().setPriceAutoScale(i, c(this.priceScale()), t);
    }, t.prototype.reset = function () {
      var t = this.I.state();
      this.I.chart().model().resetPriceScale(t, c(this.priceScale()));
    }, t.prototype.paint = function (t) {
      if (this.Dr && null !== this.Nr) {
        if (1 !== t) {
          var i = gn(this.Vr.canvas);
          this.Ur(), this.qr(i, this.Vr.pixelRatio), this.Lt(i, this.Vr.pixelRatio), this.jr(i, this.Vr.pixelRatio), this.Hr(i, this.Vr.pixelRatio);
        }
        var n = gn(this.Fr.canvas),
          s = this.Nr.w,
          h = this.Nr.h;
        q(n, this.Fr.pixelRatio, function () {
          n.clearRect(0, 0, s, h);
        }), this.Yr(n, this.Fr.pixelRatio);
      }
    }, t.prototype.getImage = function () {
      return this.Vr.canvas;
    }, t.prototype.isLeft = function () {
      return this.zr;
    }, t.prototype.Mr = function (t) {
      if (null !== this.B && !this.B.isEmpty() && this.I.chart().options().handleScale.axisPressedMouseMove) {
        var i = this.I.chart().model(),
          n = this.I.state();
        this.xr = !0, i.startScalePrice(n, this.B, t.localY);
      }
    }, t.prototype.wr = function (t) {
      if (null !== this.B && this.I.chart().options().handleScale.axisPressedMouseMove) {
        var i = this.I.chart().model(),
          n = this.I.state(),
          s = this.B;
        i.scalePriceTo(n, s, t.localY);
      }
    }, t.prototype.Pr = function () {
      if (null !== this.B && this.I.chart().options().handleScale.axisPressedMouseMove) {
        var t = this.I.chart().model(),
          i = this.I.state(),
          n = this.B;
        this.xr && (this.xr = !1, t.endScalePrice(i, n));
      }
    }, t.prototype.br = function (t) {
      if (null !== this.B && this.I.chart().options().handleScale.axisPressedMouseMove) {
        var i = this.I.chart().model(),
          n = this.I.state();
        this.xr = !1, i.endScalePrice(n, this.B);
      }
    }, t.prototype.Ir = function (t) {
      this.I.chart().options().handleScale.axisDoubleClickReset && this.reset();
    }, t.prototype.Or = function (t) {
      null !== this.B && (!this.I.chart().model().options().handleScale.axisPressedMouseMove || this.B.isPercentage() || this.B.isIndexedTo100() || this.Kr(1));
    }, t.prototype.Rr = function (t) {
      this.Kr(0);
    }, t.prototype.Wr = function () {
      var t = this,
        i = [],
        n = null === this.B ? void 0 : this.B;
      return function (s) {
        for (var h = 0; h < s.length; ++h) for (var r = s[h].priceAxisViews(t.I.state(), n), u = 0; u < r.length; u++) i.push(r[u]);
      }(this.I.state().orderedSources()), i;
    }, t.prototype.qr = function (t, i) {
      var n = this;
      if (null !== this.Nr) {
        var s = this.Nr.w,
          h = this.Nr.h;
        q(t, i, function () {
          j(t, 0, 0, s, h, n.backgroundColor());
        });
      }
    }, t.prototype.Lt = function (t, i) {
      if (null !== this.Nr && null !== this.B && this.B.options().borderVisible) {
        t.save(), t.fillStyle = this.lineColor();
        var n,
          s = Math.max(1, Math.floor(this.rendererOptions().borderSize * i));
        n = this.zr ? Math.floor(this.Nr.w * i) - s : 0, t.fillRect(n, 0, s, Math.ceil(this.Nr.h * i)), t.restore();
      }
    }, t.prototype.jr = function (t, i) {
      if (null !== this.Nr && null !== this.B) {
        var n = this.B.marks();
        t.save(), t.strokeStyle = this.lineColor(), t.font = this.baseFont(), t.fillStyle = this.lineColor();
        var s = this.rendererOptions(),
          h = this.B.options().borderVisible,
          r = this.zr ? Math.floor((this.Nr.w - s.tickLength) * i - s.borderSize * i) : Math.floor(s.borderSize * i),
          u = this.zr ? Math.round(r - s.paddingInner * i) : Math.round(r + s.tickLength * i + s.paddingInner * i),
          e = this.zr ? "right" : "left",
          o = Math.max(1, Math.floor(i)),
          f = Math.floor(.5 * i);
        if (h) {
          var a = Math.round(s.tickLength * i);
          t.beginPath();
          for (var c = 0, l = n; c < l.length; c++) {
            var v = l[c];
            t.rect(r, Math.round(v.coord * i) - f, a, o);
          }
          t.fill();
        }
        t.fillStyle = this.textColor();
        for (var d = 0, M = n; d < M.length; d++) {
          v = M[d];
          this.Tr.paintTo(t, v.label, u, Math.round(v.coord * i), e);
        }
        t.restore();
      }
    }, t.prototype.Ur = function () {
      if (null !== this.Nr && null !== this.B) {
        var t = this.Nr.h / 2,
          i = [],
          n = this.B.orderedSources().slice(),
          s = this.I.state(),
          h = this.rendererOptions();
        this.B === s.defaultPriceScale() && this.I.state().orderedSources().forEach(function (t) {
          s.isOverlay(t) && n.push(t);
        });
        var r = this.B.mainSource(),
          u = this.B;
        n.forEach(function (n) {
          var h = n.priceAxisViews(s, u);
          h.forEach(function (t) {
            t.setFixedCoordinate(null), t.isVisible() && i.push(t);
          }), r === n && h.length > 0 && (t = h[0].coordinate());
        });
        var e = i.filter(function (i) {
            return i.coordinate() <= t;
          }),
          o = i.filter(function (i) {
            return i.coordinate() > t;
          });
        if (e.sort(function (t, i) {
          return i.coordinate() - t.coordinate();
        }), e.length && o.length && o.push(e[0]), o.sort(function (t, i) {
          return t.coordinate() - i.coordinate();
        }), i.forEach(function (t) {
          return t.setFixedCoordinate(t.coordinate());
        }), this.B.options().alignLabels) {
          for (var f = 1; f < e.length; f++) {
            var a = e[f],
              c = (v = e[f - 1]).height(h, !1);
            a.coordinate() > (d = v.getFixedCoordinate()) - c && a.setFixedCoordinate(d - c);
          }
          for (var l = 1; l < o.length; l++) {
            var v, d;
            a = o[l], c = (v = o[l - 1]).height(h, !0);
            a.coordinate() < (d = v.getFixedCoordinate()) + c && a.setFixedCoordinate(d + c);
          }
        }
      }
    }, t.prototype.Hr = function (t, i) {
      var n = this;
      if (null !== this.Nr) {
        t.save();
        var s = this.Nr,
          h = this.Wr(),
          r = this.rendererOptions(),
          u = this.zr ? "right" : "left";
        h.forEach(function (h) {
          if (h.isAxisLabelVisible()) {
            var e = h.renderer();
            t.save(), e.draw(t, r, n.Cr, s.w, u, i), t.restore();
          }
        }), t.restore();
      }
    }, t.prototype.Yr = function (t, i) {
      var n = this;
      if (null !== this.Nr && null !== this.B) {
        t.save();
        var s = this.Nr,
          h = this.I.chart().model(),
          r = [],
          u = this.I.state(),
          e = h.crosshairSource().priceAxisViews(u, this.B);
        e.length && r.push(e);
        var o = this.rendererOptions(),
          f = this.zr ? "right" : "left";
        r.forEach(function (h) {
          h.forEach(function (h) {
            t.save(), h.renderer().draw(t, o, n.Cr, s.w, f, i), t.restore();
          });
        }), t.restore();
      }
    }, t.prototype.Kr = function (t) {
      this.cr.style.cursor = 1 === t ? "ns-resize" : "default";
    }, t.prototype.cn = function () {
      var t = this,
        i = this.optimalWidth();
      if (this.Er < i) {
        var n = this.I.chart();
        null === this.Sr && (this.Sr = setTimeout(function () {
          n && n.model().fullUpdate(), t.Sr = null;
        }, 100));
      }
      this.Er = i;
    }, t.prototype.Ar = function (t) {
      this.Tr.destroy(), this.Tr = new In(t.fontSize, t.color, t.fontFamily);
    }, t;
  }(),
  Un = En,
  qn = function () {
    function t(t, i) {
      var n = this;
      this.Nr = new mn(0, 0), this.$r = null, this._r = null, this.Xr = !1, this.Zr = "none", this.Jr = new rt(), this.Gr = 0, this.Qr = !1, this.tu = null, this.iu = !1, this.nu = null, this.Lr = function () {
        return n.su && n.F().lightUpdate();
      }, this.Br = function () {
        return n.su && n.F().lightUpdate();
      }, this.hu = t, this.su = i, this.su.onDestroyed().subscribe(this.ru.bind(this), this, !0), this.uu = document.createElement("td"), this.uu.style.padding = "0", this.uu.style.position = "relative";
      var s = document.createElement("div");
      s.style.width = "100%", s.style.height = "100%", s.style.position = "relative", s.style.overflow = "hidden", this.eu = document.createElement("td"), this.eu.style.padding = "0", this.ou = document.createElement("td"), this.ou.style.padding = "0", this.uu.appendChild(s), this.Vr = Nn(s, new mn(16, 16)), this.Vr.subscribeCanvasConfigured(this.Lr);
      var h = this.Vr.canvas;
      h.style.position = "absolute", h.style.zIndex = "1", h.style.left = "0", h.style.top = "0", this.Fr = Nn(s, new mn(16, 16)), this.Fr.subscribeCanvasConfigured(this.Br);
      var r = this.Fr.canvas;
      r.style.position = "absolute", r.style.zIndex = "2", r.style.left = "0", r.style.top = "0", this.ar = document.createElement("tr"), this.ar.appendChild(this.eu), this.ar.appendChild(this.uu), this.ar.appendChild(this.ou), this.fu(), t.model().mainPriceScaleOptionsChanged().subscribe(this.au.bind(this), this), this.updatePriceAxisWidget();
      var u = this.chart().options().handleScroll;
      this.dr = new Ln(this.Fr.canvas, this, {
        treatVertTouchDragAsPageScroll: !u.vertTouchDrag,
        treatHorzTouchDragAsPageScroll: !u.horzTouchDrag
      });
    }
    return t.prototype.destroy = function () {
      null !== this.$r && this.$r.destroy(), this.Fr.unsubscribeCanvasConfigured(this.Br), this.Fr.destroy(), this.Vr.unsubscribeCanvasConfigured(this.Lr), this.Vr.destroy(), null !== this.su && this.su.onDestroyed().unsubscribeAll(this), this.dr.destroy();
    }, t.prototype.state = function () {
      return c(this.su);
    }, t.prototype.stateOrNull = function () {
      return this.su;
    }, t.prototype.setState = function (i) {
      null !== this.su && this.su.onDestroyed().unsubscribeAll(this), this.su = i, null !== this.su && this.su.onDestroyed().subscribe(t.prototype.ru.bind(this), this, !0), this.updatePriceAxisWidget();
    }, t.prototype.chart = function () {
      return this.hu;
    }, t.prototype.getElement = function () {
      return this.ar;
    }, t.prototype.updatePriceAxisWidget = function () {
      if (null !== this.su && null !== this.$r && 0 !== this.F().serieses().length) {
        var t = this.su.defaultPriceScale();
        this.$r.setPriceScale(c(t));
      }
    }, t.prototype.stretchFactor = function () {
      return null !== this.su ? this.su.stretchFactor() : 0;
    }, t.prototype.setStretchFactor = function (t) {
      this.su && this.su.setStretchFactor(t);
    }, t.prototype.mouseEnterEvent = function (t) {
      if (this.su) {
        var i = t.localX,
          n = t.localY;
        Dn || this.cu(i, n);
      }
    }, t.prototype.mouseDownEvent = function (t) {
      if (this.Qr = !1, this.iu = null !== this.tu, this.su) {
        if (document.activeElement !== document.body && document.activeElement !== document.documentElement) c(document.activeElement).blur();else {
          var i = document.getSelection();
          null !== i && i.removeAllRanges();
        }
        var n = this.F();
        if (!this.su.defaultPriceScale().isEmpty() && !n.timeScale().isEmpty()) {
          if (null !== this.tu) {
            var s = n.crosshairSource();
            this.nu = {
              x: s.appliedX(),
              y: s.appliedY()
            }, this.tu = {
              x: t.localX,
              y: t.localY
            };
          }
          Dn || this.cu(t.localX, t.localY);
        }
      }
    }, t.prototype.mouseMoveEvent = function (t) {
      if (this.su) {
        var i = t.localX,
          n = t.localY;
        if (this.lu() && this.vu(), !Dn) {
          this.cu(i, n);
          var s = this.hitTest(i, n);
          this.F().setHoveredSource(s && {
            source: s.source,
            object: s.object
          }), null !== s && void 0 !== s.view.moveHandler && s.view.moveHandler(i, n);
        }
      }
    }, t.prototype.mouseClickEvent = function (t) {
      if (null !== this.su) {
        var i = t.localX,
          n = t.localY,
          s = this.hitTest(i, n);
        if (null !== s && void 0 !== s.view.clickHandler && s.view.clickHandler(i, n), this.Jr.hasListeners()) {
          var h = this.F().crosshairSource().appliedIndex();
          this.Jr.fire(h, {
            x: i,
            y: n
          });
        }
        this.du();
      }
    }, t.prototype.pressedMouseMoveEvent = function (t) {
      if (null !== this.su) {
        var i = this.F(),
          n = t.localX,
          s = t.localY;
        if (null !== this.tu) {
          this.iu = !1;
          var h = c(this.nu),
            r = h.x + (n - this.tu.x),
            u = h.y + (s - this.tu.y);
          this.cu(r, u);
        } else this.lu() || this.cu(n, s);
        if (!i.timeScale().isEmpty()) {
          var e = this.hu.options().handleScroll;
          if (e.pressedMouseMove && "touch" !== t.type || (e.horzTouchDrag || e.vertTouchDrag) && "mouse" !== t.type) {
            var o = this.su.defaultPriceScale();
            null !== this._r || this.Mu() || (this._r = {
              x: t.clientX,
              y: t.clientY
            }), null === this._r || this._r.x === t.clientX && this._r.y === t.clientY || this.Xr || (o.isEmpty() || i.startScrollPrice(this.su, o, t.localY), i.startScrollTime(t.localX), this.Xr = !0), this.Xr && (o.isEmpty() || i.scrollPriceTo(this.su, o, t.localY), i.scrollTimeTo(t.localX));
          }
        }
      }
    }, t.prototype.mouseUpEvent = function (t) {
      if (null !== this.su) {
        this.Qr = !1;
        var i = this.F();
        if (this.Xr) {
          var n = this.su.defaultPriceScale();
          i.endScrollPrice(this.su, n), i.endScrollTime(), this._r = null, this.Xr = !1;
        }
      }
    }, t.prototype.longTapEvent = function (t) {
      if (this.Qr = !0, null === this.tu && Un) {
        var i = {
          x: t.localX,
          y: t.localY
        };
        this.wu(i, i);
      }
    }, t.prototype.mouseLeaveEvent = function (t) {
      null !== this.su && (this.su.model().setHoveredSource(null), En || this.vu());
    }, t.prototype.clicked = function () {
      return this.Jr;
    }, t.prototype.pinchStartEvent = function () {
      this.Gr = 1;
    }, t.prototype.pinchEvent = function (t, i) {
      if (this.hu.options().handleScale.pinch) {
        var n = 5 * (i - this.Gr);
        this.Gr = i, this.F().zoomTime(t.x, n);
      }
    }, t.prototype.hitTest = function (t, i) {
      var n = this.su;
      if (null === n) return null;
      for (var s = 0, h = n.orderedSources(); s < h.length; s++) {
        var r = h[s],
          u = this.bu(r.paneViews(n), t, i);
        if (null !== u) return {
          source: r,
          view: u.view,
          object: u.object
        };
      }
      return null;
    }, t.prototype.setPriceAxisSize = function (t) {
      c(this.$r).setSize(new mn(t, this.Nr.h));
    }, t.prototype.getSize = function () {
      return this.Nr;
    }, t.prototype.setSize = function (t) {
      if (t.w < 0 || t.h < 0) throw new Error("Try to set invalid size to PaneWidget " + JSON.stringify(t));
      this.Nr.equals(t) || (this.Nr = t, this.Vr.resizeCanvas({
        width: t.w,
        height: t.h
      }), this.Fr.resizeCanvas({
        width: t.w,
        height: t.h
      }), this.uu.style.width = t.w + "px", this.uu.style.height = t.h + "px");
    }, t.prototype.recalculatePriceScale = function () {
      var t = c(this.su);
      t.recalculatePriceScale(t.defaultPriceScale());
      for (var i = 0, n = t.dataSources(); i < n.length; i++) {
        var s = n[i];
        if (t.isOverlay(s)) {
          var h = s.priceScale();
          null !== h && t.recalculatePriceScale(h), s.updateAllViews();
        }
      }
    }, t.prototype.getImage = function () {
      return this.Vr.canvas;
    }, t.prototype.paint = function (t) {
      if (0 !== t && null !== this.su) {
        if (t > 1 && this.recalculatePriceScale(), null !== this.$r && this.$r.paint(t), 1 !== t) {
          var i = gn(this.Vr.canvas);
          i.save(), this.qr(i, this.mu(), this.Vr.pixelRatio), this.su && (this.pu(i, this.Vr.pixelRatio), this.gu(i, this.Vr.pixelRatio), this.yu(i, this.Vr.pixelRatio)), i.restore();
        }
        var n = gn(this.Fr.canvas);
        n.clearRect(0, 0, Math.ceil(this.Nr.w * this.Fr.pixelRatio), Math.ceil(this.Nr.h * this.Fr.pixelRatio)), this.ku(n, this.Fr.pixelRatio);
      }
    }, t.prototype.priceAxisWidget = function () {
      return this.$r;
    }, t.prototype.mu = function () {
      return this.hu.options().layout.backgroundColor;
    }, t.prototype.ru = function () {
      null !== this.su && this.su.onDestroyed().unsubscribeAll(this), this.su = null;
    }, t.prototype.qr = function (t, i, n) {
      var s = this;
      q(t, n, function () {
        j(t, 0, 0, s.Nr.w, s.Nr.h, i);
      });
    }, t.prototype.pu = function (t, i) {
      for (var n = c(this.su), s = this.F().gridSource().paneViews(n), h = n.height(), r = n.width(), u = 0, e = s; u < e.length; u++) {
        var o = e[u];
        t.save();
        var f = o.renderer(h, r);
        null !== f && f.draw(t, i, !1), t.restore();
      }
    }, t.prototype.gu = function (t, i) {
      var n = this.F().watermarkSource();
      if (null !== n) {
        var s = c(this.su);
        if (s.containsSeries()) for (var h = n.paneViews(), r = s.height(), u = s.width(), e = 0, o = h; e < o.length; e++) {
          var f = o[e];
          t.save();
          var a = f.renderer(r, u);
          null !== a && a.draw(t, i, !1), t.restore();
        }
      }
    }, t.prototype.ku = function (t, i) {
      this.Nu(this.F().crosshairSource(), t, i);
    }, t.prototype.yu = function (t, i) {
      for (var n = c(this.su).orderedSources(), s = this.F().crosshairSource(), h = 0, r = n; h < r.length; h++) {
        var u = r[h];
        this.Su(u, t, i);
      }
      for (var e = 0, o = n; e < o.length; e++) {
        (u = o[e]) !== s && this.Nu(u, t, i);
      }
    }, t.prototype.Nu = function (t, i, n) {
      for (var s = c(this.su), h = t.paneViews(s), r = s.height(), u = s.width(), e = s.model().hoveredSource(), o = null !== e && e.source === t, f = null !== e && o && void 0 !== e.object ? e.object.hitTestData : void 0, a = 0, l = h; a < l.length; a++) {
        var v = l[a].renderer(r, u);
        null !== v && (i.save(), v.draw(i, n, o, f), i.restore());
      }
    }, t.prototype.Su = function (t, i, n) {
      for (var s = c(this.su), h = t.paneViews(s), r = s.height(), u = s.width(), e = s.model().hoveredSource(), o = null !== e && e.source === t, f = null !== e && o && void 0 !== e.object ? e.object.hitTestData : void 0, a = 0, l = h; a < l.length; a++) {
        var v = l[a].renderer(r, u);
        null !== v && void 0 !== v.drawBackground && (i.save(), v.drawBackground(i, n, o, f), i.restore());
      }
    }, t.prototype.bu = function (t, i, n) {
      for (var s = 0, h = t; s < h.length; s++) {
        var r = h[s],
          u = r.renderer(this.Nr.h, this.Nr.w);
        if (null !== u && u.hitTest) {
          var e = u.hitTest(i, n);
          if (null !== e) return {
            view: r,
            object: e
          };
        }
      }
      return null;
    }, t.prototype.au = function () {
      this.fu(), this.hu.adjustSize();
    }, t.prototype.fu = function () {
      if (null !== this.su) {
        var t = this.hu,
          i = this.su.defaultPriceScale().options().position;
        if (this.Zr !== i) {
          if (null !== this.$r && (this.$r.isLeft() ? this.eu.removeChild(this.$r.getElement()) : this.ou.removeChild(this.$r.getElement()), this.$r.destroy(), this.$r = null), "none" !== i) {
            var n = t.model().rendererOptionsProvider();
            this.$r = new Wn(this, t.options().layout, n, i), "left" === i && this.eu.appendChild(this.$r.getElement()), "right" === i && this.ou.appendChild(this.$r.getElement());
          }
          this.Zr = i;
        }
      }
    }, t.prototype.lu = function () {
      return Un && null === this.tu;
    }, t.prototype.Mu = function () {
      return Un && this.Qr || null !== this.tu;
    }, t.prototype.xu = function (t) {
      return Math.max(0, Math.min(t, this.Nr.w - 1));
    }, t.prototype.Du = function (t) {
      return Math.max(0, Math.min(t, this.Nr.h - 1));
    }, t.prototype.cu = function (t, i) {
      this.F().setAndSaveCurrentPosition(this.xu(t), this.Du(i), c(this.su));
    }, t.prototype.vu = function () {
      this.F().clearCurrentPosition();
    }, t.prototype.du = function () {
      this.iu && (this.tu = null, this.vu());
    }, t.prototype.wu = function (t, i) {
      this.tu = t, this.iu = !1, this.cu(i.x, i.y);
      var n = this.F().crosshairSource();
      this.nu = {
        x: n.appliedX(),
        y: n.appliedY()
      };
    }, t.prototype.F = function () {
      return this.hu.model();
    }, t;
  }(),
  jn = function () {
    function t(t, i, n, s) {
      var h = this;
      this.o = !0, this.Nr = new mn(0, 0), this.Lr = function () {
        return h.paint(3);
      }, this.zr = "left" === t, this.ah = n.rendererOptionsProvider, this.$ = i, this.Cu = s, this.cr = document.createElement("div"), this.cr.style.width = "25px", this.cr.style.height = "100%", this.cr.style.overflow = "hidden", this.Vr = Nn(this.cr, new mn(16, 16)), this.Vr.subscribeCanvasConfigured(this.Lr);
    }
    return t.prototype.destroy = function () {
      this.Vr.unsubscribeCanvasConfigured(this.Lr), this.Vr.destroy();
    }, t.prototype.update = function () {
      this.o = !0;
    }, t.prototype.getElement = function () {
      return this.cr;
    }, t.prototype.getSize = function () {
      return this.Nr;
    }, t.prototype.setSize = function (t) {
      if (t.w < 0 || t.h < 0) throw new Error("Try to set invalid size to PriceAxisStub " + JSON.stringify(t));
      this.Nr.equals(t) || (this.Nr = t, this.Vr.resizeCanvas({
        width: t.w,
        height: t.h
      }), this.cr.style.width = t.w + "px", this.cr.style.minWidth = t.w + "px", this.cr.style.height = t.h + "px", this.o = !0);
    }, t.prototype.paint = function (t) {
      if ((!(t < 3) || this.o) && 0 !== this.Nr.w && 0 !== this.Nr.h) {
        this.o = !1;
        var i = gn(this.Vr.canvas);
        this.qr(i, this.Vr.pixelRatio), this.Lt(i, this.Vr.pixelRatio);
      }
    }, t.prototype.getImage = function () {
      return this.Vr.canvas;
    }, t.prototype.isLeft = function () {
      return this.zr;
    }, t.prototype.Lt = function (t, i) {
      if (this.Cu()) {
        var n = this.Nr.w;
        t.save(), t.fillStyle = this.$.timeScale.borderColor;
        var s = Math.floor(this.ah.options().borderSize * i),
          h = this.zr ? Math.round(n * i) - s : 0;
        t.fillRect(h, 0, s, s), t.restore();
      }
    }, t.prototype.qr = function (t, i) {
      var n = this;
      q(t, i, function () {
        j(t, 0, 0, n.Nr.w, n.Nr.h, n.$.layout.backgroundColor);
      });
    }, t;
  }();
function Hn(t, i) {
  return t.span > i.span ? t : i;
}
!function (t) {
  t[t.BorderSize = 1] = "BorderSize", t[t.TickLength = 3] = "TickLength";
}(On || (On = {})), function (t) {
  t[t.Default = 0] = "Default", t[t.EwResize = 1] = "EwResize";
}(Rn || (Rn = {}));
var Yn = function () {
    function t(t) {
      var i = this;
      this.Tu = null, this.Eu = 70, this.Ht = null, this.Lu = !1, this.Nr = new mn(0, 0), this.Zr = "none", this.Lr = function () {
        return i.hu.model().lightUpdate();
      }, this.Br = function () {
        return i.hu.model().lightUpdate();
      }, this.hu = t, this.$ = t.options().layout, this.Au = document.createElement("tr"), this.Bu = document.createElement("td"), this.Bu.style.padding = "0", this.zu = document.createElement("td"), this.zu.style.padding = "0", this.cr = document.createElement("td"), this.cr.style.height = "25px", this.cr.style.padding = "0", this.Vu = document.createElement("div"), this.Vu.style.width = "100%", this.Vu.style.height = "100%", this.Vu.style.position = "relative", this.Vu.style.overflow = "hidden", this.cr.appendChild(this.Vu), this.Vr = Nn(this.Vu, new mn(16, 16)), this.Vr.subscribeCanvasConfigured(this.Lr);
      var n = this.Vr.canvas;
      n.style.position = "absolute", n.style.zIndex = "1", n.style.left = "0", n.style.top = "0", this.Fr = Nn(this.Vu, new mn(16, 16)), this.Fr.subscribeCanvasConfigured(this.Br);
      var s = this.Fr.canvas;
      s.style.position = "absolute", s.style.zIndex = "2", s.style.left = "0", s.style.top = "0", this.Au.appendChild(this.Bu), this.Au.appendChild(this.cr), this.Au.appendChild(this.zu), this.Fu(), this.hu.model().mainPriceScaleOptionsChanged().subscribe(this.Fu.bind(this), this), this.dr = new Ln(this.Fr.canvas, this, {
        treatVertTouchDragAsPageScroll: !0,
        treatHorzTouchDragAsPageScroll: !1
      });
    }
    return t.prototype.destroy = function () {
      this.dr.destroy(), null !== this.Tu && this.Tu.destroy(), this.Fr.unsubscribeCanvasConfigured(this.Br), this.Fr.destroy(), this.Vr.unsubscribeCanvasConfigured(this.Lr), this.Vr.destroy();
    }, t.prototype.getElement = function () {
      return this.Au;
    }, t.prototype.stub = function () {
      return this.Tu;
    }, t.prototype.mouseDownEvent = function (t) {
      if (!this.Lu) {
        this.Lu = !0;
        var i = this.hu.model();
        !i.timeScale().isEmpty() && this.hu.options().handleScale.axisPressedMouseMove && i.startScaleTime(t.localX);
      }
    }, t.prototype.mouseDownOutsideEvent = function () {
      var t = this.hu.model();
      !t.timeScale().isEmpty() && this.Lu && (this.Lu = !1, this.hu.options().handleScale.axisPressedMouseMove && t.endScaleTime());
    }, t.prototype.pressedMouseMoveEvent = function (t) {
      var i = this.hu.model();
      !i.timeScale().isEmpty() && this.hu.options().handleScale.axisPressedMouseMove && i.scaleTimeTo(t.localX);
    }, t.prototype.mouseUpEvent = function (t) {
      this.Lu = !1;
      var i = this.hu.model();
      i.timeScale().isEmpty() && !this.hu.options().handleScale.axisPressedMouseMove || i.endScaleTime();
    }, t.prototype.mouseDoubleClickEvent = function () {
      this.hu.options().handleScale.axisDoubleClickReset && this.hu.model().resetTimeScale();
    }, t.prototype.mouseEnterEvent = function (t) {
      this.hu.model().options().handleScale.axisPressedMouseMove && this.Kr(1);
    }, t.prototype.mouseLeaveEvent = function (t) {
      this.Kr(0);
    }, t.prototype.getSize = function () {
      return this.Nr;
    }, t.prototype.setSizes = function (t, i) {
      this.Nr && this.Nr.equals(t) || (this.Nr = t, this.Vr.resizeCanvas({
        width: t.w,
        height: t.h
      }), this.Fr.resizeCanvas({
        width: t.w,
        height: t.h
      }), this.cr.style.width = t.w + "px", this.cr.style.height = t.h + "px"), null !== this.Tu && this.Tu.setSize(new mn(i, t.h));
    }, t.prototype.width = function () {
      return this.Nr.w;
    }, t.prototype.height = function () {
      return this.Nr.h;
    }, t.prototype.optimalHeight = function () {
      var t = this.Pu();
      return Math.ceil(t.borderSize + t.tickLength + t.fontSize + t.paddingTop + t.paddingBottom);
    }, t.prototype.update = function () {
      var t = this,
        i = this.hu.model().timeScale().marks();
      i && (this.Eu = 70, i.forEach(function (i) {
        t.Eu = Math.min(i.span, t.Eu);
      }));
    }, t.prototype.getImage = function () {
      return this.Vr.canvas;
    }, t.prototype.paint = function (t) {
      if (0 !== t) {
        if (1 !== t) {
          var i = gn(this.Vr.canvas);
          this.qr(i, this.Vr.pixelRatio), this.Lt(i, this.Vr.pixelRatio), this.jr(i, this.Vr.pixelRatio), this.Hr(i, this.Vr.pixelRatio), null !== this.Tu && this.Tu.paint(t);
        }
        var n = gn(this.Fr.canvas);
        this.Yr(n, this.Fr.pixelRatio);
      }
    }, t.prototype.qr = function (t, i) {
      var n = this;
      q(t, i, function () {
        j(t, 0, 0, n.Nr.w, n.Nr.h, n.mu());
      });
    }, t.prototype.Lt = function (t, i) {
      if (this.hu.options().timeScale.borderVisible) {
        t.save(), t.fillStyle = this.Iu();
        var n = Math.max(1, Math.floor(this.Pu().borderSize * i));
        t.fillRect(0, 0, Math.ceil(this.Nr.w * i), n), t.restore();
      }
    }, t.prototype.jr = function (t, i) {
      var n = this,
        s = this.hu.model().timeScale().marks();
      if (s && 0 !== s.length) {
        var h = s.reduce(Hn, s[0]).span;
        h > 30 && h < 40 && (h = 30), t.save(), t.strokeStyle = this.Iu();
        var r = this.Pu(),
          u = r.borderSize + r.tickLength + r.paddingTop + r.fontSize - r.baselineOffset;
        t.textAlign = "center", t.fillStyle = this.Iu();
        var e = Math.floor(this.Pu().borderSize * i),
          o = Math.max(1, Math.floor(i)),
          f = Math.floor(.5 * i);
        if (this.hu.model().timeScale().options().borderVisible) {
          t.beginPath();
          for (var a = Math.round(r.tickLength * i), c = s.length; c--;) {
            var l = Math.round(s[c].coord * i);
            t.rect(l - f, e, o, a);
          }
          t.fill();
        }
        t.fillStyle = this.Pn(), q(t, i, function () {
          t.font = n.Ou();
          for (var i = 0, r = s; i < r.length; i++) {
            (f = r[i]).span < h && t.fillText(f.label, f.coord, u);
          }
          t.font = n.Ru();
          for (var e = 0, o = s; e < o.length; e++) {
            var f;
            (f = o[e]).span >= h && t.fillText(f.label, f.coord, u);
          }
        });
      }
    }, t.prototype.Hr = function (t, i) {
      t.save();
      var n = new Set(),
        s = this.hu.model(),
        h = s.dataSources();
      n.add(s.crosshairSource());
      for (var r = this.Pu(), u = 0, e = h; u < e.length; u++) {
        var o = e[u];
        if (!n.has(o)) for (var f = 0, a = o.timeAxisViews(); f < a.length; f++) {
          a[f].renderer().draw(t, r, i);
        }
      }
      t.restore();
    }, t.prototype.Yr = function (t, i) {
      t.save(), t.clearRect(0, 0, Math.ceil(this.Nr.w * i), Math.ceil(this.Nr.h * i));
      var n = [],
        s = this.hu.model().crosshairSource().timeAxisViews();
      n.push(s);
      var h = this.Pu();
      n.forEach(function (n) {
        n.forEach(function (n) {
          t.save(), n.renderer().draw(t, h, i), t.restore();
        });
      }), t.restore();
    }, t.prototype.mu = function () {
      return this.$.backgroundColor;
    }, t.prototype.Iu = function () {
      return this.hu.options().timeScale.borderColor;
    }, t.prototype.Pn = function () {
      return this.$.textColor;
    }, t.prototype.Zt = function () {
      return this.$.fontSize;
    }, t.prototype.Ou = function () {
      return Oi(this.Zt(), this.$.fontFamily);
    }, t.prototype.Ru = function () {
      return Oi(this.Zt(), this.$.fontFamily, "bold");
    }, t.prototype.Pu = function () {
      null === this.Ht && (this.Ht = {
        borderSize: 1,
        baselineOffset: NaN,
        paddingTop: NaN,
        paddingBottom: NaN,
        paddingHorizontal: NaN,
        tickLength: 3,
        fontSize: NaN,
        font: "",
        widthCache: new Kt()
      });
      var t = this.Ht,
        i = this.Ou();
      if (t.font !== i) {
        var n = this.Zt();
        t.fontSize = n, t.font = i, t.paddingTop = Math.ceil(n / 2.5), t.paddingBottom = t.paddingTop, t.paddingHorizontal = Math.ceil(n / 2), t.baselineOffset = Math.round(this.Zt() / 5), t.widthCache.reset();
      }
      return this.Ht;
    }, t.prototype.Kr = function (t) {
      this.cr.style.cursor = 1 === t ? "ew-resize" : "default";
    }, t.prototype.Fu = function () {
      var t = this.hu.model().mainPriceScale().options().position;
      if (t !== this.Zr) {
        if (null !== this.Tu && (this.Tu.isLeft() ? this.Bu.removeChild(this.Tu.getElement()) : this.zu.removeChild(this.Tu.getElement()), this.Tu.destroy(), this.Tu = null), "none" !== t) {
          var i = {
              rendererOptionsProvider: this.hu.model().rendererOptionsProvider()
            },
            n = this.hu.model();
          this.Tu = new jn(t, this.hu.options(), i, function () {
            return n.mainPriceScale().options().borderVisible && n.timeScale().options().borderVisible;
          }), ("left" === t ? this.Bu : this.zu).appendChild(this.Tu.getElement());
        }
        this.Zr = t;
      }
    }, t;
  }(),
  Kn = function () {
    function t(t, i) {
      var n = this;
      this.Wu = [], this.Uu = [], this.qu = 0, this.ju = new rt(), this.nn = 0, this.Kt = 0, this.Hu = 0, this.Yu = null, this.Ku = !1, this.Jr = new rt(), this.oh = new rt(), this.$ = i, this.Au = document.createElement("div"), this.Au.classList.add("tv-lightweight-charts"), this.Au.style.overflow = "hidden", this.Au.style.width = "100%", this.Au.style.height = "100%", this.$u = document.createElement("table"), this.$u.setAttribute("cellspacing", "0"), this.Au.appendChild(this.$u), this._u = this.Xu.bind(this), this.Au.addEventListener("wheel", this._u, {
        passive: !1
      }), this.F = new bn(this.fh.bind(this), this.$), this.model().crosshairMoved().subscribe(this.Zu.bind(this), this), this.Ju = new Yn(this), this.$u.appendChild(this.Ju.getElement());
      var s = this.$.width,
        h = this.$.height;
      if (0 === s && 0 === h) {
        var r = t.getBoundingClientRect();
        (s = Math.floor(r.width)) % 2 && (s -= 1), (h = Math.floor(r.height)) % 2 && (h -= 1);
      }
      s = Math.max(70, s), h = Math.max(50, h), this.resize(s, h), this.Gu(), t.appendChild(this.Au), this.Qu(), this.F.timeScale().optionsApplied().subscribe(function () {
        n.Qu(), n.adjustSize();
      }, this);
    }
    return t.prototype.model = function () {
      return this.F;
    }, t.prototype.options = function () {
      return this.$;
    }, t.prototype.paneWidgets = function () {
      return this.Wu;
    }, t.prototype.destroy = function () {
      this.Au.removeEventListener("wheel", this._u), 0 !== this.qu && window.cancelAnimationFrame(this.qu), this.F.crosshairMoved().unsubscribeAll(this), this.F.timeScale().optionsApplied().unsubscribeAll(this), this.F.destroy();
      for (var t = 0, i = this.Wu; t < i.length; t++) {
        var n = i[t];
        this.$u.removeChild(n.getElement()), n.clicked().unsubscribeAll(this), n.destroy();
      }
      this.Wu = [];
      for (var s = 0, h = this.Uu; s < h.length; s++) {
        var r = h[s];
        this.te(r);
      }
      this.Uu = [], c(this.Ju).destroy(), null !== this.Au.parentElement && this.Au.parentElement.removeChild(this.Au), this.oh.destroy(), this.Jr.destroy(), delete this.Au;
    }, t.prototype.resize = function (t, i, n) {
      if (void 0 === n && (n = !1), this.nn !== i || this.Kt !== t) {
        this.nn = i, this.Kt = t;
        var s = i + "px",
          h = t + "px";
        c(this.Au).style.height = s, c(this.Au).style.width = h, this.$u.style.height = s, this.$u.style.width = h, n ? this.ie(new Hi(3)) : this.F.fullUpdate();
      }
    }, t.prototype.paint = function (t) {
      void 0 === t && (t = new Hi(3));
      for (var i = 0; i < this.Wu.length; i++) this.Wu[i].paint(t.invalidateForPane(i).level);
      this.Ju.paint(t.fullInvalidation());
    }, t.prototype.adjustSize = function () {
      this.ne(), this.F.fullUpdate();
    }, t.prototype.applyOptions = function (t) {
      this.F.applyOptions(t), this.Qu();
      var i = t.width || this.Kt,
        n = t.height || this.nn;
      this.resize(i, n);
    }, t.prototype.clicked = function () {
      return this.Jr;
    }, t.prototype.crosshairMoved = function () {
      return this.oh;
    }, t.prototype.takeScreenshot = function () {
      var t = this;
      null !== this.Yu && (this.ie(this.Yu), this.Yu = null);
      var i = this.Wu[0],
        n = kn(document, new mn(this.Kt, this.nn)),
        s = gn(n),
        h = pn(n);
      return q(s, h, function () {
        var n = 0,
          h = 0,
          r = function r() {
            for (var i = 0; i < t.Wu.length; i++) {
              var r = t.Wu[i],
                u = r.getSize().h,
                e = c(r.priceAxisWidget()),
                o = e.getImage();
              s.drawImage(o, n, h, e.getWidth(), u), h += u, i < t.Wu.length - 1 && (h += 1);
            }
          };
        "left" === t.$.priceScale.position && (r(), n = c(i.priceAxisWidget()).getWidth()), h = 0;
        for (var u = 0; u < t.Wu.length; u++) {
          var e = t.Wu[u],
            o = e.getSize(),
            f = e.getImage();
          if (s.drawImage(f, n, h, o.w, o.h), h += o.h, u < t.Wu.length - 1) {
            var a = t.Uu[u],
              l = a.getSize(),
              v = a.getImage();
            s.drawImage(v, n, h, l.w, l.h), h += l.h;
          }
        }
        n += i.getSize().w, "right" === t.$.priceScale.position && (h = 0, r());
        var d = function d() {
          var i = c(t.Ju.stub()),
            r = i.getSize(),
            u = i.getImage();
          s.drawImage(u, n, h, r.w, r.h);
        };
        if (t.$.timeScale.visible) {
          n = 0, "left" === t.$.priceScale.position && (d(), n = c(i.priceAxisWidget()).getWidth());
          var M = t.Ju.getSize();
          f = t.Ju.getImage();
          s.drawImage(f, n, h, M.w, M.h), "right" === t.$.priceScale.position && (n = i.getSize().w, d(), s.restore());
        }
      }), n;
    }, t.prototype.ne = function () {
      for (var t = 0, i = 0, n = 0, s = this.Wu; n < s.length; n++) {
        var h = s[n];
        "none" !== this.$.priceScale.position && (i = Math.max(i, c(h.priceAxisWidget()).optimalWidth())), t += h.stretchFactor();
      }
      var r = this.Kt,
        u = this.nn,
        e = Math.max(r - i, 0),
        o = 1 * this.Uu.length,
        f = this.$.timeScale.visible ? this.Ju.optimalHeight() : 0;
      f % 2 && (f += 1);
      for (var a = o + f, l = u < a ? 0 : u - a, v = l / t, d = 0, M = 0; M < this.Wu.length; ++M) {
        (h = this.Wu[M]).setState(this.F.panes()[M]);
        var w,
          b = 0;
        b = M === this.Wu.length - 1 ? l - d : Math.round(h.stretchFactor() * v), d += w = Math.max(b, 2), h.setSize(new mn(e, w)), "none" !== this.$.priceScale.position && h.setPriceAxisSize(i), h.state() && this.F.setPaneHeight(h.state(), w);
      }
      this.Ju.setSizes(new mn(e, f), i), this.F.setWidth(e), this.Hu !== i && (this.Hu = i, this.ju.fire(i));
    }, t.prototype.Xu = function (t) {
      var i = t.deltaX / 100,
        n = -t.deltaY / 100;
      if (0 !== i && this.$.handleScroll.mouseWheel || 0 !== n && this.$.handleScale.mouseWheel) {
        switch (t.cancelable && t.preventDefault(), t.deltaMode) {
          case t.DOM_DELTA_PAGE:
            i *= 120, n *= 120;
            break;
          case t.DOM_DELTA_LINE:
            i *= 32, n *= 32;
        }
        if (0 !== n && this.$.handleScale.mouseWheel) {
          var s = Math.sign(n) * Math.min(1, Math.abs(n)),
            h = t.clientX - this.Au.getBoundingClientRect().left;
          this.model().zoomTime(h, s);
        }
        0 !== i && this.$.handleScroll.mouseWheel && this.model().scrollChart(-80 * i);
      }
    }, t.prototype.ie = function (t) {
      var i = t.fullInvalidation();
      if (3 === i && this.se(), 3 === i || 2 === i) {
        for (var n = this.F.panes(), s = 0; s < n.length; s++) t.invalidateForPane(s).autoScale && n[s].momentaryAutoScale();
        t.getFitContent() && this.F.timeScale().fitContent();
        var h = t.getTargetTimeRange();
        null !== h && this.F.timeScale().setTimePointsRange(h), this.Ju.update();
      }
      this.paint(t);
    }, t.prototype.fh = function (t) {
      var i = this;
      null !== this.Yu ? this.Yu.merge(t) : this.Yu = t, this.Ku || (this.Ku = !0, this.qu = window.requestAnimationFrame(function () {
        i.Ku = !1, i.qu = 0, null !== i.Yu && (i.ie(i.Yu), i.Yu = null);
      }));
    }, t.prototype.se = function () {
      this.Gu();
    }, t.prototype.te = function (t) {
      this.$u.removeChild(t.getElement()), t.destroy();
    }, t.prototype.Gu = function () {
      for (var t = this.F.panes(), i = t.length, n = this.Wu.length, s = i; s < n; s++) {
        var h = a(this.Wu.pop());
        this.$u.removeChild(h.getElement()), h.clicked().unsubscribeAll(this), h.destroy(), void 0 !== (r = this.Uu.pop()) && this.te(r);
      }
      for (s = n; s < i; s++) {
        if ((h = new qn(this, t[s])).clicked().subscribe(this.he.bind(this), this), this.Wu.push(h), s > 1) {
          var r = new Pn(this, s - 1, s, !0);
          this.Uu.push(r), this.$u.insertBefore(r.getElement(), this.Ju.getElement());
        }
        this.$u.insertBefore(h.getElement(), this.Ju.getElement());
      }
      for (s = 0; s < i; s++) {
        var u = t[s];
        (h = this.Wu[s]).state() !== u ? h.setState(u) : h.updatePriceAxisWidget();
      }
      this.Qu(), this.ne();
    }, t.prototype.ue = function (t, i) {
      var n,
        s = new Map();
      null !== t && this.F.serieses().forEach(function (i) {
        var n = i.dataAt(t);
        null !== n && s.set(i, n);
      });
      if (null !== t) {
        var h = this.F.timeScale().indexToUserTime(t);
        null !== h && (n = h);
      }
      var r = this.model().hoveredSource(),
        u = null !== r && r.source instanceof Ci ? r.source : void 0,
        e = null !== r && void 0 !== r.object ? r.object.externalId : void 0;
      return {
        time: n,
        point: i || void 0,
        hoveredSeries: u,
        seriesPrices: s,
        hoveredObject: e
      };
    }, t.prototype.he = function (t, i) {
      var n = this;
      this.Jr.fire(function () {
        return n.ue(t, i);
      });
    }, t.prototype.Zu = function (t, i) {
      var n = this;
      this.oh.fire(function () {
        return n.ue(t, i);
      });
    }, t.prototype.Qu = function () {
      var t = this.$.timeScale.visible ? "" : "none";
      this.Ju.getElement().style.display = t;
    }, t;
  }();
function $n(t) {
  if (!Fi(t)) throw new Error("time must be of type BusinessDay");
  var i = new Date(Date.UTC(t.year, t.month - 1, t.day, 0, 0, 0, 0));
  return {
    timestamp: Math.round(i.getTime() / 1e3),
    businessDay: t
  };
}
function _n(t) {
  if (!Pi(t)) throw new Error("time must be of type isUTCTimestamp");
  return {
    timestamp: t
  };
}
function Xn(t) {
  return 0 === t.length ? null : Fi(t[0].time) ? $n : _n;
}
function Zn(t) {
  return Pi(t) ? _n(t) : Fi(t) ? $n(t) : $n(es(t));
}
function Jn(t, i) {
  var n = t.value,
    s = null;
  return "color" in t && void 0 !== t.color && (s = i.addColor(t.color)), [n, n, n, n, s];
}
function Gn(t, i) {
  return [t.open, t.high, t.low, t.close, null];
}
var Qn = {
  Candlestick: Gn,
  Bar: Gn,
  Area: Jn,
  Histogram: Jn,
  Line: Jn
};
function ts(t) {
  return Qn[t];
}
function is(t) {
  return 60 * t * 60 * 1e3;
}
function ns(t) {
  return 60 * t * 1e3;
}
var ss,
  hs = [{
    divisor: 1,
    span: 20
  }, {
    divisor: (ss = 1, 1e3 * ss),
    span: 19
  }, {
    divisor: ns(1),
    span: 20
  }, {
    divisor: ns(5),
    span: 21
  }, {
    divisor: ns(30),
    span: 22
  }, {
    divisor: is(1),
    span: 30
  }, {
    divisor: is(3),
    span: 31
  }, {
    divisor: is(6),
    span: 32
  }, {
    divisor: is(12),
    span: 33
  }];
function rs(t, i) {
  if (null !== i) {
    var n = new Date(1e3 * i.timestamp),
      s = new Date(1e3 * t.timestamp);
    if (s.getUTCFullYear() !== n.getUTCFullYear()) return 70;
    if (s.getUTCMonth() !== n.getUTCMonth()) return 60;
    if (s.getUTCDate() !== n.getUTCDate()) return 50;
    for (var h = hs.length - 1; h >= 0; --h) if (Math.floor(n.getTime() / hs[h].divisor) !== Math.floor(s.getTime() / hs[h].divisor)) return hs[h].span;
  }
  return 20;
}
function us(t, i) {
  return t.timestamp < i.timestamp;
}
function es(t) {
  var i = new Date(t);
  if (isNaN(i.getTime())) throw new Error("Invalid date string=" + t + ", expected format=yyyy-mm-dd");
  return {
    day: i.getUTCDate(),
    month: i.getUTCMonth() + 1,
    year: i.getUTCFullYear()
  };
}
function os(t) {
  w(t.time) && (t.time = es(t.time));
}
var fs,
  as = function () {
    function t() {
      this.ee = new Map(), this.oe = new Map(), this.fe = [];
    }
    return t.prototype.destroy = function () {
      this.ee.clear(), this.oe.clear(), this.fe = [];
    }, t.prototype.setSeriesData = function (t, i) {
      var n = this;
      t.clearData(), function (t) {
        t.forEach(os);
      }(i), this.ee.forEach(function (i) {
        return i.mapping.delete(t);
      });
      var s = Xn(i);
      null !== s && i.forEach(function (i) {
        var h = s(i.time),
          r = n.ee.get(h.timestamp) || {
            index: 0,
            mapping: new Map(),
            timePoint: h
          };
        r.mapping.set(t, i), n.ee.set(h.timestamp, r);
      });
      var h = new Map();
      return this.ee.forEach(function (t, i) {
        t.mapping.size > 0 && h.set(i, t);
      }), this.ae(h);
    }, t.prototype.removeSeries = function (t) {
      return this.setSeriesData(t, []);
    }, t.prototype.updateSeriesData = function (t, i) {
      os(i);
      var n = t.data().bars();
      if (n.size() > 0) if (void 0 !== c(n.last()).time.businessDay) {
        if (!Fi(i.time)) throw new Error("time must be of type BusinessDay");
      } else if (!Pi(i.time)) throw new Error("time must be of type isUTCTimestamp");
      var s = c(Xn([i]))(i.time),
        h = this.ee.get(s.timestamp) || {
          index: 0,
          mapping: new Map(),
          timePoint: s
        },
        r = 0 === h.mapping.size;
      h.mapping.set(t, i);
      var u = !1;
      if (r) {
        var e = this.ee.size;
        this.fe.length > 0 && this.fe[this.fe.length - 1].timestamp > s.timestamp ? (e = Ct(this.fe, s, us), this.fe.splice(e, 0, s), this.ce(e), u = !0) : this.fe.push(s), h.index = e, this.oe.set(h.index, s);
      }
      this.ee.set(s.timestamp, h);
      var o = new Map(),
        f = function f(i) {
          var n = a(l.oe.get(i));
          a(l.ee.get(n.timestamp)).mapping.forEach(function (s, h) {
            if (u || h === t) {
              var r = ts(h.seriesType()),
                e = o.get(h) || {
                  update: []
                },
                f = {
                  index: i,
                  time: n,
                  value: r(s, h.palette())
                };
              e.update.push(f), o.set(h, e);
            }
          });
        },
        l = this;
      for (e = h.index; e < this.ee.size; ++e) f(e);
      var v = r ? this.le(h.index) : [],
        d = r ? this.fe.slice(h.index) : [];
      return {
        timeScaleUpdate: {
          seriesUpdates: o,
          changes: d,
          index: h.index,
          marks: v
        }
      };
    }, t.prototype.ae = function (t) {
      var i = this;
      this.ee = t, this.fe = Array.from(this.ee.values()).map(function (t) {
        return t.timePoint;
      }), this.fe.sort(function (t, i) {
        return t.timestamp - i.timestamp;
      });
      var n = new Map();
      this.fe.forEach(function (t, s) {
        var h = a(i.ee.get(t.timestamp));
        h.index = s, h.mapping.forEach(function (i, h) {
          var r = ts(h.seriesType()),
            u = n.get(h) || {
              update: []
            },
            e = {
              index: s,
              time: t,
              value: r(i, h.palette())
            };
          u.update.push(e), n.set(h, u);
        });
      });
      var s = null,
        h = this.fe.map(function (t, i) {
          var n = rs(t, s);
          return s = t, {
            span: n,
            time: t,
            index: i
          };
        }),
        r = {
          seriesUpdates: n,
          changes: this.fe.slice(),
          index: 0,
          marks: h
        };
      return this.ve(), {
        timeScaleUpdate: r
      };
    }, t.prototype.ce = function (t) {
      for (var i = this.oe.size - 1; i >= t; --i) {
        var n = a(this.oe.get(i)),
          s = i + 1;
        a(this.ee.get(n.timestamp)).index = s, this.oe.delete(i), this.oe.set(s, n);
      }
    }, t.prototype.ve = function () {
      var t = this;
      this.oe.clear(), this.ee.forEach(function (i, n) {
        t.oe.set(i.index, i.timePoint);
      });
    }, t.prototype.le = function (t) {
      for (var i = [], n = this.oe.get(t - 1) || null, s = t; s < this.oe.size; ++s) {
        var h = a(this.oe.get(s)),
          r = rs(h, n);
        n = h, i.push({
          span: r,
          time: h,
          index: s
        });
      }
      return i;
    }, t;
  }(),
  cs = {
    color: "#FF0000",
    price: 0,
    lineStyle: 2,
    lineWidth: 1,
    axisLabelVisible: !0
  },
  ls = function () {
    function t(t) {
      this.ii = t;
    }
    return t.prototype.applyOptions = function (t) {
      this.ii.applyOptions(t);
    }, t.prototype.options = function () {
      return this.ii.options();
    }, t.prototype.priceLine = function () {
      return this.ii;
    }, t;
  }(),
  vs = function () {
    function t(t, i) {
      this._series = t, this._dataUpdatesConsumer = i;
    }
    return t.prototype.destroy = function () {
      delete this._series, delete this._dataUpdatesConsumer;
    }, t.prototype.priceFormatter = function () {
      return this._series.formatter();
    }, t.prototype.series = function () {
      return this._series;
    }, t.prototype.priceToCoordinate = function (t) {
      var i = this._series.firstValue();
      return null === i ? null : this._series.priceScale().priceToCoordinate(t, i.value);
    }, t.prototype.coordinateToPrice = function (t) {
      var i = this._series.firstValue();
      return null === i ? null : this._series.priceScale().coordinateToPrice(t, i.value);
    }, t.prototype.setData = function (t) {
      this._dataUpdatesConsumer.applyNewData(this._series, t);
    }, t.prototype.update = function (t) {
      this._dataUpdatesConsumer.updateData(this._series, t);
    }, t.prototype.setMarkers = function (t) {
      var i = t.map(function (t) {
        return _e(_e({}, t), {
          time: Zn(t.time)
        });
      });
      this._series.setMarkers(i);
    }, t.prototype.applyOptions = function (t) {
      this._series.applyOptions(t);
    }, t.prototype.options = function () {
      return p(this._series.options());
    }, t.prototype.createPriceLine = function (t) {
      var i = v(p(cs), t),
        n = this._series.createPriceLine(i);
      return new ls(n);
    }, t.prototype.removePriceLine = function (t) {
      this._series.removePriceLine(t.priceLine());
    }, t;
  }(),
  ds = function (t) {
    function i() {
      return null !== t && t.apply(this, arguments) || this;
    }
    return u(i, t), i.prototype.applyOptions = function (i) {
      Vi(i), t.prototype.applyOptions.call(this, i);
    }, i;
  }(vs),
  Ms = {
    width: 0,
    height: 0,
    layout: {
      backgroundColor: "#FFFFFF",
      textColor: "#191919",
      fontSize: 11,
      fontFamily: "'Trebuchet MS', Roboto, Ubuntu, sans-serif"
    },
    crosshair: {
      vertLine: {
        color: "#758696",
        width: 1,
        style: 3,
        visible: !0,
        labelVisible: !0,
        labelBackgroundColor: "#4c525e"
      },
      horzLine: {
        color: "#758696",
        width: 1,
        style: 3,
        visible: !0,
        labelVisible: !0,
        labelBackgroundColor: "#4c525e"
      },
      mode: 1
    },
    grid: {
      vertLines: {
        color: "#D6DCDE",
        style: 0,
        visible: !0
      },
      horzLines: {
        color: "#D6DCDE",
        style: 0,
        visible: !0
      }
    },
    priceScale: {
      autoScale: !0,
      mode: 0,
      invertScale: !1,
      alignLabels: !0,
      position: "right",
      borderVisible: !0,
      borderColor: "#2B2B43",
      entireTextOnly: !1,
      scaleMargins: {
        bottom: .1,
        top: .2
      }
    },
    timeScale: {
      rightOffset: 0,
      barSpacing: 6,
      fixLeftEdge: !1,
      lockVisibleTimeRangeOnResize: !1,
      rightBarStaysOnScroll: !1,
      borderVisible: !0,
      borderColor: "#2B2B43",
      visible: !0,
      timeVisible: !1,
      secondsVisible: !0
    },
    watermark: {
      color: "rgba(0, 0, 0, 0)",
      visible: !1,
      fontSize: 48,
      text: "",
      horzAlign: "center",
      vertAlign: "center"
    },
    localization: {
      locale: navigator.language,
      dateFormat: "dd MMM 'yy"
    },
    handleScroll: {
      mouseWheel: !0,
      pressedMouseMove: !0,
      horzTouchDrag: !0,
      vertTouchDrag: !0
    },
    handleScale: {
      axisPressedMouseMove: !0,
      axisDoubleClickReset: !0,
      mouseWheel: !0,
      pinch: !0
    }
  },
  ws = {
    upColor: "#26a69a",
    downColor: "#ef5350",
    wickVisible: !0,
    borderVisible: !0,
    borderColor: "#378658",
    borderUpColor: "#26a69a",
    borderDownColor: "#ef5350",
    wickColor: "#737375",
    wickUpColor: "#26a69a",
    wickDownColor: "#ef5350"
  },
  bs = {
    upColor: "#26a69a",
    downColor: "#ef5350",
    openVisible: !0,
    thinBars: !0
  },
  ms = {
    color: "#2196f3",
    lineStyle: 0,
    lineWidth: 3,
    lineType: 0,
    crosshairMarkerVisible: !0,
    crosshairMarkerRadius: 4
  },
  ps = {
    topColor: "rgba( 46, 220, 135, 0.4)",
    bottomColor: "rgba( 40, 221, 100, 0)",
    lineColor: "#33D778",
    lineStyle: 0,
    lineWidth: 3,
    lineType: 0,
    crosshairMarkerVisible: !0,
    crosshairMarkerRadius: 4
  },
  gs = {
    color: "#26a69a",
    base: 0
  },
  ys = {
    title: "",
    lastValueVisible: !0,
    priceLineVisible: !0,
    priceLineSource: 0,
    priceLineWidth: 1,
    priceLineColor: "",
    priceLineStyle: 2,
    baseLineVisible: !0,
    baseLineWidth: 1,
    baseLineColor: "#B2B5BE",
    baseLineStyle: 0,
    priceFormat: {
      type: "price",
      precision: 2,
      minMove: .01
    }
  },
  ks = function () {
    function t(t) {
      this.l = t;
    }
    return t.prototype.destroy = function () {
      delete this.l;
    }, t.prototype.applyOptions = function (t) {
      this.l.applyOptions({
        priceScale: t
      });
    }, t.prototype.options = function () {
      return this.B().options();
    }, t.prototype.B = function () {
      return this.l.mainPriceScale();
    }, t;
  }();
!function (t) {
  t[t.AnimationDurationMs = 1e3] = "AnimationDurationMs";
}(fs || (fs = {}));
var Ns = function () {
  function t(t) {
    this.F = t;
  }
  return t.prototype.destroy = function () {
    delete this.F;
  }, t.prototype.scrollPosition = function () {
    return this.$n().rightOffset();
  }, t.prototype.scrollToPosition = function (t, i) {
    i ? this.$n().scrollToOffsetAnimated(t, 1e3) : this.$n().setRightOffset(t);
  }, t.prototype.scrollToRealTime = function () {
    this.$n().scrollToRealTime();
  }, t.prototype.getVisibleRange = function () {
    var t = this.$n().visibleBars();
    if (null === t) return null;
    var i = this.F.timeScale().points(),
      n = c(i.firstIndex()),
      s = c(i.lastIndex());
    return {
      from: Ss(c(i.valueAt(Math.max(n, t.firstBar())))),
      to: Ss(c(i.valueAt(Math.min(s, t.lastBar()))))
    };
  }, t.prototype.setVisibleRange = function (t) {
    var i = {
      from: Zn(t.from),
      to: Zn(t.to)
    };
    this.F.setTargetTimeRange(i);
  }, t.prototype.resetTimeScale = function () {
    this.F.resetTimeScale();
  }, t.prototype.fitContent = function () {
    this.F.fitContent();
  }, t.prototype.applyOptions = function (t) {
    this.$n().applyOptions(t);
  }, t.prototype.options = function () {
    return p(this.$n().options());
  }, t.prototype.$n = function () {
    return this.F.timeScale();
  }, t;
}();
function Ss(t) {
  return t.businessDay || t.timestamp;
}
function xs(t) {
  if (void 0 !== t && "custom" !== t.type) {
    var i = t;
    void 0 !== i.minMove && void 0 === i.precision && (i.precision = function (t) {
      if (t >= 1) return 0;
      for (var i = 0; i < 8; i++) {
        var n = Math.round(t);
        if (Math.abs(n - t) < 1e-8) return i;
        t *= 10;
      }
      return i;
    }(i.minMove));
  }
}
function Ds(t) {
  var i = t.handleScale;
  m(i) && (t.handleScale = {
    axisDoubleClickReset: i,
    axisPressedMouseMove: i,
    mouseWheel: i,
    pinch: i
  });
  var n = t.handleScroll;
  return m(n) && (t.handleScroll = {
    horzTouchDrag: n,
    vertTouchDrag: n,
    mouseWheel: n,
    pressedMouseMove: n
  }), t;
}
var Cs = function () {
  function t(t, i) {
    var n = this;
    this.de = new as(), this.Me = new rt(), this.we = new Map(), this.be = new Map(), this.me = new rt(), this.pe = new rt();
    var s = void 0 === i ? p(Ms) : v(p(Ms), Ds(i));
    this.ur = new Kn(t, s), this.ur.model().timeScale().visibleBarsChanged().subscribe(this.ge.bind(this)), this.ur.clicked().subscribe(function (t) {
      n.me.hasListeners() && n.me.fire(n.ye(t()));
    }, this), this.ur.crosshairMoved().subscribe(function (t) {
      n.pe.hasListeners() && n.pe.fire(n.ye(t()));
    }, this);
    var h = this.ur.model();
    this.ke = new ks(h), this.Ne = new Ns(h);
  }
  return t.prototype.remove = function () {
    this.ur.model().timeScale().visibleBarsChanged().unsubscribeAll(this), this.ur.clicked().unsubscribeAll(this), this.ur.crosshairMoved().unsubscribeAll(this), this.ke.destroy(), this.Ne.destroy(), this.ur.destroy(), delete this.ur, this.we.forEach(function (t, i) {
      i.destroy();
    }), this.we.clear(), this.be.clear(), this.Me.destroy(), this.me.destroy(), this.pe.destroy(), this.de.destroy(), delete this.de;
  }, t.prototype.resize = function (t, i, n) {
    this.ur.resize(t, i, n);
  }, t.prototype.addAreaSeries = function (t) {
    void 0 === t && (t = {}), xs(t.priceFormat);
    var i = v(p(ys), ps, t),
      n = this.ur.model().createSeries("Area", i),
      s = new vs(n, this);
    return this.we.set(s, n), this.be.set(n, s), s;
  }, t.prototype.addBarSeries = function (t) {
    void 0 === t && (t = {}), xs(t.priceFormat);
    var i = v(p(ys), bs, t),
      n = this.ur.model().createSeries("Bar", i),
      s = new vs(n, this);
    return this.we.set(s, n), this.be.set(n, s), s;
  }, t.prototype.addCandlestickSeries = function (t) {
    void 0 === t && (t = {}), Vi(t), xs(t.priceFormat);
    var i = v(p(ys), ws, t),
      n = this.ur.model().createSeries("Candlestick", i),
      s = new ds(n, this);
    return this.we.set(s, n), this.be.set(n, s), s;
  }, t.prototype.addHistogramSeries = function (t) {
    void 0 === t && (t = {}), xs(t.priceFormat);
    var i = v(p(ys), gs, t),
      n = this.ur.model().createSeries("Histogram", i),
      s = new vs(n, this);
    return this.we.set(s, n), this.be.set(n, s), s;
  }, t.prototype.addLineSeries = function (t) {
    void 0 === t && (t = {}), xs(t.priceFormat);
    var i = v(p(ys), ms, t),
      n = this.ur.model().createSeries("Line", i),
      s = new vs(n, this);
    return this.we.set(s, n), this.be.set(n, s), s;
  }, t.prototype.removeSeries = function (t) {
    var i = t,
      n = a(this.we.get(i)),
      s = this.de.removeSeries(n),
      h = this.ur.model();
    h.removeSeries(n);
    var r = s.timeScaleUpdate;
    h.updateTimeScale(r.index, r.changes, r.marks, !0), r.seriesUpdates.forEach(function (t, i) {
      i.updateData(t.update);
    }), h.updateTimeScaleBaseIndex(0), this.we.delete(i), this.be.delete(n);
  }, t.prototype.applyNewData = function (t, i) {
    var n = this.de.setSeriesData(t, i),
      s = this.ur.model(),
      h = n.timeScaleUpdate;
    s.updateTimeScale(h.index, h.changes, h.marks, !0), h.seriesUpdates.forEach(function (t, i) {
      i.updateData(t.update, !0);
    }), s.updateTimeScaleBaseIndex(0);
  }, t.prototype.updateData = function (t, i) {
    var n = this.de.updateSeriesData(t, i),
      s = this.ur.model(),
      h = n.timeScaleUpdate;
    s.updateTimeScale(h.index, h.changes, h.marks, !1), h.seriesUpdates.forEach(function (t, i) {
      i.updateData(t.update);
    }), s.updateTimeScaleBaseIndex(0);
  }, t.prototype.subscribeClick = function (t) {
    this.me.subscribe(t);
  }, t.prototype.unsubscribeClick = function (t) {
    this.me.unsubscribe(t);
  }, t.prototype.subscribeCrosshairMove = function (t) {
    this.pe.subscribe(t);
  }, t.prototype.unsubscribeCrosshairMove = function (t) {
    this.pe.unsubscribe(t);
  }, t.prototype.subscribeVisibleTimeRangeChange = function (t) {
    this.Me.subscribe(t);
  }, t.prototype.unsubscribeVisibleTimeRangeChange = function (t) {
    this.Me.unsubscribe(t);
  }, t.prototype.priceScale = function () {
    return this.ke;
  }, t.prototype.timeScale = function () {
    return this.Ne;
  }, t.prototype.applyOptions = function (t) {
    this.ur.applyOptions(Ds(t));
  }, t.prototype.options = function () {
    return this.ur.options();
  }, t.prototype.takeScreenshot = function () {
    return this.ur.takeScreenshot();
  }, t.prototype.ge = function () {
    this.Me.hasListeners() && this.Me.fire(this.timeScale().getVisibleRange());
  }, t.prototype.Se = function (t) {
    return a(this.be.get(t));
  }, t.prototype.ye = function (t) {
    var i = this,
      n = new Map();
    t.seriesPrices.forEach(function (t, s) {
      n.set(i.Se(s), t);
    });
    var s = void 0 === t.hoveredSeries ? void 0 : this.Se(t.hoveredSeries);
    return {
      time: t.time && (t.time.businessDay || t.time.timestamp),
      point: t.point,
      hoveredSeries: s,
      hoveredMarkerId: t.hoveredObject,
      seriesPrices: n
    };
  }, t;
}();
function Ts(t, i) {
  var n = c(w(t) ? document.getElementById(t) : t);
  return new Cs(n, i);
}
function Es() {
  return "2.0.0";
}
export { H as CrosshairMode, n as LineStyle, i as LineType, Li as PriceLineSource, xi as PriceScaleMode, Ts as createChart, Fi as isBusinessDay, Pi as isUTCTimestamp, Es as version };